/* eslint-disable */
/* tslint:disable */
import { disableFragmentWarnings } from '@apollo/client';
disableFragmentWarnings();
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    DateTime: any;
    Json: any;
    Number: any;
    QueryArgument: any;
};

/**
 *   An Accommodation is a representation of a location which can contain one or more RentalUnits.
 *  For example: a hotel would be represented by an Accommodation with each room type represented by a separate RentalUnit.
 */
export type Accommodation = {
    __typename?: 'Accommodation';
    /**   The address where this Accommodation is located. */
    address: Address;
    /**   The attributes assigned to this Accommodation, organized into categories. */
    attributeCategories: Array<AttributeCategory>;
    /**   Indicates the Travelbase brand this Accommodation belongs to (used on aggregate sites). */
    brand: Scalars['String'];
    /**
     *   The time at which check-in closes.
     *  Formatted as HH:MM.
     */
    checkInEndTime: Scalars['String'];
    /**
     *   The time at which check-in opens.
     *  Formatted as HH:MM.
     */
    checkInStartTime: Scalars['String'];
    /**
     *   The time before which guests have to check out.
     *  Formatted as HH:MM.
     */
    checkOutTime: Scalars['String'];
    collapseInSearch: Scalars['Boolean'];
    /**   The GPS coordinates of this Accommodation. */
    coordinates: LatLon;
    /**
     *   A general description of the Accommodation.
     *  This value is language dependent.
     */
    descriptionGeneral?: Maybe<Scalars['String']>;
    /**
     *   A description of the location this Accommodation is in.
     *  This value is language dependent.
     */
    descriptionLocation: Scalars['String'];
    /**   Indicates whether this Accommodation should have it's own page on the website, otherwise only the pages of the underlying RentalUnits exist. */
    hasPublicPage: Scalars['Boolean'];
    /**   Unique ID representing this Accommodation. */
    id: Scalars['ID'];
    /**   Image gallery for the Accommodation. */
    images: Array<AccommodationImage>;
    /**   The main (hero) image for the Accommodation. */
    mainImage?: Maybe<GenericImage>;
    /**   The highest max occupancy of all the rental units within the accommodation */
    maxOccupancy?: Maybe<Scalars['Int']>;
    /**   The name of the Accommodation. */
    name: Scalars['String'];
    /**   An avatar image for the Accommodation's owner. */
    ownerImage?: Maybe<GenericImage>;
    /**
     *   A short descriptive text about the Accommodation's owner.
     *  This value is language dependent.
     */
    ownerIntroduction?: Maybe<Scalars['String']>;
    /**   The name of the Accommodation's owner. */
    ownerName?: Maybe<Scalars['String']>;
    /**
     *   A text containing tips for visitors from the Accommodation's owner.
     *  This value is language dependent.
     */
    ownerTips?: Maybe<Scalars['String']>;
    /**   The name of the Place this Accommodation is located in. */
    place: Scalars['String'];
    /**   Distances to POI's. */
    pointsOfInterest: Array<PointOfInterest>;
    /**   Public email address for reservations. */
    publicReservationsEmail?: Maybe<Scalars['String']>;
    /**   Public phone number for reservations. */
    publicReservationsPhoneNumber?: Maybe<Scalars['String']>;
    /**   Public URL for reservations. */
    publicReservationsWebsiteUrl?: Maybe<Scalars['String']>;
    /**   List the RentalUnits within this Accommodation. */
    rentalUnits: Array<RentalUnit>;
    /**   Search the RentalUnits within this Accommodation. */
    searchRentalUnits: UnitSearchResult;
    /**   Show partner information in review component */
    showPartnerInformation?: Maybe<Scalars['Boolean']>;
    /**   Unique slug to represent this Accommodation, most commonly in URLs. */
    slug: Scalars['String'];
    /**   The type of this Accommodation. */
    type: AccommodationTypeEnum;
};

/**
 *   An Accommodation is a representation of a location which can contain one or more RentalUnits.
 *  For example: a hotel would be represented by an Accommodation with each room type represented by a separate RentalUnit.
 */
export type AccommodationSearchRentalUnitsArgs = {
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    params?: InputMaybe<UnitSearchParamsInput>;
};

/**   An image file available through a CDN URL. */
export type AccommodationImage = Image & {
    __typename?: 'AccommodationImage';
    /**   The category assigned to this Image. */
    category: AccommodationImageCategoryEnum;
    /**
     *   A version of the original image transformed to specific parameters.
     *  Note that the available transform options are dependent on the type of image.
     */
    transform?: Maybe<ImageTransform>;
};

/**   An image file available through a CDN URL. */
export type AccommodationImageTransformArgs = {
    config: ImageTransformConfigEnum;
    format: ImageTransformFormatEnum;
};

/**   Categories for AccommodationImages, describing what the image displays. */
export enum AccommodationImageCategoryEnum {
    Bathroom = 'BATHROOM',
    Bedroom = 'BEDROOM',
    Entrance = 'ENTRANCE',
    Facilities = 'FACILITIES',
    FloorPlan = 'FLOOR_PLAN',
    Front = 'FRONT',
    Kitchen = 'KITCHEN',
    LivingRoom = 'LIVING_ROOM',
    Other = 'OTHER',
    Outdoor = 'OUTDOOR',
    Surroundings = 'SURROUNDINGS',
    View = 'VIEW',
}

/**   Types of Accommodation. */
export enum AccommodationTypeEnum {
    ApartmentBlock = 'APARTMENT_BLOCK',
    BedAndBreakfast = 'BED_AND_BREAKFAST',
    BungalowPark = 'BUNGALOW_PARK',
    Camping = 'CAMPING',
    Hotel = 'HOTEL',
    Location = 'LOCATION',
}

export type Activity = {
    __typename?: 'Activity';
    /**   A summary of the activityReviews for this Activity. */
    activityReviewStats?: Maybe<ActivityReviewStats>;
    /**   The Activityreviews submitted by past guests for this activity. */
    activityReviews: Array<ActivityReview>;
    bookingType: ActivityBookingTypesEnum;
    company?: Maybe<Company>;
    coordinates?: Maybe<LatLon>;
    /**   This value is language dependent. */
    description?: Maybe<Scalars['String']>;
    /**   This value is language dependent. */
    descriptionLocation?: Maybe<Scalars['String']>;
    /**   This value is language dependent. */
    descriptionParticulars?: Maybe<Scalars['String']>;
    externalBookingUrl?: Maybe<Scalars['String']>;
    externalInfoUrl?: Maybe<Scalars['String']>;
    highlighted: Scalars['Boolean'];
    id: Scalars['ID'];
    images: Array<ActivityImage>;
    listImage?: Maybe<GenericImage>;
    /**   The address where this Activity is located. */
    locationAddress?: Maybe<Address>;
    mainImage?: Maybe<GenericImage>;
    maxCapacity?: Maybe<Scalars['Int']>;
    minCapacity?: Maybe<Scalars['Int']>;
    /**   This value is language dependent. */
    name: Scalars['String'];
    place?: Maybe<Scalars['String']>;
    slug: Scalars['String'];
    targetAudiences: Array<TargetAudienceEnum>;
    themes: Array<ActivityTheme>;
    /** @deprecated Now handled by bookingType of Agreement */
    ticketSalesEnabled: Scalars['Boolean'];
    timeslots: Array<Timeslot>;
    videoUrl?: Maybe<Scalars['String']>;
};

export type ActivityActivityReviewsArgs = {
    limit: Scalars['Int'];
    offset?: InputMaybe<Scalars['Int']>;
};

export type ActivityTimeslotsArgs = {
    endDate: Scalars['String'];
    startDate: Scalars['String'];
};

/**   Activity booking types */
export enum ActivityBookingTypesEnum {
    /**  Activity is directly bookable */
    Direct = 'DIRECT',
    /**  Activity is externally bookable */
    External = 'EXTERNAL',
    /**  activity is not bookable */
    NotBookable = 'NOT_BOOKABLE',
}

/**   An image file available through a CDN URL. */
export type ActivityImage = Image & {
    __typename?: 'ActivityImage';
    /**
     *   A version of the original image transformed to specific parameters.
     *  Note that the available transform options are dependent on the type of image.
     */
    transform?: Maybe<ImageTransform>;
};

/**   An image file available through a CDN URL. */
export type ActivityImageTransformArgs = {
    config: ImageTransformConfigEnum;
    format: ImageTransformFormatEnum;
};

export type ActivityRateGroup = {
    __typename?: 'ActivityRateGroup';
    /** @deprecated Now handled by bookingType of Agreement */
    canBuyTickets: Scalars['Boolean'];
    rates: Array<Rate>;
    releaseHours?: Maybe<Scalars['Int']>;
};

/**   A review of a Activity submitted by a Customer. */
export type ActivityReview = {
    __typename?: 'ActivityReview';
    /**   The average of the specific ratings given. */
    average: Scalars['Float'];
    /**   The city the Customer is from. */
    city?: Maybe<Scalars['String']>;
    /**   The main text submitted by the Customer. */
    comment: Scalars['String'];
    /**
     *   The date this ActivityReview was submitted.
     *  Formatted as yyyy-mm-dd.
     */
    date: Scalars['String'];
    /**   Unique ID representing this ActivityReview. */
    id: Scalars['ID'];
    /**
     *   The language in which this Review was written.
     *  This is a 2-letter language code.
     */
    language?: Maybe<Scalars['String']>;
    /**   Rating (1-10) of the location of the Activity. */
    ratingActivity?: Maybe<Scalars['Int']>;
    /**   Rating (1-10) of the hospitality provided. */
    ratingHospitality?: Maybe<Scalars['Int']>;
    /**   Rating (1-10) of value for money. */
    ratingValueForMoney?: Maybe<Scalars['Int']>;
    /**   The reply to this ActivityReview submitted by the Partner, if any. */
    reply?: Maybe<Scalars['String']>;
    /**
     *   Tips the Customer submitted for the Partner, if any.
     *  This field is not publicly visible, only logged in Customers can see this for the ActivityReviews they submitted themselves.
     */
    tips?: Maybe<Scalars['String']>;
    /**   The title/short summary the Customer submitted. */
    title: Scalars['String'];
};

/**   Summary of the ActivityReviews submitted. */
export type ActivityReviewStats = {
    __typename?: 'ActivityReviewStats';
    /**   The average of the `activity` ratings across all ActivityReviews. */
    activity: Scalars['Float'];
    /**   The average of all ratings across all ActivityReviews. */
    average: Scalars['Float'];
    /**   Amount of ActivityReviews available. */
    count: Scalars['Int'];
    /**   The average of the `hospitality` ratings across all ActivityReviews. */
    hospitality: Scalars['Float'];
    /**   The average of the `valueForMoney` ratings across all ActivityReviews. */
    valueForMoney: Scalars['Float'];
};

/**   Activity search result ordering options. */
export enum ActivitySearchOrderEnum {
    /**
     *  Randomize order.
     * # The random seed used is the current date, so the order will be identical between pageloads and between users, but change daily.
     */
    Random = 'RANDOM',
    /**  Sort by average Activity review rating, descending. */
    ReviewRatingDesc = 'REVIEW_RATING_DESC',
    /**  Order by first available Timeslot. */
    TimeslotsAsc = 'TIMESLOTS_ASC',
}

export type ActivitySearchParamsInput = {
    companyId?: InputMaybe<Scalars['ID']>;
    /**   Formatted as yyyy-mm-dd, inclusive */
    endDate?: InputMaybe<Scalars['String']>;
    highlighted?: InputMaybe<Scalars['Boolean']>;
    placeId?: InputMaybe<Scalars['ID']>;
    rating?: InputMaybe<Scalars['Float']>;
    /**   Formatted as yyyy-mm-dd */
    startDate?: InputMaybe<Scalars['String']>;
    targetAudiences?: InputMaybe<Array<TargetAudienceEnum>>;
    themeSlugs?: InputMaybe<Array<Scalars['String']>>;
};

export type ActivitySearchResult = {
    __typename?: 'ActivitySearchResult';
    hits: Array<Activity>;
    placeCounts: Array<GenericAggregationCount>;
    targetAudienceCount: Array<TargetAudienceAggregationCount>;
    themeCounts: Array<GenericAggregationCount>;
    totalHits: Scalars['Int'];
};

export type ActivityTheme = {
    __typename?: 'ActivityTheme';
    id: Scalars['ID'];
    /**   This value is language dependent. */
    name?: Maybe<Scalars['String']>;
    position: Scalars['Int'];
    slug: Scalars['String'];
};

export type AddFavoriteActivityInput = {
    activityId: Scalars['ID'];
};

export type AddFavoriteActivityPayload = {
    __typename?: 'AddFavoriteActivityPayload';
    favorite?: Maybe<FavoriteActivity>;
};

export type AddFavoriteCompanyInput = {
    companyId: Scalars['ID'];
};

export type AddFavoriteCompanyPayload = {
    __typename?: 'AddFavoriteCompanyPayload';
    favorite?: Maybe<FavoriteCompany>;
};

export type AddFavoriteRentalUnitInput = {
    rentalUnitId: Scalars['ID'];
};

export type AddFavoriteRentalUnitPayload = {
    __typename?: 'AddFavoriteRentalUnitPayload';
    favorite?: Maybe<FavoriteRentalUnit>;
};

export type Address = AddressInterface &
    ElementInterface & {
        __typename?: 'Address';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** First line of the address */
        addressLine1?: Maybe<Scalars['String']>;
        /** Second line of the address */
        addressLine2?: Maybe<Scalars['String']>;
        /** Third line of the address */
        addressLine3?: Maybe<Scalars['String']>;
        /** Administrative area. */
        administrativeArea?: Maybe<Scalars['String']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        city?: Maybe<Scalars['String']>;
        /** Two-letter country code */
        countryCode: Scalars['String'];
        countryISOCode?: Maybe<Scalars['String']>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Dependent locality */
        dependentLocality?: Maybe<Scalars['String']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The first name on the address. */
        firstName?: Maybe<Scalars['String']>;
        /** The full name on the address. */
        fullName?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The last name on the address. */
        lastName?: Maybe<Scalars['String']>;
        /** Latitude */
        latitude?: Maybe<Scalars['String']>;
        /** Locality */
        locality?: Maybe<Scalars['String']>;
        /** Longitude */
        longitude?: Maybe<Scalars['String']>;
        number?: Maybe<Scalars['String']>;
        /** Organization name */
        organization?: Maybe<Scalars['String']>;
        /** Organization tax ID */
        organizationTaxId?: Maybe<Scalars['String']>;
        postalCode?: Maybe<Scalars['String']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** Sorting code */
        sortingCode?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        street?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type Address_CountArgs = {
    field: Scalars['String'];
};

export type AddressInput = {
    city?: InputMaybe<Scalars['String']>;
    countryCode?: InputMaybe<Scalars['String']>;
    number?: InputMaybe<Scalars['String']>;
    postalCode?: InputMaybe<Scalars['String']>;
    street?: InputMaybe<Scalars['String']>;
};

/** This is the interface implemented by all addresses. */
export type AddressInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** First line of the address */
    addressLine1?: Maybe<Scalars['String']>;
    /** Second line of the address */
    addressLine2?: Maybe<Scalars['String']>;
    /** Third line of the address */
    addressLine3?: Maybe<Scalars['String']>;
    /** Administrative area. */
    administrativeArea?: Maybe<Scalars['String']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** Two-letter country code */
    countryCode: Scalars['String'];
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Dependent locality */
    dependentLocality?: Maybe<Scalars['String']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The first name on the address. */
    firstName?: Maybe<Scalars['String']>;
    /** The full name on the address. */
    fullName?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The last name on the address. */
    lastName?: Maybe<Scalars['String']>;
    /** Latitude */
    latitude?: Maybe<Scalars['String']>;
    /** Locality */
    locality?: Maybe<Scalars['String']>;
    /** Longitude */
    longitude?: Maybe<Scalars['String']>;
    /** Organization name */
    organization?: Maybe<Scalars['String']>;
    /** Organization tax ID */
    organizationTaxId?: Maybe<Scalars['String']>;
    /** Postal code */
    postalCode?: Maybe<Scalars['String']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** Sorting code */
    sortingCode?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all addresses. */
export type AddressInterface_CountArgs = {
    field: Scalars['String'];
};

export type Affiliate = {
    __typename?: 'Affiliate';
    handle: Scalars['String'];
    name: Scalars['String'];
};

export type AffiliateInfoInput = {
    handle: Scalars['String'];
    reference?: InputMaybe<Scalars['String']>;
};

export type AlterBookingInput = {
    bookingId: Scalars['ID'];
    /**
     *   Submitting `null` will leave the surcharges unchanged, submitting an empty array indicates none of the available optional surcharges are desired.
     *  Submitting something other than `null` will result in an error if `Booking.isSurchargesAlterable` is `false`.
     */
    optionalSurcharges?: InputMaybe<Array<BookingCartItemSurchargeInput>>;
    /**   Submitting something other than `null` will result in an error if `Booking.isTravelGroupAlterable` is `false`. */
    travelGroup?: InputMaybe<TravelGroupInput>;
};

export type AlterBookingPayload = {
    __typename?: 'AlterBookingPayload';
    booking?: Maybe<Booking>;
};

/** This is the interface implemented by all assets. */
export type AssetInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** Alternative text for the asset. */
    alt?: Maybe<Scalars['String']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the asset file was last modified. */
    dateModified?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The file extension for the asset file. */
    extension: Scalars['String'];
    /** The filename of the asset file. */
    filename: Scalars['String'];
    /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
    focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
    /** The ID of the folder that the asset belongs to. */
    folderId: Scalars['Int'];
    /** Returns the file’s format. */
    format?: Maybe<Scalars['String']>;
    /** Whether a user-defined focal point is set on the asset. */
    hasFocalPoint: Scalars['Boolean'];
    /** The height in pixels or null if it’s not an image. */
    height?: Maybe<Scalars['Int']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** An `<img>` tag based on this asset. */
    img?: Maybe<Scalars['String']>;
    /** The file kind. */
    kind: Scalars['String'];
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The file’s MIME type, if it can be determined. */
    mimeType?: Maybe<Scalars['String']>;
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<AssetInterface>;
    /** The asset’s path in the volume. */
    path: Scalars['String'];
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<AssetInterface>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The file size in bytes. */
    size?: Maybe<Scalars['String']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
    srcset?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
    /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
    url?: Maybe<Scalars['String']>;
    /** The ID of the volume that the asset belongs to. */
    volumeId?: Maybe<Scalars['Int']>;
    /** The width in pixels or null if it’s not an image. */
    width?: Maybe<Scalars['Int']>;
};

/** This is the interface implemented by all assets. */
export type AssetInterface_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all assets. */
export type AssetInterfaceFormatArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

/** This is the interface implemented by all assets. */
export type AssetInterfaceHeightArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

/** This is the interface implemented by all assets. */
export type AssetInterfaceNextArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** This is the interface implemented by all assets. */
export type AssetInterfacePrevArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** This is the interface implemented by all assets. */
export type AssetInterfaceSrcsetArgs = {
    sizes: Array<Scalars['String']>;
};

/** This is the interface implemented by all assets. */
export type AssetInterfaceUrlArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

/** This is the interface implemented by all assets. */
export type AssetInterfaceWidthArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

export type AssetRelationCriteriaInput = {
    /** Narrows the query results to only elements that have been archived. */
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ creation dates. */
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the assets’ files’ last-modified dates. */
    dateModified?: InputMaybe<Scalars['String']>;
    /** Narrows the query results based on the elements’ last-updated dates. */
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the assets’ filenames. */
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Causes the query results to be returned in the order specified by the `id` argument. */
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the folders the assets belong to, per the folders’ IDs. */
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on whether the assets have alternative text. */
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the assets’ image heights. */
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ IDs. */
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Causes the query results to be returned in reverse order. */
    inReverse?: InputMaybe<Scalars['Boolean']>;
    /** Broadens the query results to include assets from any of the subfolders of the folder specified by `folderId`. */
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the assets’ file kinds. */
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the elements should be queried in, based on their language. */
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Sets the limit for paginated results. */
    limit?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to elements that do not relate to the provided element IDs. */
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Sets the offset for paginated results. */
    offset?: InputMaybe<Scalars['Int']>;
    /** Sets the field the returned elements should be ordered by. */
    orderBy?: InputMaybe<Scalars['String']>;
    /** Determines which site should be selected when querying multi-site elements. */
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on a reference string. */
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to an asset list defined with this argument. */
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a category list defined with this argument. */
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to an entry list defined with this argument. */
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a tag list defined with this argument. */
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a use list defined with this argument. */
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    /** Narrows the relations based on the field they were created in. */
    relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the relations based on the site they were created in. */
    relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that match a search query. */
    search?: InputMaybe<Scalars['String']>;
    /** Defines the default options that should be applied terms within the `search` argument. */
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the unique identifier for an element-site relation. */
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the assets’ file sizes (in bytes). */
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ slugs. */
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ statuses. */
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ titles. */
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that have been soft-deleted. */
    trashed?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ UIDs. */
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines whether only elements with unique IDs should be returned by the query. */
    unique?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the user the assets were uploaded by, per the user’s ID. */
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    /** Narrows the query results based on the elements’ URIs. */
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the volumes the assets belong to, per the volumes’ handles. */
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the volumes the assets belong to, per the volumes’ IDs. */
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the assets’ image widths. */
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** A list of transform handles to preload. */
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**   An attribute which is assigned to either an Accommodation or a RentalUnit. */
export type Attribute = {
    __typename?: 'Attribute';
    /**   A URL-friendly handle unique to this Attribute, this should never change even if the description changes. */
    handle: Scalars['String'];
    /**   URL of an SVG icon representing this Attribute. */
    iconUrl?: Maybe<Scalars['String']>;
    /**   Unique ID representing this Attribute. */
    id: Scalars['ID'];
    /**
     *   The name of this Attribute.
     *  This value is language dependent.
     */
    name: Scalars['String'];
};

/**   A category for Attributes. */
export type AttributeCategory = {
    __typename?: 'AttributeCategory';
    /**   The Attributes in this category. */
    attributes: Array<Attribute>;
    /**   A URL-friendly handle unique to this AttributeCategory, this should never change even if the description changes. */
    handle: Scalars['String'];
    /**   Unique ID representing this AttributeCategory. */
    id: Scalars['ID'];
    /**
     *   The name of this AttributeCategory.
     *  This value is language dependent.
     */
    name: Scalars['String'];
};

export type Booking = OrderItem & {
    __typename?: 'Booking';
    amountAdults: Scalars['Int'];
    amountBabies: Scalars['Int'];
    amountChildren: Scalars['Int'];
    amountPets: Scalars['Int'];
    amountYouths: Scalars['Int'];
    /**   Formatted as yyyy-mm-dd */
    arrivalDate: Scalars['String'];
    customerComment?: Maybe<Scalars['String']>;
    /**   Formatted as yyyy-mm-dd */
    departureDate: Scalars['String'];
    deposit: Scalars['Float'];
    downloadVoucherUrl?: Maybe<Scalars['String']>;
    errors: Array<Scalars['String']>;
    /**   Formatted as yyyy-mm-dd HH:mm */
    flexCancellationUntil?: Maybe<Scalars['String']>;
    handleDepositPayment: Scalars['Boolean'];
    hasCancellationInsurance: Scalars['Boolean'];
    hasContentsInsurance: Scalars['Boolean'];
    id?: Maybe<Scalars['ID']>;
    /**   If true, some part of the Booking can be altered by the Customer (via the `alterBooking` Mutation). Use the `is...Alterable` fields to determine which parts specifically can be altered. */
    isAlterable: Scalars['Boolean'];
    isCancellable: Scalars['Boolean'];
    /**   If true, the optional surcharges for this Booking can be altered by the Customer (via the `alterBooking` Mutation). */
    isSurchargesAlterable: Scalars['Boolean'];
    /**   If true, the travel group for this Booking can be altered by the Customer (via the `alterBooking` Mutation). */
    isTravelGroupAlterable: Scalars['Boolean'];
    optionalSurcharges: Array<BookingCartItemSurcharge>;
    partnerComment?: Maybe<Scalars['String']>;
    paymentPrice: Scalars['Float'];
    priceLines: Array<PriceLine>;
    rentalUnit?: Maybe<RentalUnit>;
    requiresApproval: Scalars['Boolean'];
    review?: Maybe<Review>;
    special?: Maybe<Special>;
    status: BookingStatus;
    totalPrice: Scalars['Float'];
};

export type BookingCartItemInput = {
    amountAdults: Scalars['Int'];
    amountBabies: Scalars['Int'];
    amountChildren: Scalars['Int'];
    amountPets: Scalars['Int'];
    amountYouths: Scalars['Int'];
    /**   Formatted as yyyy-mm-dd */
    arrivalDate: Scalars['String'];
    cancellationInsurance: Scalars['Boolean'];
    contentsInsurance: Scalars['Boolean'];
    /**   Formatted as yyyy-mm-dd */
    departureDate: Scalars['String'];
    optionalSurcharges: Array<BookingCartItemSurchargeInput>;
    rentalUnitId: Scalars['ID'];
    specialId?: InputMaybe<Scalars['ID']>;
};

export type BookingCartItemSurcharge = {
    __typename?: 'BookingCartItemSurcharge';
    amount: Scalars['Int'];
    rentalUnitSurchargeId: Scalars['ID'];
};

export type BookingCartItemSurchargeInput = {
    amount: Scalars['Int'];
    rentalUnitSurchargeId: Scalars['ID'];
};

export type BookingChangePreview = {
    __typename?: 'BookingChangePreview';
    bookingPreview: Booking;
    newOrderAmountDue: Scalars['Float'];
};

export enum BookingStatus {
    Accepted = 'ACCEPTED',
    CancelledExternal = 'CANCELLED_EXTERNAL',
    CancelledGuest = 'CANCELLED_GUEST',
    CancelledPartner = 'CANCELLED_PARTNER',
    Declined = 'DECLINED',
    Init = 'INIT',
    NoShow = 'NO_SHOW',
    Pending = 'PENDING',
    Waived = 'WAIVED',
}

/**   A bounding box of GPS coordinates. */
export type BoundingBoxInput = {
    bottom: Scalars['Float'];
    left: Scalars['Float'];
    right: Scalars['Float'];
    top: Scalars['Float'];
};

export type Bucket = {
    __typename?: 'Bucket';
    count?: Maybe<Scalars['Int']>;
    label?: Maybe<Scalars['String']>;
};

export type CancelBookingInput = {
    bookingId: Scalars['ID'];
};

export type CancelBookingPayload = {
    __typename?: 'CancelBookingPayload';
    booking?: Maybe<Booking>;
};

export type Cart = {
    __typename?: 'Cart';
    availableUpsellOffers: Array<UpsellOffer>;
    id: Scalars['ID'];
    order: Order;
    status: CartStatusEnum;
};

export enum CartStatusEnum {
    Closed = 'CLOSED',
    Open = 'OPEN',
    PaymentFailed = 'PAYMENT_FAILED',
    PaymentPending = 'PAYMENT_PENDING',
}

/** This is the interface implemented by all categories. */
export type CategoryInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CategoryInterface>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The category’s children. */
    children: Array<CategoryInterface>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CategoryInterface>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The handle of the group that contains the category. */
    groupHandle: Scalars['String'];
    /** The ID of the group that contains the category. */
    groupId: Scalars['Int'];
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']>;
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']>;
    /** The same element in other locales. */
    localized: Array<CategoryInterface>;
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CategoryInterface>;
    /** The category’s parent. */
    parent?: Maybe<CategoryInterface>;
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CategoryInterface>;
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']>;
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
    /** The element’s full URL */
    url?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterface_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all categories. */
export type CategoryInterfaceAncestorsArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterfaceChildrenArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterfaceDescendantsArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterfaceLocalizedArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterfaceNextArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterfaceParentArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterfacePrevArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryRelationCriteriaInput = {
    /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
    ancestorDist?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
    ancestorOf?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only elements that have been archived. */
    archived?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ creation dates. */
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ last-updated dates. */
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
    descendantDist?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
    descendantOf?: InputMaybe<Scalars['Int']>;
    /** Whether to only return categories that the user has permission to edit. */
    editable?: InputMaybe<Scalars['Boolean']>;
    /** Causes the query results to be returned in the order specified by the `id` argument. */
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the category groups the categories belong to per the group’s handles. */
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the category groups the categories belong to, per the groups’ IDs. */
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on whether the elements have any descendants in their structure. */
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ IDs. */
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Causes the query results to be returned in reverse order. */
    inReverse?: InputMaybe<Scalars['Boolean']>;
    /** Determines which site(s) the elements should be queried in, based on their language. */
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
    leaves?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ level within the structure. */
    level?: InputMaybe<Scalars['Int']>;
    /** Sets the limit for paginated results. */
    limit?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to elements that do not relate to the provided element IDs. */
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Sets the offset for paginated results. */
    offset?: InputMaybe<Scalars['Int']>;
    /** Sets the field the returned elements should be ordered by. */
    orderBy?: InputMaybe<Scalars['String']>;
    /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
    positionedAfter?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
    positionedBefore?: InputMaybe<Scalars['Int']>;
    /** Determines which site should be selected when querying multi-site elements. */
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results based on a reference string. */
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to an asset list defined with this argument. */
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a category list defined with this argument. */
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to an entry list defined with this argument. */
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a tag list defined with this argument. */
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a use list defined with this argument. */
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    /** Narrows the relations based on the field they were created in. */
    relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the relations based on the site they were created in. */
    relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that match a search query. */
    search?: InputMaybe<Scalars['String']>;
    /** Defines the default options that should be applied terms within the `search` argument. */
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the unique identifier for an element-site relation. */
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ slugs. */
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ statuses. */
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which structure data should be joined into the query. */
    structureId?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results based on the elements’ titles. */
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that have been soft-deleted. */
    trashed?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ UIDs. */
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines whether only elements with unique IDs should be returned by the query. */
    unique?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ URIs. */
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Explicitly determines whether the query should join in the structure data. */
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type CheckoutCartInput = {
    affiliateInfo?: InputMaybe<AffiliateInfoInput>;
    agreedToTerms: Scalars['Boolean'];
    bookings?: InputMaybe<Array<BookingCartItemInput>>;
    cartId: Scalars['ID'];
    customerInfo?: InputMaybe<CustomerInfoInput>;
    paymentOptions: PaymentOptionsInput;
    tickets?: InputMaybe<Array<TicketCartItemInput>>;
    upsellPurchases?: InputMaybe<Array<UpsellPurchaseCartItemInput>>;
};

export type CheckoutCartPayload = {
    __typename?: 'CheckoutCartPayload';
    cart?: Maybe<Cart>;
    redirectUrl?: Maybe<Scalars['String']>;
    success?: Maybe<Scalars['Boolean']>;
};

export type CkeditorMarkup = {
    __typename?: 'CkeditorMarkup';
    /** The parsed chunk value as HTML. */
    html?: Maybe<Scalars['String']>;
    /** The parsed chunk value as Markdown. */
    markdown?: Maybe<Scalars['String']>;
    /** The parsed chunk value as plain text.. */
    plainText?: Maybe<Scalars['String']>;
    /** The raw chunk HTML value, with reference tags in-tact. */
    rawHtml?: Maybe<Scalars['String']>;
};

export type CkeditorMarkupMarkdownArgs = {
    hard_break?: InputMaybe<Scalars['Boolean']>;
    header_style?: InputMaybe<Scalars['String']>;
    list_item_style?: InputMaybe<Scalars['String']>;
    preserve_comments?: InputMaybe<Scalars['Boolean']>;
    remove_nodes?: InputMaybe<Scalars['String']>;
    strip_placeholder_links?: InputMaybe<Scalars['Boolean']>;
    strip_tags?: InputMaybe<Scalars['Boolean']>;
    suppress_errors?: InputMaybe<Scalars['Boolean']>;
    table_caption_side?: InputMaybe<Scalars['String']>;
    table_pipe_escape?: InputMaybe<Scalars['String']>;
    use_autolinks?: InputMaybe<Scalars['Boolean']>;
};

export type Company = {
    __typename?: 'Company';
    activities: Array<Activity>;
    address: Address;
    categories: Array<CompanyCategory>;
    companyRateGroups: Array<CompanyRateGroup>;
    coordinates?: Maybe<LatLon>;
    /**   This value is language dependent. */
    description?: Maybe<Scalars['String']>;
    /**   This value is language dependent. */
    descriptionParticulars?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    fullCircleImageUrl?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    images: Array<CompanyImage>;
    listImage?: Maybe<GenericImage>;
    logoImage?: Maybe<GenericImage>;
    mainImage?: Maybe<GenericImage>;
    name: Scalars['String'];
    normalOperatingHours?: Maybe<NormalOperatingHours>;
    phoneNumber?: Maybe<Scalars['String']>;
    place: Scalars['String'];
    showInCalendar: Scalars['Boolean'];
    slug: Scalars['String'];
    socialsFacebookUrl?: Maybe<Scalars['String']>;
    socialsInstagramUrl?: Maybe<Scalars['String']>;
    socialsTwitterUrl?: Maybe<Scalars['String']>;
    specialOperatingHours: Array<SpecialOperatingHours>;
    targetAudiences: Array<TargetAudienceEnum>;
    themes: Array<ActivityTheme>;
    videoUrl?: Maybe<Scalars['String']>;
    websiteUrl?: Maybe<Scalars['String']>;
};

export type CompanyCategory = {
    __typename?: 'CompanyCategory';
    children: Array<CompanyCategory>;
    id: Scalars['ID'];
    isRoot: Scalars['Boolean'];
    /**   This value is language dependent. */
    name?: Maybe<Scalars['String']>;
    position: Scalars['Int'];
    slug: Scalars['String'];
};

/**   An image file available through a CDN URL. */
export type CompanyImage = Image & {
    __typename?: 'CompanyImage';
    /**
     *   A version of the original image transformed to specific parameters.
     *  Note that the available transform options are dependent on the type of image.
     */
    transform?: Maybe<ImageTransform>;
};

/**   An image file available through a CDN URL. */
export type CompanyImageTransformArgs = {
    config: ImageTransformConfigEnum;
    format: ImageTransformFormatEnum;
};

export type CompanyRateGroup = {
    __typename?: 'CompanyRateGroup';
    canBuyTickets: Scalars['Boolean'];
    endDate?: Maybe<Scalars['String']>;
    rates: Array<Rate>;
    startDate?: Maybe<Scalars['String']>;
};

export type CompanySearchParamsInput = {
    categorySlugs?: InputMaybe<Array<Scalars['String']>>;
    /**   Formatted as yyyy-mm-dd, inclusive */
    endDate?: InputMaybe<Scalars['String']>;
    mainCategorySlugs?: InputMaybe<Array<Scalars['String']>>;
    placeId?: InputMaybe<Scalars['ID']>;
    showInCalendar?: InputMaybe<Scalars['Boolean']>;
    /**   Formatted as yyyy-mm-dd */
    startDate?: InputMaybe<Scalars['String']>;
    targetAudiences?: InputMaybe<Array<TargetAudienceEnum>>;
    themeSlugs?: InputMaybe<Array<Scalars['String']>>;
};

export type CompanySearchResult = {
    __typename?: 'CompanySearchResult';
    categoryCounts: Array<GenericAggregationCount>;
    hits: Array<Company>;
    mainCategoryCounts: Array<GenericAggregationCount>;
    placeCounts: Array<GenericAggregationCount>;
    targetAudienceCount: Array<TargetAudienceAggregationCount>;
    themeCounts: Array<GenericAggregationCount>;
    totalHits: Scalars['Int'];
};

export type ContactInfo = {
    __typename?: 'ContactInfo';
    contactName?: Maybe<Scalars['String']>;
    emails: Array<Scalars['String']>;
    phoneNumbers: Array<Scalars['String']>;
};

export type CountryOption = {
    __typename?: 'CountryOption';
    /** The code attribute. */
    code?: Maybe<Scalars['String']>;
    /** The label attribute. */
    label?: Maybe<Scalars['String']>;
    /** The value attribute. */
    value?: Maybe<Scalars['String']>;
};

export type Customer = {
    __typename?: 'Customer';
    address?: Maybe<Address>;
    agreedToTermsAt: Scalars['String'];
    birthdate?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    favorites: Array<Favorite>;
    firstName?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    lastName?: Maybe<Scalars['String']>;
    locale: Scalars['String'];
    orders: Array<Order>;
    phoneNumber?: Maybe<Scalars['String']>;
};

export type CustomerInfoInput = {
    address?: InputMaybe<AddressInput>;
    birthdate?: InputMaybe<Scalars['String']>;
    email?: InputMaybe<Scalars['String']>;
    firstName?: InputMaybe<Scalars['String']>;
    lastName?: InputMaybe<Scalars['String']>;
    newsletterOptin: Scalars['Boolean'];
    phoneNumber?: InputMaybe<Scalars['String']>;
};

export type DateCount = {
    __typename?: 'DateCount';
    /**   Formatted as yyyy-mm-dd */
    date: Scalars['String'];
    hits: Scalars['Int'];
};

export type DateHitCount = {
    __typename?: 'DateHitCount';
    /**   Formatted as yyyy-mm-dd */
    date: Scalars['String'];
    hits: Scalars['Int'];
};

export type Element = ElementInterface & {
    __typename?: 'Element';
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
};

export type Element_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all elements. */
export type ElementInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all elements. */
export type ElementInterface_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all entries. */
export type EntryInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<EntryInterface>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']>;
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']>;
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<EntryInterface>;
    /** The current revision for the entry. */
    currentRevision?: Maybe<EntryInterface>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<EntryInterface>;
    /** The creator of a given draft. */
    draftCreator?: Maybe<UserInterface>;
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']>;
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']>;
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']>;
    /** The drafts for the entry. */
    drafts?: Maybe<Array<Maybe<EntryInterface>>>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']>;
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['DateTime']>;
    /** The handle of the field that contains the entry. */
    fieldHandle?: Maybe<Scalars['String']>;
    /** The ID of the field that contains the entry. */
    fieldId?: Maybe<Scalars['Int']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']>;
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']>;
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']>;
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']>;
    /** The same element in other locales. */
    localized: Array<EntryInterface>;
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<EntryInterface>;
    /** The ID of the entry’s owner element. */
    ownerId?: Maybe<Scalars['Int']>;
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<EntryInterface>;
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['DateTime']>;
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<EntryInterface>;
    /** The creator of a given revision. */
    revisionCreator?: Maybe<UserInterface>;
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']>;
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']>;
    /** The revisions for the entry. */
    revisions?: Maybe<Array<Maybe<EntryInterface>>>;
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']>;
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the section that contains the entry. */
    sectionHandle?: Maybe<Scalars['String']>;
    /** The ID of the section that contains the entry. */
    sectionId?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The entry’s position within the field that contains it. */
    sortOrder?: Maybe<Scalars['Int']>;
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']>;
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String'];
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int'];
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
    /** The element’s full URL */
    url?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterface_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfacePrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterfaceRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type EntryRelationCriteriaInput = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only entries that were posted on or after a certain date. */
    after?: InputMaybe<Scalars['String']>;
    /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
    ancestorDist?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
    ancestorOf?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only elements that have been archived. */
    archived?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the user group the entries’ authors belong to. */
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the user group the entries’ authors belong to, per the groups’ IDs. */
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the entries’ authors. */
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only entries that were posted before a certain date. */
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ creation dates. */
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ last-updated dates. */
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
    descendantDist?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** The drafts’ creator ID */
    draftCreator?: InputMaybe<Scalars['Int']>;
    /** The ID of the draft to return (from the `drafts` table) */
    draftId?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only drafts of a given element.  Set to `false` to fetch unpublished drafts. */
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    /** Whether draft elements should be returned. */
    drafts?: InputMaybe<Scalars['Boolean']>;
    /** Whether to only return entries that the user has permission to edit. */
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the entries’ expiry dates. */
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the field the entries are contained by. */
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the field the entries are contained by, per the fields’ IDs. */
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Causes the query results to be returned in the order specified by the `id` argument. */
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on whether the elements have any descendants in their structure. */
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ IDs. */
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Causes the query results to be returned in reverse order. */
    inReverse?: InputMaybe<Scalars['Boolean']>;
    /** Determines which site(s) the elements should be queried in, based on their language. */
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
    leaves?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ level within the structure. */
    level?: InputMaybe<Scalars['Int']>;
    /** Sets the limit for paginated results. */
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to elements that do not relate to the provided element IDs. */
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Sets the offset for paginated results. */
    offset?: InputMaybe<Scalars['Int']>;
    /** Sets the field the returned elements should be ordered by. */
    orderBy?: InputMaybe<Scalars['String']>;
    /** Narrows the query results based on the owner element of the entries, per the owners’ IDs. */
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
    positionedAfter?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
    positionedBefore?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results based on the entries’ post dates. */
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site should be selected when querying multi-site elements. */
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results based on the primary owner element of the entries, per the owners’ IDs. */
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Whether provisional drafts should be returned. */
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on a reference string. */
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to an asset list defined with this argument. */
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a category list defined with this argument. */
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to an entry list defined with this argument. */
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a tag list defined with this argument. */
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a use list defined with this argument. */
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    /** Narrows the relations based on the field they were created in. */
    relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the relations based on the site they were created in. */
    relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** The revisions’ creator ID */
    revisionCreator?: InputMaybe<Scalars['Int']>;
    /** The ID of the revision to return (from the `revisions` table) */
    revisionId?: InputMaybe<Scalars['Int']>;
    /** The source element ID that revisions should be returned for */
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    /** Whether revision elements should be returned. */
    revisions?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results to only elements that match a search query. */
    search?: InputMaybe<Scalars['String']>;
    /** Defines the default options that should be applied terms within the `search` argument. */
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    /** Narrows the query results based on the section handles the entries belong to. */
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the sections the entries belong to, per the sections’ IDs. */
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the unique identifier for an element-site relation. */
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ slugs. */
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ statuses. */
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which structure data should be joined into the query. */
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ titles. */
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that have been soft-deleted. */
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the entries’ entry type handles. */
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the entries’ entry types, per the types’ IDs. */
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ UIDs. */
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines whether only elements with unique IDs should be returned by the query. */
    unique?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ URIs. */
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    /** Whether canonical elements should be replaced with provisional drafts if those exist. */
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    /** Explicitly determines whether the query should join in the structure data. */
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExcludeFilterCount = {
    __typename?: 'ExcludeFilterCount';
    hits: Scalars['Int'];
    property: Scalars['String'];
};

export type Favorite = {
    id: Scalars['ID'];
    targetId: Scalars['ID'];
};

export type FavoriteActivity = Favorite & {
    __typename?: 'FavoriteActivity';
    activity?: Maybe<Activity>;
    id: Scalars['ID'];
    targetId: Scalars['ID'];
};

export type FavoriteCompany = Favorite & {
    __typename?: 'FavoriteCompany';
    company?: Maybe<Company>;
    id: Scalars['ID'];
    targetId: Scalars['ID'];
};

export type FavoriteRentalUnit = Favorite & {
    __typename?: 'FavoriteRentalUnit';
    id: Scalars['ID'];
    rentalUnit?: Maybe<RentalUnit>;
    targetId: Scalars['ID'];
};

export type FieldAttribute = {
    __typename?: 'FieldAttribute';
    /** The label attribute. */
    label?: Maybe<Scalars['String']>;
    /** The value attribute. */
    value?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all fields. */
export type FieldInterface = {
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type FieldOption = {
    __typename?: 'FieldOption';
    /** Whether this option has been marked as disabled. */
    disabled?: Maybe<Scalars['Boolean']>;
    /** Whether this option has been marked as a default. */
    isDefault?: Maybe<Scalars['Boolean']>;
    /** Whether this option has been marked as an `optgroup`. */
    isOptgroup?: Maybe<Scalars['Boolean']>;
    /** The label of the option. */
    label?: Maybe<Scalars['String']>;
    /** The value of the option. */
    value?: Maybe<Scalars['String']>;
};

export type Field_Address = FieldInterface & {
    __typename?: 'Field_Address';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s nested fields. */
    fields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s nested rows. */
    nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    subFieldLabelPosition?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_AddressFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_AddressNestedRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_Address1 = FieldInterface & {
    __typename?: 'Field_Address1';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Address2 = FieldInterface & {
    __typename?: 'Field_Address2';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Address3 = FieldInterface & {
    __typename?: 'Field_Address3';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_AddressAutoComplete = FieldInterface & {
    __typename?: 'Field_AddressAutoComplete';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_AddressCity = FieldInterface & {
    __typename?: 'Field_AddressCity';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_AddressCountry = FieldInterface & {
    __typename?: 'Field_AddressCountry';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_AddressState = FieldInterface & {
    __typename?: 'Field_AddressState';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_AddressZip = FieldInterface & {
    __typename?: 'Field_AddressZip';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Agree = FieldInterface & {
    __typename?: 'Field_Agree';
    checkedValue?: Maybe<Scalars['String']>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultState?: Maybe<Scalars['Boolean']>;
    defaultValue?: Maybe<Scalars['String']>;
    descriptionHtml?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uncheckedValue?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Calculations = FieldInterface & {
    __typename?: 'Field_Calculations';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    formatting?: Maybe<Scalars['String']>;
    formula?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    prefix?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    suffix?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Categories = FieldInterface & {
    __typename?: 'Field_Categories';
    categories?: Maybe<Array<Maybe<CategoryInterface>>>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultCategory?: Maybe<CategoryInterface>;
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    labelSource?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    limitOptions?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    orderBy?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    rootCategory?: Maybe<CategoryInterface>;
    source?: Maybe<Scalars['String']>;
    sources?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_CategoriesCategoriesArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_CategoriesDefaultCategoryArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_CategoriesRootCategoryArgs = {
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_Checkboxes = FieldInterface & {
    __typename?: 'Field_Checkboxes';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    limitOptions?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    min?: Maybe<Scalars['Int']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    toggleCheckbox?: Maybe<Scalars['String']>;
    toggleCheckboxLabel?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Date = FieldInterface & {
    __typename?: 'Field_Date';
    availableDaysOfWeek?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    dateFormat?: Maybe<Scalars['String']>;
    datePickerOptions?: Maybe<Array<Maybe<FieldAttribute>>>;
    defaultDate?: Maybe<Scalars['DateTime']>;
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s nested fields. */
    fields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    isDate?: Maybe<Scalars['Boolean']>;
    isDateTime?: Maybe<Scalars['Boolean']>;
    isTime?: Maybe<Scalars['Boolean']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    maxDate?: Maybe<Scalars['DateTime']>;
    minDate?: Maybe<Scalars['DateTime']>;
    /** The field’s nested rows. */
    nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    subFieldLabelPosition?: Maybe<Scalars['String']>;
    timeFormat?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_DateNestedRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_DateAmPmDropdown = FieldInterface & {
    __typename?: 'Field_DateAmPmDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateAmPmNumber = FieldInterface & {
    __typename?: 'Field_DateAmPmNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateDate = FieldInterface & {
    __typename?: 'Field_DateDate';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateDayDropdown = FieldInterface & {
    __typename?: 'Field_DateDayDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateDayNumber = FieldInterface & {
    __typename?: 'Field_DateDayNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateHourDropdown = FieldInterface & {
    __typename?: 'Field_DateHourDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateHourNumber = FieldInterface & {
    __typename?: 'Field_DateHourNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateMinuteDropdown = FieldInterface & {
    __typename?: 'Field_DateMinuteDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateMinuteNumber = FieldInterface & {
    __typename?: 'Field_DateMinuteNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateMonthDropdown = FieldInterface & {
    __typename?: 'Field_DateMonthDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateMonthNumber = FieldInterface & {
    __typename?: 'Field_DateMonthNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateSecondDropdown = FieldInterface & {
    __typename?: 'Field_DateSecondDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateSecondNumber = FieldInterface & {
    __typename?: 'Field_DateSecondNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateTime = FieldInterface & {
    __typename?: 'Field_DateTime';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateYearDropdown = FieldInterface & {
    __typename?: 'Field_DateYearDropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_DateYearNumber = FieldInterface & {
    __typename?: 'Field_DateYearNumber';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Dropdown = FieldInterface & {
    __typename?: 'Field_Dropdown';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Email = FieldInterface & {
    __typename?: 'Field_Email';
    blockedDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Entries = FieldInterface & {
    __typename?: 'Field_Entries';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultEntry?: Maybe<EntryInterface>;
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    entries?: Maybe<Array<Maybe<EntryInterface>>>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    labelSource?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    limitOptions?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    orderBy?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    source?: Maybe<Scalars['String']>;
    sources?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_EntriesDefaultEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_EntriesEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_FileUpload = FieldInterface & {
    __typename?: 'Field_FileUpload';
    allowedKinds?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    labelSource?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    limitFiles?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    orderBy?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    sizeLimit?: Maybe<Scalars['String']>;
    sizeMinLimit?: Maybe<Scalars['String']>;
    source?: Maybe<Scalars['String']>;
    sources?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
    volumeHandle?: Maybe<Scalars['String']>;
};

export type Field_Group = FieldInterface & {
    __typename?: 'Field_Group';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s nested fields. */
    fields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s nested rows. */
    nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_GroupFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_GroupNestedRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_Heading = FieldInterface & {
    __typename?: 'Field_Heading';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    headingSize?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Hidden = FieldInterface & {
    __typename?: 'Field_Hidden';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    cookieName?: Maybe<Scalars['String']>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultOption?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    queryParameter?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Html = FieldInterface & {
    __typename?: 'Field_Html';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    htmlContent?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_MultiLineText = FieldInterface & {
    __typename?: 'Field_MultiLineText';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    richTextButtons?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    useRichText?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Name = FieldInterface & {
    __typename?: 'Field_Name';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s nested fields. */
    fields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s nested rows. */
    nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    subFieldLabelPosition?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    useMultipleFields?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_NameFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_NameNestedRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_NameFirst = FieldInterface & {
    __typename?: 'Field_NameFirst';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_NameLast = FieldInterface & {
    __typename?: 'Field_NameLast';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_NameMiddle = FieldInterface & {
    __typename?: 'Field_NameMiddle';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_NamePrefix = FieldInterface & {
    __typename?: 'Field_NamePrefix';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Newsletter = FieldInterface & {
    __typename?: 'Field_Newsletter';
    checkedValue?: Maybe<Scalars['String']>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultState?: Maybe<Scalars['Boolean']>;
    defaultValue?: Maybe<Scalars['String']>;
    descriptionHtml?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uncheckedValue?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Number = FieldInterface & {
    __typename?: 'Field_Number';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    decimals?: Maybe<Scalars['Int']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxValue?: Maybe<Scalars['Float']>;
    min?: Maybe<Scalars['Int']>;
    minValue?: Maybe<Scalars['Float']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Password = FieldInterface & {
    __typename?: 'Field_Password';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Payment = FieldInterface & {
    __typename?: 'Field_Payment';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    paymentIntegration?: Maybe<Scalars['String']>;
    paymentIntegrationType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    providerSettings?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Phone = FieldInterface & {
    __typename?: 'Field_Phone';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    countryAllowed?: Maybe<Scalars['String']>;
    countryDefaultValue?: Maybe<Scalars['String']>;
    countryEnabled?: Maybe<Scalars['Boolean']>;
    countryOptions?: Maybe<Array<Maybe<CountryOption>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Radio = FieldInterface & {
    __typename?: 'Field_Radio';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Recipients = FieldInterface & {
    __typename?: 'Field_Recipients';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    multiple?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<FieldOption>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Repeater = FieldInterface & {
    __typename?: 'Field_Repeater';
    addLabel?: Maybe<Scalars['String']>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s nested fields. */
    fields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    maxRows?: Maybe<Scalars['Int']>;
    minRows?: Maybe<Scalars['Int']>;
    /** The field’s nested rows. */
    nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_RepeaterFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_RepeaterNestedRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Field_Section = FieldInterface & {
    __typename?: 'Field_Section';
    borderColor?: Maybe<Scalars['String']>;
    borderStyle?: Maybe<Scalars['String']>;
    borderWidth?: Maybe<Scalars['Int']>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Signature = FieldInterface & {
    __typename?: 'Field_Signature';
    backgroundColor?: Maybe<Scalars['String']>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    penColor?: Maybe<Scalars['String']>;
    penWeight?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_SingleLineText = FieldInterface & {
    __typename?: 'Field_SingleLineText';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Boolean']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    max?: Maybe<Scalars['Int']>;
    maxType?: Maybe<Scalars['String']>;
    min?: Maybe<Scalars['Int']>;
    minType?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    uniqueValue?: Maybe<Scalars['Boolean']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Summary = FieldInterface & {
    __typename?: 'Field_Summary';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Table = FieldInterface & {
    __typename?: 'Field_Table';
    columns?: Maybe<Array<Maybe<KeyValueType>>>;
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** The field’s default value as a string. Some fields have different fields for their default value. */
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_Tags = FieldInterface & {
    __typename?: 'Field_Tags';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultTag?: Maybe<TagInterface>;
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    labelSource?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    limitOptions?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    orderBy?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    source?: Maybe<Scalars['String']>;
    sources?: Maybe<Scalars['String']>;
    tags?: Maybe<Array<Maybe<TagInterface>>>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_TagsDefaultTagArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Field_TagsTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Field_Users = FieldInterface & {
    __typename?: 'Field_Users';
    /** The field’s conditions as a JSON string. */
    conditions?: Maybe<Scalars['Json']>;
    /** The field’s container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    defaultUser?: Maybe<UserInterface>;
    defaultValue?: Maybe<Scalars['String']>;
    /** The field’s display name (last portion of the class). */
    displayName?: Maybe<Scalars['String']>;
    displayType?: Maybe<Scalars['String']>;
    /** The field’s value type to use in email notifications. */
    emailValue?: Maybe<Scalars['String']>;
    /** Whether the field has conditions enabled. */
    enableConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the field has content encryption enabled. */
    enableContentEncryption?: Maybe<Scalars['Boolean']>;
    /** Whether the field is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The field’s error message. */
    errorMessage?: Maybe<Scalars['String']>;
    /** The field’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the field should be included in email content. */
    includeInEmail?: Maybe<Scalars['Boolean']>;
    /** The field’s input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The field’s full GQL input type. Useful for mutations. */
    inputTypeName?: Maybe<Scalars['String']>;
    /** The field’s instructions. */
    instructions?: Maybe<Scalars['String']>;
    /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
    instructionsPosition?: Maybe<Scalars['String']>;
    /** The field’s label. */
    label?: Maybe<Scalars['String']>;
    /** The field’s label position. This will be a `verbb\formie\positions` class name. */
    labelPosition?: Maybe<Scalars['String']>;
    labelSource?: Maybe<Scalars['String']>;
    layout?: Maybe<Scalars['String']>;
    limitOptions?: Maybe<Scalars['String']>;
    /** The field handle for another field that this value should match exactly. */
    matchField?: Maybe<Scalars['String']>;
    multi?: Maybe<Scalars['Boolean']>;
    orderBy?: Maybe<Scalars['String']>;
    /** The field’s placeholder. */
    placeholder?: Maybe<Scalars['String']>;
    /** The field’s pre-populated value extracted from the query string. */
    prePopulate?: Maybe<Scalars['String']>;
    /** Whether the field is required. */
    required?: Maybe<Scalars['Boolean']>;
    source?: Maybe<Scalars['String']>;
    sources?: Maybe<Scalars['String']>;
    /** The field’s type. */
    type?: Maybe<Scalars['String']>;
    /** The field’s full GQL type. */
    typeName?: Maybe<Scalars['String']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    users?: Maybe<Array<Maybe<UserInterface>>>;
    /** The field’s visibility. */
    visibility?: Maybe<Scalars['String']>;
};

export type Field_UsersDefaultUserArgs = {
    affiliatedSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    affiliatedSiteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    archived?: InputMaybe<Scalars['Boolean']>;
    assetUploaders?: InputMaybe<Scalars['Boolean']>;
    authors?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    fullName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasPhoto?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Field_UsersUsersArgs = {
    affiliatedSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    affiliatedSiteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    archived?: InputMaybe<Scalars['Boolean']>;
    assetUploaders?: InputMaybe<Scalars['Boolean']>;
    authors?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    fullName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasPhoto?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FormIntegrationsType = {
    __typename?: 'FormIntegrationsType';
    /** Whether the integration is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The integration’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The integration’s name. */
    name?: Maybe<Scalars['String']>;
    /** The integration’s settings as a JSON string. */
    settings?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all forms. */
export type FormInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** A list of captcha values (name and value) to assist with spam protection. */
    captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
    /** The form’s config as JSON. */
    configJson?: Maybe<Scalars['String']>;
    /** A CSRF token (name and value). */
    csrfToken?: Maybe<FormieCsrfTokenType>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The form’s fields. */
    formFields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The form’s handle. */
    handle?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** Whether the form is considered available according to user checks, scheduling and more. */
    isAvailable?: Maybe<Scalars['Boolean']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The form’s pages. */
    pages?: Maybe<Array<Maybe<PageInterface>>>;
    /** The form’s rows. */
    rows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The form’s settings. */
    settings?: Maybe<FormSettingsType>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The form’s endpoint for sending submissions to, if using POST requests. */
    submissionEndpoint?: Maybe<Scalars['String']>;
    /** The form’s GQL mutation name for submissions to use. */
    submissionMutationName?: Maybe<Scalars['String']>;
    /** The form’s CSS for rendering. */
    templateCss?: Maybe<Scalars['String']>;
    /** The form’s rendered HTML. */
    templateHtml?: Maybe<Scalars['String']>;
    /** The form’s JS for rendering and functionality. */
    templateJs?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all forms. */
export type FormInterface_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all forms. */
export type FormInterfaceFormFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all forms. */
export type FormInterfaceRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all forms. */
export type FormInterfaceTemplateHtmlArgs = {
    options?: InputMaybe<Scalars['String']>;
    populateFormValues?: InputMaybe<Scalars['String']>;
};

/** This is the interface implemented by all forms. */
export type FormInterfaceTemplateJsArgs = {
    initJs?: InputMaybe<Scalars['Boolean']>;
    useObserver?: InputMaybe<Scalars['Boolean']>;
};

export type FormSettingsType = {
    __typename?: 'FormSettingsType';
    /** The form’s default instructions position for fields. This will be a `verbb\formie\positions` class name. */
    defaultInstructionsPosition?: Maybe<Scalars['String']>;
    /** The form’s default label position for fields. This will be a `verbb\formie\positions` class name. */
    defaultLabelPosition?: Maybe<Scalars['String']>;
    /** Whether to show the form’s current page title. */
    displayCurrentPageTitle?: Maybe<Scalars['Boolean']>;
    /** Whether to show the form’s title. */
    displayFormTitle?: Maybe<Scalars['Boolean']>;
    /** Whether to show the form’s page progress. */
    displayPageProgress?: Maybe<Scalars['Boolean']>;
    /** Whether to show the form’s page tabs. */
    displayPageTabs?: Maybe<Scalars['Boolean']>;
    /** The form’s submit error message. */
    errorMessageHtml?: Maybe<Scalars['String']>;
    /** The form’s error message position. Either `null`, `top-form` or `bottom-form`. */
    errorMessagePosition?: Maybe<Scalars['String']>;
    /** The form’s enabled integrations. */
    integrations?: Maybe<Array<Maybe<FormIntegrationsType>>>;
    /** The type of loading indicator to use. Either `spinner` or `text`. */
    loadingIndicator?: Maybe<Scalars['String']>;
    /** The form’s loading indicator text. */
    loadingIndicatorText?: Maybe<Scalars['String']>;
    /** The form’s progress bar position. Either `start` or `end`. */
    progressPosition?: Maybe<Scalars['String']>;
    /** The form’s progress bar value position. Either `left`, `right`, `inside-left`, `inside-center`, `inside-right` or `hidden`. */
    progressValuePosition?: Maybe<Scalars['String']>;
    /** The form’s submit action entry (for redirection), if `submitAction` is `entry`. */
    redirectEntry?: Maybe<EntryInterface>;
    /** The form’s submit action redirect URL, resolved depending on `submitAction` being `entry` or `url`. */
    redirectUrl?: Maybe<Scalars['String']>;
    /** The form’s required fields indicator. Either `asterisk` or `optional`. */
    requiredIndicator?: Maybe<Scalars['String']>;
    /** Whether to the form should scroll to the top of the page when submitted. */
    scrollToTop?: Maybe<Scalars['Boolean']>;
    /** The form’s submit action. Either `message`, `entry`, `url`, `reload`. */
    submitAction?: Maybe<Scalars['String']>;
    /** Whether to hide the form’s success message. */
    submitActionFormHide?: Maybe<Scalars['Boolean']>;
    /** The form’s submit success message. */
    submitActionMessageHtml?: Maybe<Scalars['String']>;
    /** The form’s submit message position. Either `top-form` or `bottom-form`. */
    submitActionMessagePosition?: Maybe<Scalars['String']>;
    /** The form’s submit success message timeout in seconds. */
    submitActionMessageTimeout?: Maybe<Scalars['Int']>;
    /** The form’s submit redirect option (if in new tab or same tab). Either `same-tab` or `new-tab`. */
    submitActionTab?: Maybe<Scalars['String']>;
    /** The form’s submit method. Either `page-reload` or `ajax`. */
    submitMethod?: Maybe<Scalars['String']>;
    /** Whether to validate the form’s on focus. */
    validationOnFocus?: Maybe<Scalars['Boolean']>;
    /** Whether to validate the form’s on submit. */
    validationOnSubmit?: Maybe<Scalars['Boolean']>;
};

export type FormSettingsTypeRedirectEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FormieCaptchaType = {
    __typename?: 'FormieCaptchaType';
    /** The captcha handle. */
    handle?: Maybe<Scalars['String']>;
    /** The captcha name. */
    name?: Maybe<Scalars['String']>;
    /** The catpcha value. */
    value?: Maybe<Scalars['String']>;
};

export type FormieCsrfTokenType = {
    __typename?: 'FormieCsrfTokenType';
    /** The CSRF name. */
    name?: Maybe<Scalars['String']>;
    /** The CSRF token. */
    value?: Maybe<Scalars['String']>;
};

export type GenericAggregationCount = {
    __typename?: 'GenericAggregationCount';
    hits: Scalars['Int'];
    value: Scalars['String'];
};

/**   An image file available through a CDN URL. */
export type GenericImage = Image & {
    __typename?: 'GenericImage';
    /**
     *   A version of the original image transformed to specific parameters.
     *  Note that the available transform options are dependent on the type of image.
     */
    transform?: Maybe<ImageTransform>;
};

/**   An image file available through a CDN URL. */
export type GenericImageTransformArgs = {
    config: ImageTransformConfigEnum;
    format: ImageTransformFormatEnum;
};

/** This is the interface implemented by all global sets. */
export type GlobalSetInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The handle of the global set. */
    handle: Scalars['String'];
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The name of the global set. */
    name: Scalars['String'];
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all global sets. */
export type GlobalSetInterface_CountArgs = {
    field: Scalars['String'];
};

/**   An image file available through a CDN URL. */
export type Image = {
    /**
     *   A version of the original image transformed to specific parameters.
     *  Note that the available transform options are dependent on the type of image.
     */
    transform?: Maybe<ImageTransform>;
};

/**   An image file available through a CDN URL. */
export type ImageTransformArgs = {
    config: ImageTransformConfigEnum;
    format: ImageTransformFormatEnum;
};

/**   A version of an image transformed according to the requested parameters. */
export type ImageTransform = {
    __typename?: 'ImageTransform';
    /**
     *   This is an extremely downscaled version of the original image which can be used as a placeholder while loading the full image.
     *  This is formatted as a string of base64 encoded WebP data, and is therefore only available on transforms with the `WEBP` format.
     */
    placeholder?: Maybe<Scalars['String']>;
    /**   The aspect ratio of this image. */
    ratio: Scalars['Float'];
    /**   The URL for the largest version of this transform. */
    src: Scalars['String'];
    /**   The different available sizes of this transform, formatted for use in an HTML `srcSet` attribute. */
    srcSet: Scalars['String'];
};

/**   Available image transform configurations. This determines the scaling method and the generated sizes. */
export enum ImageTransformConfigEnum {
    /**
     *  Used for displaying avatar images, generally inside a circular frame. Images are transformed and cropped to fill a 1:1 frame.
     * # Available on avatar image fields.
     */
    Avatar = 'AVATAR',
    /**
     *  Used for displaying images of varying aspect ratio in a gallery. Images are transformed to fit inside a 4:3 frame without cropping.
     * # Available on fields containing multiple images.
     */
    Gallery = 'GALLERY',
    /**
     *  Used for displaying large landscape images in a hero element. Images are transformed and cropped to fill a 4:3 frame.
     * # Available on fields called `mainImage`.
     */
    Hero = 'HERO',
    /**
     *  Used for displaying logos. Images are transformed to fit inside a 1:1 frame and extended with empty space to always produce a 1:1 image.
     * # Available on logo image fields.
     */
    Logo = 'LOGO',
    /**
     *  Used for displaying landscape images in a listing. Images are transformed and cropped to fill a 4:3 frame.
     * # Available on fields called `listImage`.
     */
    Tile = 'TILE',
}

/**
 *   Available image formats for transforms. Use WebP whenever possible for lowest image size.
 *  Note that not all formats are available for every transform.
 */
export enum ImageTransformFormatEnum {
    /**  JPEG is not available for transforms with the `LOGO` config. */
    Jpeg = 'JPEG',
    /**  PNG is only available for transforms with the `LOGO` config. */
    Png = 'PNG',
    /**  WebP is available for all transforms. */
    Webp = 'WEBP',
}

export type KeyValueType = {
    __typename?: 'KeyValueType';
    handle?: Maybe<Scalars['String']>;
    heading?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    width?: Maybe<Scalars['String']>;
};

/**   A set of GPS coordinates. */
export type LatLon = {
    __typename?: 'LatLon';
    /**   The latitude. */
    lat: Scalars['Float'];
    /**   The longitude. */
    lon: Scalars['Float'];
};

/**   A set of GPS coordinates. */
export type LatLonInput = {
    /**   The latitude. */
    lat: Scalars['Float'];
    /**   The longitude. */
    lon: Scalars['Float'];
};

export type LeaveActivityReviewInput = {
    comment: Scalars['String'];
    ratingActivity: Scalars['Int'];
    ratingHospitality: Scalars['Int'];
    ratingValueForMoney: Scalars['Int'];
    ticketId: Scalars['ID'];
    tips?: InputMaybe<Scalars['String']>;
    title: Scalars['String'];
};

export type LeaveActivityReviewPayload = {
    __typename?: 'LeaveActivityReviewPayload';
    activityReview?: Maybe<ActivityReview>;
};

export type LeaveReviewInput = {
    bookingId: Scalars['ID'];
    comment: Scalars['String'];
    ratingHospitality: Scalars['Int'];
    ratingLayout: Scalars['Int'];
    ratingLocation: Scalars['Int'];
    ratingMaintenance: Scalars['Int'];
    ratingValueForMoney: Scalars['Int'];
    tips?: InputMaybe<Scalars['String']>;
    title: Scalars['String'];
    travelGroupType: TravelGroupType;
};

export type LeaveReviewPayload = {
    __typename?: 'LeaveReviewPayload';
    review?: Maybe<Review>;
};

export type LeaveUnauthenticatedActivityReviewInput = {
    comment: Scalars['String'];
    ratingActivity: Scalars['Int'];
    ratingHospitality: Scalars['Int'];
    ratingValueForMoney: Scalars['Int'];
    ticketHash: Scalars['ID'];
    tips?: InputMaybe<Scalars['String']>;
    title: Scalars['String'];
};

export type LeaveUnauthenticatedReviewInput = {
    bookingHash: Scalars['ID'];
    comment: Scalars['String'];
    ratingHospitality: Scalars['Int'];
    ratingLayout: Scalars['Int'];
    ratingLocation: Scalars['Int'];
    ratingMaintenance: Scalars['Int'];
    ratingValueForMoney: Scalars['Int'];
    tips?: InputMaybe<Scalars['String']>;
    title: Scalars['String'];
    travelGroupType: TravelGroupType;
};

export type LinkData = {
    __typename?: 'LinkData';
    ariaLabel?: Maybe<Scalars['String']>;
    asset?: Maybe<AssetInterface>;
    category?: Maybe<CategoryInterface>;
    class?: Maybe<Scalars['String']>;
    defaultLabel?: Maybe<Scalars['String']>;
    download?: Maybe<Scalars['Boolean']>;
    element?: Maybe<ElementInterface>;
    elementId?: Maybe<Scalars['Int']>;
    elementSiteId?: Maybe<Scalars['Int']>;
    elementTitle?: Maybe<Scalars['String']>;
    elementType?: Maybe<Scalars['String']>;
    entry?: Maybe<EntryInterface>;
    filename?: Maybe<Scalars['String']>;
    form?: Maybe<ElementInterface>;
    id?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    link?: Maybe<Scalars['String']>;
    rel?: Maybe<Scalars['String']>;
    target?: Maybe<Scalars['String']>;
    title?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    url?: Maybe<Scalars['String']>;
    urlSuffix?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['String']>;
};

export type Mutation = {
    __typename?: 'Mutation';
    /**
     *   Add an Activity to a Customer's favorites.
     *  Requires an active login session.
     */
    addFavoriteActivity: AddFavoriteActivityPayload;
    /**
     *   Add a Company to a Customer's favorites.
     *  Requires an active login session.
     */
    addFavoriteCompany: AddFavoriteCompanyPayload;
    /**
     *   Add a RentalUnit to a Customer's favorites.
     *  Requires an active login session.
     */
    addFavoriteRentalUnit: AddFavoriteRentalUnitPayload;
    /**
     *   Alter an existing Booking.
     *  The Booking must belong to the currently logged in Customer and Booking.isAlterable must be TRUE.
     */
    alterBooking: AlterBookingPayload;
    /**
     *   Cancel an existing Booking.
     *  The Booking must belong to the currently logged in Customer and Booking.isCancellable must be TRUE.
     */
    cancelBooking: CancelBookingPayload;
    /**   Initiate final checkout for an existing Cart. */
    checkoutCart: CheckoutCartPayload;
    /**
     *   Leave a review for a Activity.
     *  The Ticket must be accepted, in the past, linked to the currently logged in Customer, and not already have a Review.
     */
    leaveActivityReview: LeaveActivityReviewPayload;
    /**
     *   Leave a review for a Booking.
     *  The Booking must be accepted, in the past, linked to the currently logged in Customer, and not already have a Review.
     */
    leaveReview: LeaveReviewPayload;
    /**   Leave a review without an active login session by supplying the hash from a review request email. */
    leaveUnauthenticatedActivityReview: LeaveActivityReviewPayload;
    /**   Leave a review without an active login session by supplying the hash from a review request email. */
    leaveUnauthenticatedReview: LeaveReviewPayload;
    /**
     *   Initiate payment for an existing Order.
     *  The Order must belong to the currently logged in Customer.
     */
    payOrder: PayOrderPayload;
    ping?: Maybe<Scalars['String']>;
    /**   Register a new Customer. */
    register: RegisterPayload;
    /**
     *   Remove an item for a Customer's favorites.
     *  The Favorite must belong to the currently logged in Customer.
     */
    removeFavorite: RemoveFavoritePayload;
    /**
     *   Request a login email for a Customer.
     *  The email contains a link which supplies an `authCode` for the oAuth token endpoint.
     */
    sendAuthenticationEmail: SendAuthenticationEmailPayload;
    /**   Create or update a Cart with contents and/or details. */
    updateCart: UpdateCartPayload;
    /**
     *   Update the details of an existing Customer.
     *  This can only be performed on the currently logged in Customer.
     */
    updateCustomer: UpdateCustomerPayload;
};

export type MutationAddFavoriteActivityArgs = {
    input: AddFavoriteActivityInput;
};

export type MutationAddFavoriteCompanyArgs = {
    input: AddFavoriteCompanyInput;
};

export type MutationAddFavoriteRentalUnitArgs = {
    input: AddFavoriteRentalUnitInput;
};

export type MutationAlterBookingArgs = {
    input: AlterBookingInput;
};

export type MutationCancelBookingArgs = {
    input: CancelBookingInput;
};

export type MutationCheckoutCartArgs = {
    input: CheckoutCartInput;
};

export type MutationLeaveActivityReviewArgs = {
    input: LeaveActivityReviewInput;
};

export type MutationLeaveReviewArgs = {
    input: LeaveReviewInput;
};

export type MutationLeaveUnauthenticatedActivityReviewArgs = {
    input: LeaveUnauthenticatedActivityReviewInput;
};

export type MutationLeaveUnauthenticatedReviewArgs = {
    input: LeaveUnauthenticatedReviewInput;
};

export type MutationPayOrderArgs = {
    input: PayOrderInput;
};

export type MutationRegisterArgs = {
    input: RegisterInput;
};

export type MutationRemoveFavoriteArgs = {
    input: RemoveFavoriteInput;
};

export type MutationSendAuthenticationEmailArgs = {
    input: SendAuthenticationEmailInput;
};

export type MutationUpdateCartArgs = {
    input: UpdateCartInput;
};

export type MutationUpdateCustomerArgs = {
    input: UpdateCustomerInput;
};

export type NameType = {
    __typename?: 'NameType';
    /** The first name value of the name. */
    firstName?: Maybe<Scalars['String']>;
    /** The full name value. */
    fullName?: Maybe<Scalars['String']>;
    /** The last name value of the name. */
    lastName?: Maybe<Scalars['String']>;
    /** The middle name value of the name. */
    middleName?: Maybe<Scalars['String']>;
    /** The prefix value of the name. */
    prefix?: Maybe<Scalars['String']>;
};

export type NormalOperatingHours = {
    __typename?: 'NormalOperatingHours';
    friday: Array<TimeOpenClosed>;
    monday: Array<TimeOpenClosed>;
    saturday: Array<TimeOpenClosed>;
    sunday: Array<TimeOpenClosed>;
    thursday: Array<TimeOpenClosed>;
    tuesday: Array<TimeOpenClosed>;
    wednesday: Array<TimeOpenClosed>;
};

export type Order = {
    __typename?: 'Order';
    affiliate?: Maybe<Affiliate>;
    affiliateReference?: Maybe<Scalars['String']>;
    agreedToTerms?: Maybe<Scalars['Boolean']>;
    createdDate?: Maybe<Scalars['String']>;
    customer?: Maybe<Customer>;
    downloadOverviewUrl?: Maybe<Scalars['String']>;
    errors: Array<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    invoiceAddress?: Maybe<Address>;
    isDeskOrder: Scalars['Boolean'];
    newsletterOptin?: Maybe<Scalars['Boolean']>;
    number?: Maybe<Scalars['String']>;
    orderItems: Array<OrderItem>;
    paymentOptions?: Maybe<PaymentOptions>;
    payments: Array<Payment>;
    totalPrice: Scalars['Float'];
};

export type OrderItem = {
    errors: Array<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    paymentPrice: Scalars['Float'];
    priceLines: Array<PriceLine>;
    totalPrice: Scalars['Float'];
};

/** This is the interface implemented by all pages. */
export type PageInterface = {
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The page’s label. */
    label?: Maybe<Scalars['String']>;
    /** The page’s fields. */
    pageFields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The page’s rows. */
    rows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The page’s settings, including buttons. */
    settings?: Maybe<PageSettingsInterface>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all pages. */
export type PageInterfacePageFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all pages. */
export type PageInterfaceRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all pages. */
export type PageSettingsInterface = {
    /** The page’s back button label. */
    backButtonLabel?: Maybe<Scalars['String']>;
    /** The page’s button (back and submit) positions. */
    buttonsPosition?: Maybe<Scalars['String']>;
    /** The page’s button (back and submit) container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The page’s button (back and submit) CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** Whether the page’s button has JS events enabled. */
    enableJsEvents?: Maybe<Scalars['Boolean']>;
    /** Whether the page’s next button has conditions enabled, for multi-page forms. */
    enableNextButtonConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the page has conditions enabled. */
    enablePageConditions?: Maybe<Scalars['Boolean']>;
    /** The page’s button (back and submit) input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The page’s JS event options (GTM) as a JSON string. */
    jsGtmEventOptions?: Maybe<Scalars['Json']>;
    /** The page’s conditions for whether to show the next button, for multi-page forms as a JSON string. */
    nextButtonConditions?: Maybe<Scalars['Json']>;
    /** The page’s conditions as a JSON string. */
    pageConditions?: Maybe<Scalars['Json']>;
    /** The page’s draft button label. */
    saveButtonLabel?: Maybe<Scalars['String']>;
    /** Whether to show the page’s back button. */
    showBackButton?: Maybe<Scalars['Boolean']>;
    /** Whether to show the page’s draft button. */
    showSaveButton?: Maybe<Scalars['Boolean']>;
    /** The page’s submit button label. */
    submitButtonLabel?: Maybe<Scalars['String']>;
};

export type PageSettingsType = PageSettingsInterface & {
    __typename?: 'PageSettingsType';
    /** The page’s back button label. */
    backButtonLabel?: Maybe<Scalars['String']>;
    /** The page’s button (back and submit) positions. */
    buttonsPosition?: Maybe<Scalars['String']>;
    /** The page’s button (back and submit) container attributes. */
    containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The page’s button (back and submit) CSS classes. */
    cssClasses?: Maybe<Scalars['String']>;
    /** Whether the page’s button has JS events enabled. */
    enableJsEvents?: Maybe<Scalars['Boolean']>;
    /** Whether the page’s next button has conditions enabled, for multi-page forms. */
    enableNextButtonConditions?: Maybe<Scalars['Boolean']>;
    /** Whether the page has conditions enabled. */
    enablePageConditions?: Maybe<Scalars['Boolean']>;
    /** The page’s button (back and submit) input attributes. */
    inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
    /** The page’s JS event options (GTM) as a JSON string. */
    jsGtmEventOptions?: Maybe<Scalars['Json']>;
    /** The page’s conditions for whether to show the next button, for multi-page forms as a JSON string. */
    nextButtonConditions?: Maybe<Scalars['Json']>;
    /** The page’s conditions as a JSON string. */
    pageConditions?: Maybe<Scalars['Json']>;
    /** The page’s draft button label. */
    saveButtonLabel?: Maybe<Scalars['String']>;
    /** Whether to show the page’s back button. */
    showBackButton?: Maybe<Scalars['Boolean']>;
    /** Whether to show the page’s draft button. */
    showSaveButton?: Maybe<Scalars['Boolean']>;
    /** The page’s submit button label. */
    submitButtonLabel?: Maybe<Scalars['String']>;
};

export type PageType = PageInterface & {
    __typename?: 'PageType';
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The page’s label. */
    label?: Maybe<Scalars['String']>;
    /** The page’s fields. */
    pageFields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The page’s rows. */
    rows?: Maybe<Array<Maybe<RowInterface>>>;
    /** The page’s settings, including buttons. */
    settings?: Maybe<PageSettingsInterface>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
};

export type PageTypePageFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type PageTypeRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type PayOrderInput = {
    orderId: Scalars['ID'];
    paymentOptions: PaymentOptionsInput;
};

export type PayOrderPayload = {
    __typename?: 'PayOrderPayload';
    order?: Maybe<Order>;
    redirectUrl?: Maybe<Scalars['String']>;
};

export type Payment = {
    __typename?: 'Payment';
    amount: Scalars['Float'];
    date: Scalars['String'];
    method: PaymentMethodEnum;
    status: PaymentStatusEnum;
};

export enum PaymentMethodEnum {
    ApplePay = 'APPLE_PAY',
    Bancontact = 'BANCONTACT',
    BankAccount = 'BANK_ACCOUNT',
    Cash = 'CASH',
    CreditCard = 'CREDIT_CARD',
    CreditNote = 'CREDIT_NOTE',
    DeskBooking = 'DESK_BOOKING',
    GiftCard = 'GIFT_CARD',
    Giropay = 'GIROPAY',
    Ideal = 'IDEAL',
    IngHomepay = 'ING_HOMEPAY',
    None = 'NONE',
    Other = 'OTHER',
    Paypal = 'PAYPAL',
    PointOfSale = 'POINT_OF_SALE',
    SepaDirectDebit = 'SEPA_DIRECT_DEBIT',
    SepaTransfer = 'SEPA_TRANSFER',
    Sofort = 'SOFORT',
    Trustly = 'TRUSTLY',
}

export type PaymentOptions = {
    __typename?: 'PaymentOptions';
    /**   The methods available for this payment. */
    availableMethods: Array<PaymentMethodEnum>;
    /**   The date before which the totalAmountDue must be paid. Formatted as: yyyy-mm-dd. */
    fullPaymentDueDate?: Maybe<Scalars['String']>;
    /**   The minimum amount that needs to be paid at this point. */
    partialPaymentAmount: Scalars['Float'];
    /**   The total remaining amount due to be paid through Travelbase. */
    totalAmountDue: Scalars['Float'];
};

export type PaymentOptionsInput = {
    /**   Method "SEPA_DIRECT_DEBIT" only, this must be supplied */
    accountHolderName?: InputMaybe<Scalars['String']>;
    /**   Method "SEPA_DIRECT_DEBIT" only, this must be supplied and must be a valid IBAN */
    iban?: InputMaybe<Scalars['String']>;
    landingUrl: Scalars['String'];
    method: PaymentMethodEnum;
    payPartialAmount: Scalars['Boolean'];
    /**   Method "POINT_OF_SALE" only, this must be supplied and be stored in the PaymentTerminal table */
    sellDeviceId?: InputMaybe<Scalars['String']>;
};

export enum PaymentStatusEnum {
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    Initializing = 'INITIALIZING',
    Pending = 'PENDING',
    Provisional = 'PROVISIONAL',
}

export type Place = {
    __typename?: 'Place';
    id: Scalars['ID'];
    name: Scalars['String'];
    position: Scalars['Int'];
};

/**   Description of a POI and the distance to it from the parent object. */
export type PointOfInterest = {
    __typename?: 'PointOfInterest';
    /**   The distance in meters from the parent object to the POI (as the crow flies). */
    distance: Scalars['Int'];
    /**
     *   Name of the POI.
     *  This value is language dependent.
     */
    name: Scalars['String'];
};

export type PriceLine = {
    __typename?: 'PriceLine';
    category?: Maybe<PriceLineCategoryEnum>;
    label: Scalars['String'];
    quantity?: Maybe<Scalars['String']>;
    totalPrice: Scalars['Float'];
    unitPrice?: Maybe<Scalars['Float']>;
};

export enum PriceLineCategoryEnum {
    Accommodation = 'ACCOMMODATION',
    AdminCosts = 'ADMIN_COSTS',
    Charges = 'CHARGES',
    Insurance = 'INSURANCE',
    NotInTotal = 'NOT_IN_TOTAL',
    Special = 'SPECIAL',
    Surcharges = 'SURCHARGES',
}

export type PropertyFilterCount = {
    __typename?: 'PropertyFilterCount';
    hits: Scalars['Int'];
    property: Scalars['String'];
};

/**   Properties to filter by in a search query. */
export type PropertyFilterInput = {
    /**
     *   The handles of the properties to filter by.
     *  Multiples handles are combined as "OR".
     *  Be aware that when treating filters as "OR", the corresponding FilterBuckets in the result are essentially useless as possible values will be excluded based on already active filters.
     */
    properties: Array<Scalars['String']>;
};

export type Query = {
    __typename?: 'Query';
    /**   Retrieve details for a specific Accommodation. */
    accommodation?: Maybe<Accommodation>;
    /**   Retrieve details for a specific Accommodation by id. */
    accommodationById?: Maybe<Accommodation>;
    /**   Retrieve details for all Accommodations. */
    accommodations: Array<Accommodation>;
    /**   Retrieve details for a specific set of Accommodations. */
    accommodationsBySlug: Array<Accommodation>;
    /** Entries within the “Winactie” section. */
    actionEntries?: Maybe<Array<Maybe<ActionSectionEntryUnion>>>;
    /**   Search within all available Activities. */
    activities: ActivitySearchResult;
    /**   Retrieve details for a specific set of Activities. */
    activitiesBySlug: Array<Activity>;
    /**   Retrieve details for a specific Activity. */
    activity?: Maybe<Activity>;
    /**   Retrieve details for all available ActivityThemes. */
    activityThemes: Array<ActivityTheme>;
    /** Entries within the “Nieuws artikelen” section. */
    articlesEntries?: Maybe<Array<Maybe<ArticlesSectionEntryUnion>>>;
    /** This query is used to query for a single asset. */
    asset?: Maybe<AssetInterface>;
    /** This query is used to return the number of assets. */
    assetCount: Scalars['Int'];
    /** This query is used to query for assets. */
    assets?: Maybe<Array<Maybe<AssetInterface>>>;
    /** Entries within the “Banners” section. */
    bannersEntries?: Maybe<Array<Maybe<BannersSectionEntryUnion>>>;
    /**
     *   Preview the effects of altering a specific Booking.
     *  The booking must belong to the currently logged in Customer.
     */
    bookingAlterationPreview?: Maybe<BookingChangePreview>;
    /**
     *   Preview the effects of cancelling a specific Booking.
     *  The booking must belong to the currently logged in Customer.
     */
    bookingCancellationPreview?: Maybe<BookingChangePreview>;
    /**   Retrieve details for a specific Cart. */
    cart?: Maybe<Cart>;
    /**   Search within all available Companies. */
    companies: CompanySearchResult;
    /**   Retrieve details for a specific set of Companies. */
    companiesBySlug: Array<Company>;
    /** Entries within the “Bedrijven” section. */
    companiesEntries?: Maybe<Array<Maybe<CompaniesSectionEntryUnion>>>;
    /** Single entry within the “Bedrijven” section. */
    companiesEntry?: Maybe<CompaniesSectionEntryUnion>;
    /**   Retrieve details for a specific Company. */
    company?: Maybe<Company>;
    /**   Retrieve details for all available CompanyCategories. */
    companyCategories: Array<CompanyCategory>;
    /** Entries within the “Contact” section. */
    contactEntries?: Maybe<Array<Maybe<ContactSectionEntryUnion>>>;
    /** Single entry within the “Contact” section. */
    contactEntry?: Maybe<ContactSectionEntryUnion>;
    /** Entries within the “Contact” Matrix field. */
    contactMatrixFieldEntries?: Maybe<Array<Maybe<ContactMatrixFieldEntryUnion>>>;
    /** Entries within the “Content” Matrix field. */
    contentMatrixFieldEntries?: Maybe<Array<Maybe<ContentMatrixFieldEntryUnion>>>;
    /** This query is used to query for entries. */
    entries?: Maybe<Array<Maybe<EntryInterface>>>;
    /** This query is used to query for a single entry. */
    entry?: Maybe<EntryInterface>;
    /** This query is used to return the number of entries. */
    entryCount: Scalars['Int'];
    /** Entries within the “Evenementen” section. */
    eventsEntries?: Maybe<Array<Maybe<EventsSectionEntryUnion>>>;
    /** Single entry within the “Evenementen” section. */
    eventsEntry?: Maybe<EventsSectionEntryUnion>;
    /** Entries within the “Excursies” section. */
    excursionsEntries?: Maybe<Array<Maybe<ExcursionsSectionEntryUnion>>>;
    /** Single entry within the “Excursies” section. */
    excursionsEntry?: Maybe<ExcursionsSectionEntryUnion>;
    /** Entries within the “Externe link” section. */
    externalSiteLinkEntries?: Maybe<Array<Maybe<ExternalSiteLinkSectionEntryUnion>>>;
    /** Entries within the “Footer” section. */
    footerEntries?: Maybe<Array<Maybe<FooterSectionEntryUnion>>>;
    /** This query is used to query for a single form. */
    formieForm?: Maybe<FormInterface>;
    /** This query is used to return the number of forms. */
    formieFormCount: Scalars['Int'];
    /** This query is used to query for forms. */
    formieForms?: Maybe<Array<Maybe<FormInterface>>>;
    /** Search within both CMS and Travelbase content. */
    globalSearch?: Maybe<SearchResult>;
    /** This query is used to query for a single global set. */
    globalSet?: Maybe<GlobalSetInterface>;
    /** This query is used to query for global sets. */
    globalSets?: Maybe<Array<Maybe<GlobalSetInterface>>>;
    /** Entries within the “Home” section. */
    homepageEntries?: Maybe<Array<Maybe<HomepageSectionEntryUnion>>>;
    /** Single entry within the “Home” section. */
    homepageEntry?: Maybe<HomepageSectionEntryUnion>;
    /** Entries within the “Menu” section. */
    menuEntries?: Maybe<Array<Maybe<MenuSectionEntryUnion>>>;
    /** Entries within the “Gastomgeving” section. */
    myTerschellingEntries?: Maybe<Array<Maybe<MyTerschellingSectionEntryUnion>>>;
    /** Single entry within the “Gastomgeving” section. */
    myTerschellingEntry?: Maybe<MyTerschellingSectionEntryUnion>;
    /** Entries within the “Nieuws overzicht” section. */
    newsEntries?: Maybe<Array<Maybe<NewsSectionEntryUnion>>>;
    /** Single entry within the “Nieuws overzicht” section. */
    newsEntry?: Maybe<NewsSectionEntryUnion>;
    /**   Retrieve details for a specific Order. */
    order?: Maybe<Order>;
    /** Entries within the “Pagina's” section. */
    pagesEntries?: Maybe<Array<Maybe<PagesSectionEntryUnion>>>;
    ping?: Maybe<Scalars['String']>;
    /**   Retrieve details for all available Places. */
    places: Array<Place>;
    /**   Retrieve details for a specific RentalUnit. */
    rentalUnit?: Maybe<RentalUnit>;
    /**   Retrieve details for a specific RentalUnit by id. */
    rentalUnitById?: Maybe<RentalUnit>;
    /**   Retrieve details for a specific set of RentalUnits. */
    rentalUnits: Array<RentalUnit>;
    /**
     * This query is used to query for Retour redirects.
     * @deprecated This query is deprecated and will be removed in the future. You should use `retourResolveRedirect` instead.
     */
    retour?: Maybe<RetourInterface>;
    /** This query is used to query for all Retour redirects for a site. */
    retourRedirects?: Maybe<Array<Maybe<RetourInterface>>>;
    /** This query is used to query for Retour redirects. */
    retourResolveRedirect?: Maybe<RetourInterface>;
    /**
     * This query is used to search for keywords.
     * @deprecated Limited and contains bugs, use `globalSearch` instead.
     */
    search?: Maybe<Array<Maybe<SearchType>>>;
    /** Entries within the “Zoeken” section. */
    searchEntries?: Maybe<Array<Maybe<SearchSectionEntryUnion>>>;
    /** Single entry within the “Zoeken” section. */
    searchEntry?: Maybe<SearchSectionEntryUnion>;
    /**   Search within all available RentalUnits. */
    searchRentalUnits: SearchRentalUnitsResult;
    /**
     *   Search for available Trips.
     *  Note that this will only ever return and/or count 1 Trip per RentalUnit, even if multiple Trips for the same RentalUnit match the search parameters.
     */
    searchTrips: SearchTripsResult;
    /** Entries within the “Bezienswaardigheden” section. */
    sightsEntries?: Maybe<Array<Maybe<SightsSectionEntryUnion>>>;
    /** Single entry within the “Bezienswaardigheden” section. */
    sightsEntry?: Maybe<SightsSectionEntryUnion>;
    /**   Retrieve details for a specific Special. */
    special?: Maybe<Special>;
    /** This query is used to query for a single tag. */
    tag?: Maybe<TagInterface>;
    /** This query is used to return the number of tags. */
    tagCount: Scalars['Int'];
    /** This query is used to query for tags. */
    tags?: Maybe<Array<Maybe<TagInterface>>>;
    /** Entries within the “Bedankt” section. */
    thankYouEntries?: Maybe<Array<Maybe<ThankYouSectionEntryUnion>>>;
    /** Single entry within the “Bedankt” section. */
    thankYouEntry?: Maybe<ThankYouSectionEntryUnion>;
    /** Entries within the “Tips” section. */
    tipsEntries?: Maybe<Array<Maybe<TipsSectionEntryUnion>>>;
    /** This query is used to get all the accommodations for the sitemap. */
    travelbaseObjectsSitemap?: Maybe<Array<Maybe<TravelbaseObjectsSitemapType>>>;
    /**   Retrieve all possible properties by which RentalUnits can be filtered. */
    unitFilterProperties: Array<UnitFilterPropertyCategory>;
    /** @deprecated Use searchRentalUnits or searchTrips instead */
    unitSearch: UnitSearchResult;
    /** @deprecated Use searchTrips.stats.dateCounts instead */
    unitSearchAlternativeDates: Array<DateHitCount>;
    /**   Returns the currently logged in Customer, if any. */
    viewer?: Maybe<Customer>;
};

export type QueryAccommodationArgs = {
    slug: Scalars['String'];
};

export type QueryAccommodationByIdArgs = {
    id: Scalars['ID'];
};

export type QueryAccommodationsArgs = {
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    query: Scalars['String'];
};

export type QueryAccommodationsBySlugArgs = {
    slugs: Array<Scalars['String']>;
};

export type QueryActionEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryActivitiesArgs = {
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    order?: InputMaybe<ActivitySearchOrderEnum>;
    params: ActivitySearchParamsInput;
};

export type QueryActivitiesBySlugArgs = {
    slugs: Array<Scalars['String']>;
};

export type QueryActivityArgs = {
    slug: Scalars['String'];
};

export type QueryArticlesEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAssetArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryAssetCountArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryAssetsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryBannersEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryBookingAlterationPreviewArgs = {
    input: AlterBookingInput;
};

export type QueryBookingCancellationPreviewArgs = {
    input: CancelBookingInput;
};

export type QueryCartArgs = {
    id: Scalars['ID'];
};

export type QueryCompaniesArgs = {
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    params: CompanySearchParamsInput;
    sortByDistanceTo?: InputMaybe<LatLonInput>;
};

export type QueryCompaniesBySlugArgs = {
    slugs: Array<Scalars['String']>;
};

export type QueryCompaniesEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCompaniesEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCompanyArgs = {
    slug: Scalars['String'];
};

export type QueryContactEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryContactEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryContactMatrixFieldEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryContentMatrixFieldEntriesArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEntriesArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEntryArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEntryCountArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEventsEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEventsEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryExcursionsEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryExcursionsEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryExternalSiteLinkEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryFooterEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryFormieFormArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type QueryFormieFormCountArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type QueryFormieFormsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGlobalSearchArgs = {
    language: Scalars['String'];
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    query: Scalars['String'];
    type?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGlobalSetArgs = {
    active?: InputMaybe<Scalars['Boolean']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactEmailText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactMessengerText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactMyTerschellingText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactPhoneText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactShopText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactWhatsappText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryGlobalSetsArgs = {
    active?: InputMaybe<Scalars['Boolean']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactEmailText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactMessengerText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactMyTerschellingText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactPhoneText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactShopText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    contactWhatsappText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryHomepageEntriesArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryHomepageEntryArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryMenuEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryMyTerschellingEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryMyTerschellingEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryNewsEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryNewsEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryOrderArgs = {
    id: Scalars['ID'];
};

export type QueryPagesEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryRentalUnitArgs = {
    slug: Scalars['String'];
};

export type QueryRentalUnitByIdArgs = {
    id: Scalars['ID'];
};

export type QueryRentalUnitsArgs = {
    slugs: Array<Scalars['String']>;
};

export type QueryRetourArgs = {
    site?: InputMaybe<Scalars['String']>;
    siteId?: InputMaybe<Scalars['Int']>;
    uri?: InputMaybe<Scalars['String']>;
};

export type QueryRetourRedirectsArgs = {
    site?: InputMaybe<Scalars['String']>;
    siteId?: InputMaybe<Scalars['Int']>;
};

export type QueryRetourResolveRedirectArgs = {
    site?: InputMaybe<Scalars['String']>;
    siteId?: InputMaybe<Scalars['Int']>;
    uri?: InputMaybe<Scalars['String']>;
};

export type QuerySearchArgs = {
    language?: InputMaybe<Scalars['String']>;
    q?: InputMaybe<Scalars['String']>;
    size?: InputMaybe<Scalars['Int']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QuerySearchEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySearchEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySearchRentalUnitsArgs = {
    accommodationId?: InputMaybe<Scalars['String']>;
    babies?: InputMaybe<Scalars['Int']>;
    filters?: InputMaybe<Array<PropertyFilterInput>>;
    limit?: InputMaybe<Scalars['Int']>;
    mapArea?: InputMaybe<BoundingBoxInput>;
    offset?: InputMaybe<Scalars['Int']>;
    order?: InputMaybe<SearchRentalUnitsOrderEnum>;
    persons?: InputMaybe<Scalars['Int']>;
    pets?: InputMaybe<Scalars['Int']>;
};

export type QuerySearchTripsArgs = {
    babies: Scalars['Int'];
    date: Array<Scalars['String']>;
    duration: Array<Scalars['Int']>;
    filters?: InputMaybe<Array<PropertyFilterInput>>;
    mapArea?: InputMaybe<BoundingBoxInput>;
    persons: Scalars['Int'];
    pets: Scalars['Int'];
    price?: InputMaybe<RangeFilterInput>;
    specialId?: InputMaybe<Array<Scalars['ID']>>;
    tripType?: InputMaybe<Array<TripTypeEnum>>;
};

export type QuerySightsEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySightsEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySpecialArgs = {
    id: Scalars['ID'];
};

export type QueryTagArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryTagCountArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryThankYouEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryThankYouEntryArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryTipsEntriesArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QueryTravelbaseObjectsSitemapArgs = {
    language?: InputMaybe<Scalars['String']>;
    size?: InputMaybe<Scalars['Int']>;
};

export type QueryUnitSearchArgs = {
    limit?: InputMaybe<Scalars['Int']>;
    mapArea?: InputMaybe<BoundingBoxInput>;
    offset?: InputMaybe<Scalars['Int']>;
    order?: InputMaybe<UnitSearchOrderEnum>;
    params: UnitSearchParamsInput;
};

export type QueryUnitSearchAlternativeDatesArgs = {
    params: UnitAndTripSearchParamsInput;
};

export type RangeFilterInput = {
    max?: InputMaybe<Scalars['Float']>;
    min?: InputMaybe<Scalars['Float']>;
};

export type Rate = {
    __typename?: 'Rate';
    id: Scalars['ID'];
    /**   This value is language dependent. */
    name: Scalars['String'];
    position: Scalars['Int'];
    price: Scalars['Float'];
};

export type RegisterInput = {
    agreedToTerms: Scalars['Boolean'];
    email: Scalars['String'];
    landingUrl: Scalars['String'];
    newsletterOptIn: Scalars['Boolean'];
    registerSource: Scalars['String'];
};

export type RegisterPayload = {
    __typename?: 'RegisterPayload';
    customer?: Maybe<Customer>;
};

export type RemoveFavoriteInput = {
    favoriteId: Scalars['ID'];
};

export type RemoveFavoritePayload = {
    __typename?: 'RemoveFavoritePayload';
    success: Scalars['Boolean'];
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnit = {
    __typename?: 'RentalUnit';
    /**   The Accommodation this RentalUnit is a part of. */
    accommodation: Accommodation;
    /**   Search for Trips in other RentalUnits within the same Accommodation. */
    alternativesInAccommodation?: Maybe<UnitSearchResult>;
    /**   The amount of bathrooms present in this RentalUnit. */
    amountBathrooms?: Maybe<Scalars['Int']>;
    /**   The amount of bedrooms present in this RentalUnit. */
    amountBedrooms?: Maybe<Scalars['Int']>;
    /**   The amount of beds present in this RentalUnit. */
    amountBeds?: Maybe<Scalars['Int']>;
    /**   The amount of toilets present in this RentalUnit. */
    amountToilets?: Maybe<Scalars['Int']>;
    /**   The attributes assigned to this RentalUnit, organized into categories. */
    attributeCategories: Array<AttributeCategory>;
    /**   Indicates the Travelbase brand this RentalUnit belongs to (used on aggregate sites). */
    brand: Scalars['String'];
    /**   Whether or not cancellation insurance can be purchased during checkout for this RentalUnit. */
    cancellationInsuranceAvailable: Scalars['Boolean'];
    /**   A canonical url for this RentalUnit */
    canonicalUrl?: Maybe<Scalars['String']>;
    /**   Unique code representing this RentalUnit to facilitate communication with partners and customers. */
    code: Scalars['String'];
    /**   Whether or not contents insurance can be purchased during checkout for this RentalUnit. */
    contentsInsuranceAvailable: Scalars['Boolean'];
    /**
     *   An optional description of features unique to this RentalUnit.
     *  This value is language dependent.
     */
    descriptionExtras?: Maybe<Scalars['String']>;
    /**
     *   A general description of the RentalUnit, describing its layout.
     *  This value is language dependent.
     */
    descriptionLayout: Scalars['String'];
    /**
     *   A text containing important information for any (prospective) guests.
     *  This information is also displayed on the booking voucher.
     *  This value is language dependent.
     */
    descriptionParticulars?: Maybe<Scalars['String']>;
    /**
     *   The first date for which a Trip is available, if any.
     *  Formatted as yyyy-mm-dd.
     */
    firstTripDate?: Maybe<Scalars['String']>;
    /**   If set, bookings for this RentalUnit can be cancelled with full refund up to this many days before arrival. */
    flexCancellationDays?: Maybe<Scalars['Int']>;
    /**   A URL for an embeddable 3D view of the RentalUnit. */
    fullCircleImageUrl?: Maybe<Scalars['String']>;
    /**   Way to check if this RentalUnit matches a specific filter property. */
    hasFilterProperty: Scalars['Boolean'];
    /**   Unique ID representing this RentalUnit. */
    id: Scalars['ID'];
    /**   A set of images intended to be displayed as some form of photo gallery. */
    images: Array<AccommodationImage>;
    /**   An image (photo) intended for use in a listing/as a thumbnail. */
    listImage: GenericImage;
    /**   The living area (in square meters) of the RentalUnit. */
    livingArea?: Maybe<Scalars['Int']>;
    /**   An image (photo) intended for use in a large (hero) display. */
    mainImage?: Maybe<GenericImage>;
    /**   The maximum amount of babies that may be brought along without counting against the occupancy and without being charged as an occupant. */
    maxExtraBabyOccupancy?: Maybe<Scalars['Int']>;
    /**   The maximum travel party size for which this RentalUnit can be booked. */
    maxOccupancy: Scalars['Int'];
    /**   The minimum travel party size for which this RentalUnit can be booked. */
    minOccupancy: Scalars['Int'];
    /**   The municipal registration number for this RentalUnit. */
    municipalRegistration?: Maybe<Scalars['String']>;
    /**   The name of this RentalUnit. */
    name: Scalars['String'];
    /**   The outdoor area (in square meters) private to the RentalUnit. */
    outdoorArea?: Maybe<Scalars['Int']>;
    /**   The amount of pets allowed in this RentalUnit. */
    petsAllowed: Scalars['Int'];
    /**
     *   Search for alternative RentalUnits given the specified search parameters.
     *  Alternatives will always have the same `type` and `maxOccupancy`, and will prioritize similar `livingArea` and geographic location.
     */
    relevantAlternatives?: Maybe<UnitSearchResult>;
    /**   A summary of the reviews for this RentalUnit. */
    reviewStats?: Maybe<ReviewStats>;
    /**   The reviews submitted by past guests for this RentalUnit. */
    reviews: Array<Review>;
    /**   Unique slug to represent this RentalUnit, most commonly in URLs. */
    slug: Scalars['String'];
    /**   The surcharges valid on the specified arrival date, or today if no date is submitted. */
    surcharges: Array<RentalUnitSurcharge>;
    /**
     *   This is a short "marketing-oriented" description used as a display title.
     *  This value is language dependent.
     */
    tagline: Scalars['String'];
    /**   Search within available Trips for this RentalUnit in a specific time period. */
    trips: Array<Trip>;
    /**   The type of this RentalUnit. */
    type: RentalUnitTypeEnum;
    /**   A URL for an embeddable video presenting the RentalUnit. */
    videoUrl?: Maybe<Scalars['String']>;
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnitAlternativesInAccommodationArgs = {
    params?: InputMaybe<UnitSearchParamsInput>;
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnitHasFilterPropertyArgs = {
    handle: Scalars['String'];
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnitRelevantAlternativesArgs = {
    params?: InputMaybe<UnitSearchParamsInput>;
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnitReviewsArgs = {
    limit: Scalars['Int'];
    offset?: InputMaybe<Scalars['Int']>;
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnitSurchargesArgs = {
    arrivalDate?: InputMaybe<Scalars['String']>;
};

/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
export type RentalUnitTripsArgs = {
    babies: Scalars['Int'];
    endDate: Scalars['String'];
    persons: Scalars['Int'];
    pets: Scalars['Int'];
    startDate: Scalars['String'];
};

export type RentalUnitSurcharge = {
    __typename?: 'RentalUnitSurcharge';
    calculation: SurchargeCalculationEnum;
    /**   This value is language dependent. */
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    maxAmount: Scalars['Int'];
    minAmount: Scalars['Int'];
    /**   This value is language dependent. */
    name: Scalars['String'];
    unitPrice: Scalars['Float'];
};

/**   Types of RentalUnit. */
export enum RentalUnitTypeEnum {
    Bed = 'BED',
    Boat = 'BOAT',
    CamperSpot = 'CAMPER_SPOT',
    CampingPitch = 'CAMPING_PITCH',
    Home = 'HOME',
    Room = 'ROOM',
    Tent = 'TENT',
}

/** This is the interface implemented by Retour. */
export type RetourInterface = {
    /** The id of the Element associated with this redirect (unused/vestigial). */
    associatedElementId?: Maybe<Scalars['Int']>;
    /** Whether the redirect is enabled or not. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The number of times this redirect has been hit. */
    hitCount?: Maybe<Scalars['Int']>;
    /** A datetime string of when this redirect was last hit. */
    hitLastTime?: Maybe<Scalars['String']>;
    /** The id of the redirect. */
    id?: Maybe<Scalars['Int']>;
    /** The URL that should be redirected to. */
    redirectDestUrl?: Maybe<Scalars['String']>;
    /** The http status code that should be used for the redirect. */
    redirectHttpCode?: Maybe<Scalars['Int']>;
    /** Whether an `exactmatch` or `regexmatch` should be used when matching the URL. */
    redirectMatchType?: Maybe<Scalars['String']>;
    /** Should the legacy URL be matched by path or by full URL? */
    redirectSrcMatch?: Maybe<Scalars['String']>;
    /** The unparsed URL pattern that Retour should match. */
    redirectSrcUrl?: Maybe<Scalars['String']>;
    /** The parsed URL pattern that Retour should match. */
    redirectSrcUrlParsed?: Maybe<Scalars['String']>;
    /** The site handle of the redirect (or null for all sites). */
    site?: Maybe<Scalars['String']>;
    /** The siteId of the redirect (0 or null for all sites). */
    siteId?: Maybe<Scalars['Int']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
};

/** This entity has all the Retour fields */
export type RetourType = RetourInterface & {
    __typename?: 'RetourType';
    /** The id of the Element associated with this redirect (unused/vestigial). */
    associatedElementId?: Maybe<Scalars['Int']>;
    /** Whether the redirect is enabled or not. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The number of times this redirect has been hit. */
    hitCount?: Maybe<Scalars['Int']>;
    /** A datetime string of when this redirect was last hit. */
    hitLastTime?: Maybe<Scalars['String']>;
    /** The id of the redirect. */
    id?: Maybe<Scalars['Int']>;
    /** The URL that should be redirected to. */
    redirectDestUrl?: Maybe<Scalars['String']>;
    /** The http status code that should be used for the redirect. */
    redirectHttpCode?: Maybe<Scalars['Int']>;
    /** Whether an `exactmatch` or `regexmatch` should be used when matching the URL. */
    redirectMatchType?: Maybe<Scalars['String']>;
    /** Should the legacy URL be matched by path or by full URL? */
    redirectSrcMatch?: Maybe<Scalars['String']>;
    /** The unparsed URL pattern that Retour should match. */
    redirectSrcUrl?: Maybe<Scalars['String']>;
    /** The parsed URL pattern that Retour should match. */
    redirectSrcUrlParsed?: Maybe<Scalars['String']>;
    /** The site handle of the redirect (or null for all sites). */
    site?: Maybe<Scalars['String']>;
    /** The siteId of the redirect (0 or null for all sites). */
    siteId?: Maybe<Scalars['Int']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
};

/**   A review of a RentalUnit submitted by a Customer. */
export type Review = {
    __typename?: 'Review';
    /** @deprecated No longer supported */
    anonymous?: Maybe<Scalars['Boolean']>;
    /**   The average of the specific ratings given. */
    average: Scalars['Float'];
    /**   The city the Customer is from. */
    city?: Maybe<Scalars['String']>;
    /**   The main text submitted by the Customer. */
    comment: Scalars['String'];
    /**
     *   The date this Review was submitted.
     *  Formatted as yyyy-mm-dd.
     */
    date: Scalars['String'];
    /** @deprecated No longer supported */
    displayName?: Maybe<Scalars['String']>;
    /**   Unique ID representing this Review. */
    id: Scalars['ID'];
    /**
     *   The language in which this Review was written.
     *  This is a 2-letter language code.
     */
    language?: Maybe<Scalars['String']>;
    /**   Rating (1-10) of the hospitality provided. */
    ratingHospitality?: Maybe<Scalars['Int']>;
    /**   Rating (1-10) of the RentalUnit's layout. */
    ratingLayout?: Maybe<Scalars['Int']>;
    /**   Rating (1-10) of the location of the Accommodation. */
    ratingLocation?: Maybe<Scalars['Int']>;
    /**   Rating (1-10) of the level of maintenance. */
    ratingMaintenance?: Maybe<Scalars['Int']>;
    /**   Rating (1-10) of value for money. */
    ratingValueForMoney?: Maybe<Scalars['Int']>;
    /**   The reply to this review submitted by the Partner, if any. */
    reply?: Maybe<Scalars['String']>;
    /**
     *   Tips the Customer submitted for the Partner, if any.
     *  This field is not publicly visible, only logged in Customers can see this for the Reviews they submitted themselves.
     */
    tips?: Maybe<Scalars['String']>;
    /**   The title/short summary the Customer submitted. */
    title: Scalars['String'];
    /**
     *   The type of travel group this Customer visited the RentalUnit with.
     *  This field is not publicly visible, only logged in Customers can see this for the Reviews they submitted themselves.
     */
    travelGroupType?: Maybe<TravelGroupType>;
};

/**   Summary of the Reviews submitted. */
export type ReviewStats = {
    __typename?: 'ReviewStats';
    /**   The average of all ratings across all Reviews. */
    average: Scalars['Float'];
    /**   Amount of Reviews available. */
    count: Scalars['Int'];
    /**   The average of the `hospitality` ratings across all Reviews. */
    hospitality: Scalars['Float'];
    /**   The average of the `layout` ratings across all Reviews. */
    layout: Scalars['Float'];
    /**   The average of the `location` ratings across all Reviews. */
    location: Scalars['Float'];
    /**   The average of the `maintenance` ratings across all Reviews. */
    maintenance: Scalars['Float'];
    /**   The average of the `valueForMoney` ratings across all Reviews. */
    valueForMoney: Scalars['Float'];
};

/** This is the interface implemented by all rows. */
export type RowInterface = {
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The row’s fields. */
    rowFields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all rows. */
export type RowInterfaceRowFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type RowType = RowInterface & {
    __typename?: 'RowType';
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The row’s fields. */
    rowFields?: Maybe<Array<Maybe<FieldInterface>>>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
};

export type RowTypeRowFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type SearchImage = {
    __typename?: 'SearchImage';
    /** The image's extension */
    extension?: Maybe<Scalars['String']>;
    /** The image's placeholderUrl */
    placeholderUrl?: Maybe<Scalars['String']>;
    /** The image's srcset */
    srcset?: Maybe<Scalars['String']>;
    /** The image's srcsetWebp */
    srcsetWebp?: Maybe<Scalars['String']>;
    /** The image's title */
    title?: Maybe<Scalars['String']>;
    /** The image's url */
    url?: Maybe<Scalars['String']>;
};

/**   RentalUnit search result ordering options. */
export enum SearchRentalUnitsOrderEnum {
    /**
     *  Randomize order.
     * # The random seed used is the current date, so the order will be identical between pageloads and between users, but change daily.
     */
    RandomBoosted = 'RANDOM_BOOSTED',
    /**  Sort by amount of recent bookings. */
    RecentBookingsBoosted = 'RECENT_BOOKINGS_BOOSTED',
    /**  Sort by average RentalUnit review rating, descending. */
    ReviewRatingDesc = 'REVIEW_RATING_DESC',
}

/**   Results of a RentalUnit search query. */
export type SearchRentalUnitsResult = {
    __typename?: 'SearchRentalUnitsResult';
    /**   Available filter properties and corresponding result counts excluding accomodation type filters. */
    excludeFilterCounts: Array<ExcludeFilterCount>;
    /**   The search results. */
    hits: Array<RentalUnit>;
    /**   Available filter properties and corresponding result counts within the result set. */
    propertyFilterCounts: Array<PropertyFilterCount>;
    /**   Total amount of matching RentalUnits. */
    totalHits: Scalars['Int'];
};

export type SearchResult = {
    __typename?: 'SearchResult';
    hits?: Maybe<Array<Maybe<SearchType>>>;
    totalHits?: Maybe<Scalars['Int']>;
    typeCounts?: Maybe<Array<Maybe<Bucket>>>;
};

export type SearchTermOptions = {
    exact?: InputMaybe<Scalars['Boolean']>;
    exclude?: InputMaybe<Scalars['Boolean']>;
    subLeft?: InputMaybe<Scalars['Boolean']>;
    subRight?: InputMaybe<Scalars['Boolean']>;
};

/**   The results of a search within Trips. */
export type SearchTripsResult = {
    __typename?: 'SearchTripsResult';
    /**   Fetch Trips matching the specified parameters. */
    hits: Array<Trip>;
    /**   Statistical information about the Trips matching the specified parameters. */
    stats: SearchTripsStats;
};

/**   The results of a search within Trips. */
export type SearchTripsResultHitsArgs = {
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    order?: InputMaybe<UnitSearchOrderEnum>;
};

/**   Statistics for a specific search whitin Trips. */
export type SearchTripsStats = {
    __typename?: 'SearchTripsStats';
    /**
     *   List of dates and the respective amount of Trips found for that date.
     *  Only useful in case the search parameters contain multiple dates. Any date with 0 Trips found will not appear in this result.
     */
    dateCounts: Array<DateCount>;
    /**   Available filter properties and corresponding result counts excluding accomodation type filters. */
    excludeFilterCounts: Array<ExcludeFilterCount>;
    /**   The highest price among the Trips found. */
    maxPrice?: Maybe<Scalars['Float']>;
    /**   The lowest price among the Trips found. */
    minPrice?: Maybe<Scalars['Float']>;
    /**   List of filter properties and the respective amount of Trips found. */
    propertyFilterCounts: Array<PropertyFilterCount>;
    /**   List of Specials and the respective amount of Trips found for that Special. */
    specialCounts: Array<SpecialCount>;
    /**   The total amount of Trips found. */
    totalHits: Scalars['Int'];
    /**   List of TripTypes and the respective amount of Trips found for that TripType. */
    tripTypeCounts: Array<TripTypeCount>;
};

export type SearchType = {
    __typename?: 'SearchType';
    /** The document's image */
    image?: Maybe<SearchImage>;
    /** The document's language */
    language?: Maybe<Scalars['String']>;
    /** The document's post date */
    postDate?: Maybe<Scalars['String']>;
    /** The document's tags */
    tags?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The document's title */
    title?: Maybe<Scalars['String']>;
    /** The document's type */
    type?: Maybe<Scalars['String']>;
    /** The document's uri */
    uri?: Maybe<Scalars['String']>;
};

export type SendAuthenticationEmailInput = {
    email: Scalars['String'];
    landingUrl: Scalars['String'];
};

export type SendAuthenticationEmailPayload = {
    __typename?: 'SendAuthenticationEmailPayload';
    success?: Maybe<Scalars['Boolean']>;
};

export type Special = {
    __typename?: 'Special';
    /**   This value is language dependent. */
    description: Scalars['String'];
    id: Scalars['ID'];
    landingPageUrl?: Maybe<Scalars['String']>;
    /**   This value is language dependent. */
    name: Scalars['String'];
};

export type SpecialCount = {
    __typename?: 'SpecialCount';
    hits: Scalars['Int'];
    special: Special;
};

export type SpecialOperatingHours = {
    __typename?: 'SpecialOperatingHours';
    endDate: Scalars['String'];
    friday?: Maybe<Array<TimeOpenClosed>>;
    monday?: Maybe<Array<TimeOpenClosed>>;
    saturday?: Maybe<Array<TimeOpenClosed>>;
    startDate: Scalars['String'];
    sunday?: Maybe<Array<TimeOpenClosed>>;
    thursday?: Maybe<Array<TimeOpenClosed>>;
    tuesday?: Maybe<Array<TimeOpenClosed>>;
    wednesday?: Maybe<Array<TimeOpenClosed>>;
};

export enum SurchargeCalculationEnum {
    PerPerson = 'PER_PERSON',
    PerPersonPerNight = 'PER_PERSON_PER_NIGHT',
    PerPet = 'PER_PET',
    PerPetPerNight = 'PER_PET_PER_NIGHT',
    PerPiece = 'PER_PIECE',
    PerPiecePerNight = 'PER_PIECE_PER_NIGHT',
    Subsequent = 'SUBSEQUENT',
}

/** This is the interface implemented by all tags. */
export type TagInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The handle of the group that contains the tag. */
    groupHandle: Scalars['String'];
    /** The ID of the group that contains the tag. */
    groupId: Scalars['Int'];
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all tags. */
export type TagInterface_CountArgs = {
    field: Scalars['String'];
};

export type TagRelationCriteriaInput = {
    /** Narrows the query results to only elements that have been archived. */
    archived?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ creation dates. */
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ last-updated dates. */
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Causes the query results to be returned in the order specified by the `id` argument. */
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the tag groups the tags belong to per the group’s handles. */
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the tag groups the tags belong to, per the groups’ IDs. */
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ IDs. */
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Causes the query results to be returned in reverse order. */
    inReverse?: InputMaybe<Scalars['Boolean']>;
    /** Determines which site(s) the elements should be queried in, based on their language. */
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Sets the limit for paginated results. */
    limit?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to elements that do not relate to the provided element IDs. */
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Sets the offset for paginated results. */
    offset?: InputMaybe<Scalars['Int']>;
    /** Sets the field the returned elements should be ordered by. */
    orderBy?: InputMaybe<Scalars['String']>;
    /** Determines which site should be selected when querying multi-site elements. */
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on a reference string. */
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to an asset list defined with this argument. */
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a category list defined with this argument. */
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to an entry list defined with this argument. */
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a tag list defined with this argument. */
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a use list defined with this argument. */
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    /** Narrows the relations based on the field they were created in. */
    relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the relations based on the site they were created in. */
    relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that match a search query. */
    search?: InputMaybe<Scalars['String']>;
    /** Defines the default options that should be applied terms within the `search` argument. */
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the unique identifier for an element-site relation. */
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ slugs. */
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ statuses. */
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ titles. */
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that have been soft-deleted. */
    trashed?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ UIDs. */
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines whether only elements with unique IDs should be returned by the query. */
    unique?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ URIs. */
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TargetAudienceAggregationCount = {
    __typename?: 'TargetAudienceAggregationCount';
    hits: Scalars['Int'];
    value: TargetAudienceEnum;
};

/**   Available target audience options. */
export enum TargetAudienceEnum {
    Adults = 'ADULTS',
    AllAges = 'ALL_AGES',
    Children = 'CHILDREN',
    Pets = 'PETS',
    WheelchairAccessible = 'WHEELCHAIR_ACCESSIBLE',
}

export type Ticket = OrderItem & {
    __typename?: 'Ticket';
    activity?: Maybe<Activity>;
    activityReview?: Maybe<ActivityReview>;
    downloadVoucherUrl?: Maybe<Scalars['String']>;
    endDateTime: Scalars['String'];
    errors: Array<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    paymentPrice: Scalars['Float'];
    priceLines: Array<PriceLine>;
    rateLines: Array<TicketRateLine>;
    startDateTime: Scalars['String'];
    status: TicketStatus;
    timeslot?: Maybe<Timeslot>;
    totalPrice: Scalars['Float'];
};

export type TicketCartItemInput = {
    rateLines: Array<TicketRateLineInput>;
    timeslotId: Scalars['ID'];
};

export type TicketRateLine = {
    __typename?: 'TicketRateLine';
    amount: Scalars['Int'];
    rateId?: Maybe<Scalars['ID']>;
    totalPrice: Scalars['Float'];
    unitPrice: Scalars['Float'];
};

export type TicketRateLineInput = {
    amount: Scalars['Int'];
    rateId: Scalars['ID'];
};

export enum TicketStatus {
    Accepted = 'ACCEPTED',
    Init = 'INIT',
    Waived = 'WAIVED',
}

export type TimeOpenClosed = {
    __typename?: 'TimeOpenClosed';
    timeClosed: Scalars['String'];
    timeOpen: Scalars['String'];
};

export type Timeslot = {
    __typename?: 'Timeslot';
    /**   If `null`, unlimited tickets are available */
    allotment?: Maybe<Scalars['Int']>;
    /**   Formatted as yyyy-mm-dd HH:MM */
    endDateTime: Scalars['String'];
    id: Scalars['ID'];
    label?: Maybe<Scalars['String']>;
    rateGroup?: Maybe<ActivityRateGroup>;
    /**   Formatted as yyyy-mm-dd HH:MM */
    startDateTime: Scalars['String'];
};

export type TravelGroupInput = {
    amountAdults: Scalars['Int'];
    amountBabies: Scalars['Int'];
    amountChildren: Scalars['Int'];
    amountPets: Scalars['Int'];
    amountYouths: Scalars['Int'];
};

export enum TravelGroupType {
    Alone = 'ALONE',
    BusinessTrip = 'BUSINESS_TRIP',
    FamilyWithOlderChildren = 'FAMILY_WITH_OLDER_CHILDREN',
    FamilyWithYoungChildren = 'FAMILY_WITH_YOUNG_CHILDREN',
    GroupOfFriends = 'GROUP_OF_FRIENDS',
    GroupTrip = 'GROUP_TRIP',
    OlderCouple = 'OLDER_COUPLE',
    YoungCouple = 'YOUNG_COUPLE',
}

export type TravelbaseObjectsSitemapType = {
    __typename?: 'TravelbaseObjectsSitemapType';
    /** The document's image */
    image?: Maybe<SearchImage>;
    /** The document's url */
    url?: Maybe<Scalars['String']>;
};

export type Trip = {
    __typename?: 'Trip';
    date: Scalars['String'];
    duration: Scalars['Int'];
    originalPrice?: Maybe<Scalars['Float']>;
    price: Scalars['Float'];
    rentalUnit: RentalUnit;
    special?: Maybe<Special>;
    specialId?: Maybe<Scalars['ID']>;
    type: TripTypeEnum;
};

export type TripTypeCount = {
    __typename?: 'TripTypeCount';
    hits: Scalars['Int'];
    tripType: TripTypeEnum;
};

/**   Available types of Trip. */
export enum TripTypeEnum {
    /**  Rate including an early booking discount. */
    EarlyBooking = 'EARLY_BOOKING',
    /**  Rate including a last minute discount. */
    LastMinute = 'LAST_MINUTE',
    /**  The regular rate. */
    Regular = 'REGULAR',
    /**  Rate including a Special. */
    Special = 'SPECIAL',
}

export type UnitAndTripSearchParamsInput = {
    babies: Scalars['Int'];
    date: Scalars['String'];
    duration: Scalars['Int'];
    filters?: InputMaybe<Array<PropertyFilterInput>>;
    persons: Scalars['Int'];
    pets: Scalars['Int'];
    price?: InputMaybe<RangeFilterInput>;
    specialId?: InputMaybe<Scalars['ID']>;
    tripType?: InputMaybe<Array<TripTypeEnum>>;
};

/**   A property of a RentalUnit or Accommodation which can be used to filter by. */
export type UnitFilterProperty = {
    __typename?: 'UnitFilterProperty';
    /**   A URL-friendly handle unique to this property, this should never change even if the name changes. */
    handle: Scalars['String'];
    /**
     *   Name of this property.
     *  This value is language dependent.
     */
    name: Scalars['String'];
};

/**   A category of FilterProperties. */
export type UnitFilterPropertyCategory = {
    __typename?: 'UnitFilterPropertyCategory';
    /**   The properties in this category. */
    filterProperties: Array<UnitFilterProperty>;
    /**   A URL-friendly handle unique to this category, this should never change even if the name changes. */
    handle: Scalars['String'];
    /**
     *   Name of this category.
     *  This value is language dependent.
     */
    name: Scalars['String'];
};

export type UnitSearchHit = {
    __typename?: 'UnitSearchHit';
    rentalUnit: RentalUnit;
    trips: Array<Trip>;
};

/**   RentalUnit/Trip search result ordering options. */
export enum UnitSearchOrderEnum {
    /**  Sort by Trip price, ascending. */
    PriceAsc = 'PRICE_ASC',
    /**  Sort by Trip price, descending. */
    PriceDesc = 'PRICE_DESC',
    /**
     *  Randomize order.
     * # The random seed used is the current date, so the order will be identical between pageloads and between users, but change daily.
     */
    RandomBoosted = 'RANDOM_BOOSTED',
    /**  Sort by amount of recent bookings. */
    RecentBookingsBoosted = 'RECENT_BOOKINGS_BOOSTED',
    /**  Sort by average RentalUnit review rating, descending. */
    ReviewRatingDesc = 'REVIEW_RATING_DESC',
}

/**   Parameters for searching within RentalUnits (optionally filtered by specific Trip availability). */
export type UnitSearchParamsInput = {
    /**   The amount of babies in the travel party. */
    babies?: InputMaybe<Scalars['Int']>;
    /**
     *   Filter by this arrival date.
     *  Formatted as yyyy-mm-dd.
     */
    date?: InputMaybe<Scalars['String']>;
    /**   Filter by this Trip duration. */
    duration?: InputMaybe<Scalars['Int']>;
    /**
     *   Filter by properties the RentalUnit/Accommodation must posses.
     *  Multiple filters are combined as "AND".
     */
    filters?: InputMaybe<Array<PropertyFilterInput>>;
    /**   The amount of non-baby people in the travel party. */
    persons?: InputMaybe<Scalars['Int']>;
    /**   The amount of pets in the travel party. */
    pets?: InputMaybe<Scalars['Int']>;
    /**   Filter by a price range. */
    price?: InputMaybe<RangeFilterInput>;
    /**   Filter by a specific Special (by ID). */
    specialId?: InputMaybe<Scalars['ID']>;
    /**   Filter by this/these TripType(s). */
    tripType?: InputMaybe<Array<TripTypeEnum>>;
};

/**   Results of a RentalUnit/Trip search query. */
export type UnitSearchResult = {
    __typename?: 'UnitSearchResult';
    /**   The search results. */
    hits: Array<UnitSearchHit>;
    /**   The maximum Trip price within the result set. */
    maxPrice?: Maybe<Scalars['Float']>;
    /**   The minimum Trip price within the result set. */
    minPrice?: Maybe<Scalars['Float']>;
    /**   Available filter properties and corresponding result counts within the result set. */
    propertyFilterCounts: Array<PropertyFilterCount>;
    /**   Available Specials and corresponding counts within the result set. */
    specialCounts: Array<SpecialCount>;
    /**   Total amount of matching RentalUnits. */
    totalHits: Scalars['Int'];
    /**   Available TripTypes and corresponding counts within the result set. */
    tripTypeCounts: Array<TripTypeCount>;
};

export type UpdateCartInput = {
    affiliateInfo?: InputMaybe<AffiliateInfoInput>;
    agreedToTerms?: InputMaybe<Scalars['Boolean']>;
    bookings?: InputMaybe<Array<BookingCartItemInput>>;
    cartId?: InputMaybe<Scalars['ID']>;
    customerInfo?: InputMaybe<CustomerInfoInput>;
    paymentOptions?: InputMaybe<UpdateCartPaymentOptionsInput>;
    tickets?: InputMaybe<Array<TicketCartItemInput>>;
    upsellPurchases?: InputMaybe<Array<UpsellPurchaseCartItemInput>>;
};

export type UpdateCartPayload = {
    __typename?: 'UpdateCartPayload';
    cart?: Maybe<Cart>;
    /**   Indicates whether the current user (if any) is allowed to perform the checkout action for the submitted customer email address. */
    checkoutAllowed?: Maybe<Scalars['Boolean']>;
};

export type UpdateCartPaymentOptionsInput = {
    /**   Method "POINT_OF_SALE" only, this must be supplied and be stored in the PaymentTerminal table */
    sellDeviceId?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerInput = {
    address?: InputMaybe<AddressInput>;
    /**   Formatted as yyyy-mm-dd */
    birthdate?: InputMaybe<Scalars['String']>;
    customerId: Scalars['ID'];
    firstName?: InputMaybe<Scalars['String']>;
    lastName?: InputMaybe<Scalars['String']>;
    phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerPayload = {
    __typename?: 'UpdateCustomerPayload';
    customer?: Maybe<Customer>;
};

export type UpsellOffer = {
    __typename?: 'UpsellOffer';
    /**   This value is language dependent. */
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    image?: Maybe<GenericImage>;
    maxAmount: Scalars['Int'];
    /**   This value is language dependent. */
    name: Scalars['String'];
    unitPrice: Scalars['Float'];
};

export type UpsellPurchase = OrderItem & {
    __typename?: 'UpsellPurchase';
    amount: Scalars['Int'];
    errors: Array<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    offer?: Maybe<UpsellOffer>;
    paymentPrice: Scalars['Float'];
    priceLines: Array<PriceLine>;
    status: UpsellPurchaseStatus;
    totalPrice: Scalars['Float'];
};

export type UpsellPurchaseCartItemInput = {
    amount: Scalars['Int'];
    upsellOfferId: Scalars['ID'];
};

export enum UpsellPurchaseStatus {
    Accepted = 'ACCEPTED',
    Init = 'INIT',
    Waived = 'WAIVED',
}

export type User = ElementInterface &
    UserInterface & {
        __typename?: 'User';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The user’s addresses. */
        addresses?: Maybe<Array<Maybe<AddressInterface>>>;
        /** The handle of the site the user is affiliated with. */
        affiliatedSiteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the user is affiliated with. */
        affiliatedSiteId?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The user’s email. */
        email?: Maybe<Scalars['String']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The user’s first name. */
        firstName?: Maybe<Scalars['String']>;
        /** The user’s first name or username. */
        friendlyName?: Maybe<Scalars['String']>;
        /** The user’s full name. */
        fullName?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The user’s last name. */
        lastName?: Maybe<Scalars['String']>;
        /** The user’s full name or username. */
        name: Scalars['String'];
        /** The user’s photo. */
        photo?: Maybe<AssetInterface>;
        /** The user’s preferences. */
        preferences: Scalars['String'];
        /** The user’s preferred language. */
        preferredLanguage?: Maybe<Scalars['String']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The username. */
        username?: Maybe<Scalars['String']>;
    };

export type User_CountArgs = {
    field: Scalars['String'];
};

export type UserAddressesArgs = {
    administrativeArea?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    archived?: InputMaybe<Scalars['Boolean']>;
    countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all users. */
export type UserInterface = {
    /** Return a number of related elements for a field. */
    _count?: Maybe<Scalars['Int']>;
    /** The user’s addresses. */
    addresses?: Maybe<Array<Maybe<AddressInterface>>>;
    /** The handle of the site the user is affiliated with. */
    affiliatedSiteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the user is affiliated with. */
    affiliatedSiteId?: Maybe<Scalars['Int']>;
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']>;
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['DateTime']>;
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['DateTime']>;
    /** The user’s email. */
    email?: Maybe<Scalars['String']>;
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']>;
    /** The user’s first name. */
    firstName?: Maybe<Scalars['String']>;
    /** The user’s first name or username. */
    friendlyName?: Maybe<Scalars['String']>;
    /** The user’s full name. */
    fullName?: Maybe<Scalars['String']>;
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']>;
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']>;
    /** The user’s last name. */
    lastName?: Maybe<Scalars['String']>;
    /** The user’s full name or username. */
    name: Scalars['String'];
    /** The user’s photo. */
    photo?: Maybe<AssetInterface>;
    /** The user’s preferences. */
    preferences: Scalars['String'];
    /** The user’s preferred language. */
    preferredLanguage?: Maybe<Scalars['String']>;
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']>;
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']>;
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']>;
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']>;
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']>;
    /** The element’s status. */
    status?: Maybe<Scalars['String']>;
    /** The element’s title. */
    title?: Maybe<Scalars['String']>;
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']>;
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']>;
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']>;
    /** The username. */
    username?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all users. */
export type UserInterface_CountArgs = {
    field: Scalars['String'];
};

/** This is the interface implemented by all users. */
export type UserInterfaceAddressesArgs = {
    administrativeArea?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    archived?: InputMaybe<Scalars['Boolean']>;
    countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type UserRelationCriteriaInput = {
    /** Determines which site(s) the users should be affiliated with. */
    affiliatedSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the users should be affiliated with. */
    affiliatedSiteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only elements that have been archived. */
    archived?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on whether the users have uploaded any assets. */
    assetUploaders?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on whether the users are listed as the author of any entries. */
    authors?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ creation dates. */
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ last-updated dates. */
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the users’ email addresses. */
    email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the users’ first names. */
    firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Causes the query results to be returned in the order specified by the `id` argument. */
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the users’ full names. */
    fullName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the user group the users belong to. */
    group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the user group the users belong to, per the groups’ IDs. */
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to only users that have (or don’t have) a user photo. */
    hasPhoto?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ IDs. */
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Causes the query results to be returned in reverse order. */
    inReverse?: InputMaybe<Scalars['Boolean']>;
    /** Determines which site(s) the elements should be queried in, based on their language. */
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the users’ last names. */
    lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Sets the limit for paginated results. */
    limit?: InputMaybe<Scalars['Int']>;
    /** Narrows the query results to elements that do not relate to the provided element IDs. */
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Sets the offset for paginated results. */
    offset?: InputMaybe<Scalars['Int']>;
    /** Sets the field the returned elements should be ordered by. */
    orderBy?: InputMaybe<Scalars['String']>;
    /** Determines which site should be selected when querying multi-site elements. */
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on a reference string. */
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results to elements that relate to an asset list defined with this argument. */
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a category list defined with this argument. */
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to an entry list defined with this argument. */
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a tag list defined with this argument. */
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    /** Narrows the query results to elements that relate to a use list defined with this argument. */
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    /** Narrows the relations based on the field they were created in. */
    relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the relations based on the site they were created in. */
    relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that match a search query. */
    search?: InputMaybe<Scalars['String']>;
    /** Defines the default options that should be applied terms within the `search` argument. */
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the unique identifier for an element-site relation. */
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    /** Narrows the query results based on the elements’ slugs. */
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ statuses. */
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the elements’ titles. */
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results to only elements that have been soft-deleted. */
    trashed?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ UIDs. */
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Determines whether only elements with unique IDs should be returned by the query. */
    unique?: InputMaybe<Scalars['Boolean']>;
    /** Narrows the query results based on the elements’ URIs. */
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    /** Narrows the query results based on the users’ usernames. */
    username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ActionSectionEntryUnion = Action_Entry;

export type Action_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'action_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        button?: Maybe<LinkData>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        description?: Maybe<Description_CkeditorField>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Action_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Action_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Action_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'article_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        newsHeroImage: Array<Maybe<AssetInterface>>;
        newsImages: Array<Maybe<AssetInterface>>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMenuHidden?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNoIndex?: Maybe<Scalars['Boolean']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        textBody?: Maybe<TextBody_CkeditorField>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Article_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Article_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryNewsHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Article_EntryNewsImagesArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Article_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Article_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ArticlesSectionEntryUnion = Article_Entry;

export type AssetTags_Tag = ElementInterface &
    TagInterface & {
        __typename?: 'assetTags_Tag';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The handle of the group that contains the tag. */
        groupHandle: Scalars['String'];
        /** The ID of the group that contains the tag. */
        groupId: Scalars['Int'];
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type AssetTags_Tag_CountArgs = {
    field: Scalars['String'];
};

export type Banner_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'banner_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        button?: Maybe<LinkData>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        heroImage: Array<Maybe<AssetInterface>>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Banner_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Banner_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Banner_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Banner_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type BannersSectionEntryUnion = Banner_Entry;

export type CompaniesSectionEntryUnion = Companies_Entry;

export type Companies_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'companies_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Companies_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Companies_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Companies_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact2_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'contact2_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        email?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        messenger?: Maybe<Scalars['Boolean']>;
        myTerschelling?: Maybe<Scalars['Boolean']>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        phone?: Maybe<Scalars['Boolean']>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        shop?: Maybe<Scalars['Boolean']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
        whatsapp?: Maybe<Scalars['Boolean']>;
    };

export type Contact2_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Contact2_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact2_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ContactMatrixFieldEntryUnion = Contact2_Entry;

export type ContactMatrix_MatrixField = Contact2_Entry;

export type ContactSectionEntryUnion = Contact_Entry;

export type Contact_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'contact_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        button?: Maybe<LinkData>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        contactMatrix: Array<Maybe<ContactMatrix_MatrixField>>;
        contentMatrix: Array<Maybe<ContentMatrix_MatrixField>>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        heroImage: Array<Maybe<AssetInterface>>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNoIndex?: Maybe<Scalars['Boolean']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        textBody?: Maybe<TextBody_CkeditorField>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Contact_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Contact_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryContactMatrixArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryContentMatrixArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Contact_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_GlobalSet = ElementInterface &
    GlobalSetInterface & {
        __typename?: 'contact_GlobalSet';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        contactEmailText?: Maybe<Scalars['String']>;
        contactMessengerText?: Maybe<Scalars['String']>;
        contactMyTerschellingText?: Maybe<Scalars['String']>;
        contactPhoneText?: Maybe<Scalars['String']>;
        contactShopText?: Maybe<Scalars['String']>;
        contactWhatsappText?: Maybe<Scalars['String']>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The handle of the global set. */
        handle: Scalars['String'];
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The name of the global set. */
        name: Scalars['String'];
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type Contact_GlobalSet_CountArgs = {
    field: Scalars['String'];
};

export type ContentMatrixFieldEntryUnion =
    | SectionAccommodations_Entry
    | SectionAccordion_Entry
    | SectionAction_Entry
    | SectionActivities_Entry
    | SectionBanner_Entry
    | SectionBoat_Entry
    | SectionButton_Entry
    | SectionCompanies_Entry
    | SectionEmbed_Entry
    | SectionForms_Entry
    | SectionHeader_Entry
    | SectionHierarchicalTiles_Entry
    | SectionImages_Entry
    | SectionMap_Entry
    | SectionText_Entry
    | SectionTiles_Entry
    | SectionTip_Entry
    | SectionTravelbaseTiles_Entry
    | SectionVideo_Entry
    | SectionWebcam_Entry;

export type ContentMatrix_MatrixField =
    | SectionAccommodations_Entry
    | SectionAccordion_Entry
    | SectionAction_Entry
    | SectionActivities_Entry
    | SectionBanner_Entry
    | SectionBoat_Entry
    | SectionButton_Entry
    | SectionCompanies_Entry
    | SectionEmbed_Entry
    | SectionForms_Entry
    | SectionHeader_Entry
    | SectionHierarchicalTiles_Entry
    | SectionImages_Entry
    | SectionMap_Entry
    | SectionText_Entry
    | SectionTiles_Entry
    | SectionTip_Entry
    | SectionTravelbaseTiles_Entry
    | SectionVideo_Entry
    | SectionWebcam_Entry;

export type Description_CkeditorField = {
    __typename?: 'description_CkeditorField';
    /** The content split into chunks of markup and nested entries. */
    chunks: Array<Maybe<Description_CkeditorField_Chunks>>;
    /** The parsed content as HTML. */
    html?: Maybe<Scalars['String']>;
    /** The parsed content as Markdown. */
    markdown?: Maybe<Scalars['String']>;
    /** The parsed content as plain text. */
    plainText?: Maybe<Scalars['String']>;
    /** The raw HTML value, with reference tags and `<craft-entry>` nodes in-tact. */
    rawHtml?: Maybe<Scalars['String']>;
};

export type Description_CkeditorFieldMarkdownArgs = {
    hard_break?: InputMaybe<Scalars['Boolean']>;
    header_style?: InputMaybe<Scalars['String']>;
    list_item_style?: InputMaybe<Scalars['String']>;
    preserve_comments?: InputMaybe<Scalars['Boolean']>;
    remove_nodes?: InputMaybe<Scalars['String']>;
    strip_placeholder_links?: InputMaybe<Scalars['Boolean']>;
    strip_tags?: InputMaybe<Scalars['Boolean']>;
    suppress_errors?: InputMaybe<Scalars['Boolean']>;
    table_caption_side?: InputMaybe<Scalars['String']>;
    table_pipe_escape?: InputMaybe<Scalars['String']>;
    use_autolinks?: InputMaybe<Scalars['Boolean']>;
};

export type Description_CkeditorField_Chunks = CkeditorMarkup;

export type EventsSectionEntryUnion = Events_Entry;

export type Events_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'events_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Events_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Events_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Events_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ExcursionsSectionEntryUnion = Excursions_Entry;

export type Excursions_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'excursions_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Excursions_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Excursions_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Excursions_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ExternalLink_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'externalLink_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        externalLinkOpenInNewTab?: Maybe<Scalars['Boolean']>;
        externalLinkUrl?: Maybe<Scalars['String']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        heroImage: Array<Maybe<AssetInterface>>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        tagline?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type ExternalLink_Entry_CountArgs = {
    field: Scalars['String'];
};

export type ExternalLink_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ExternalLink_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalLink_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalSiteLinkSectionEntryUnion = ExternalLink_Entry;

export type FooterCategory_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'footerCategory_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type FooterCategory_Entry_CountArgs = {
    field: Scalars['String'];
};

export type FooterCategory_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterCategory_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'footerLink_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        menuLink?: Maybe<LinkData>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type FooterLink_Entry_CountArgs = {
    field: Scalars['String'];
};

export type FooterLink_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterLink_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FooterSectionEntryUnion = FooterCategory_Entry | FooterLink_Entry;

export type HomepageSectionEntryUnion = Homepage_Entry;

export type Homepage_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'homepage_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        action: Array<Maybe<EntryInterface>>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        header?: Maybe<Scalars['String']>;
        heroImage: Array<Maybe<AssetInterface>>;
        homeCurrent: Array<Maybe<EntryInterface>>;
        homeHighlights: Array<Maybe<EntryInterface>>;
        homeHighlightsTitle?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Homepage_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Homepage_EntryActionArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Homepage_EntryHomeCurrentArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryHomeHighlightsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Homepage_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Library_Asset = AssetInterface &
    ElementInterface & {
        __typename?: 'library_Asset';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Alternative text for the asset. */
        alt?: Maybe<Scalars['String']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        assetRights?: Maybe<Scalars['String']>;
        assetSource?: Maybe<Scalars['String']>;
        assetTags: Array<Maybe<TagInterface>>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the asset file was last modified. */
        dateModified?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The file extension for the asset file. */
        extension: Scalars['String'];
        /** The filename of the asset file. */
        filename: Scalars['String'];
        /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
        focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
        /** The ID of the folder that the asset belongs to. */
        folderId: Scalars['Int'];
        /** Returns the file’s format. */
        format?: Maybe<Scalars['String']>;
        /** Whether a user-defined focal point is set on the asset. */
        hasFocalPoint: Scalars['Boolean'];
        /** The height in pixels or null if it’s not an image. */
        height?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** An `<img>` tag based on this asset. */
        img?: Maybe<Scalars['String']>;
        /** The file kind. */
        kind: Scalars['String'];
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The file’s MIME type, if it can be determined. */
        mimeType?: Maybe<Scalars['String']>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<AssetInterface>;
        /** The asset’s path in the volume. */
        path: Scalars['String'];
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<AssetInterface>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The file size in bytes. */
        size?: Maybe<Scalars['String']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
        srcset?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
        url?: Maybe<Scalars['String']>;
        /** The ID of the volume that the asset belongs to. */
        volumeId?: Maybe<Scalars['Int']>;
        /** The width in pixels or null if it’s not an image. */
        width?: Maybe<Scalars['Int']>;
    };

export type Library_Asset_CountArgs = {
    field: Scalars['String'];
};

export type Library_AssetAssetRightsArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type Library_AssetAssetTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Library_AssetFormatArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

export type Library_AssetHeightArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

export type Library_AssetNextArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Library_AssetPrevArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Library_AssetSrcsetArgs = {
    sizes: Array<Scalars['String']>;
};

export type Library_AssetUrlArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

export type Library_AssetWidthArgs = {
    format?: InputMaybe<Scalars['String']>;
    handle?: InputMaybe<Scalars['String']>;
    height?: InputMaybe<Scalars['Int']>;
    immediately?: InputMaybe<Scalars['Boolean']>;
    interlace?: InputMaybe<Scalars['String']>;
    mode?: InputMaybe<Scalars['String']>;
    position?: InputMaybe<Scalars['String']>;
    quality?: InputMaybe<Scalars['Int']>;
    transform?: InputMaybe<Scalars['String']>;
    width?: InputMaybe<Scalars['Int']>;
};

export type MenuSectionEntryUnion = Menu_Entry;

export type Menu_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'menu_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        menuLink?: Maybe<LinkData>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Menu_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Menu_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Menu_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschellingSectionEntryUnion = MyTerschelling_Entry;

export type MyTerschelling_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'myTerschelling_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNoIndex?: Maybe<Scalars['Boolean']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type MyTerschelling_Entry_CountArgs = {
    field: Scalars['String'];
};

export type MyTerschelling_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MyTerschelling_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsSectionEntryUnion = News_Entry;

export type News_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'news_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        heroImage: Array<Maybe<AssetInterface>>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        textBody?: Maybe<TextBody_CkeditorField>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type News_Entry_CountArgs = {
    field: Scalars['String'];
};

export type News_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type News_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Notification_GlobalSet = ElementInterface &
    GlobalSetInterface & {
        __typename?: 'notification_GlobalSet';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        active?: Maybe<Scalars['Boolean']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        button?: Maybe<LinkData>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        description?: Maybe<Description_CkeditorField>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The handle of the global set. */
        handle: Scalars['String'];
        header?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The name of the global set. */
        name: Scalars['String'];
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type Notification_GlobalSet_CountArgs = {
    field: Scalars['String'];
};

export type Opgave20april_Form = ElementInterface &
    FormInterface & {
        __typename?: 'opgave20april_Form';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        aantalPersonen?: Maybe<Scalars['Number']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        bedrijfsnaam?: Maybe<Scalars['String']>;
        /** A list of captcha values (name and value) to assist with spam protection. */
        captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
        /** The form’s config as JSON. */
        configJson?: Maybe<Scalars['String']>;
        /** A CSRF token (name and value). */
        csrfToken?: Maybe<FormieCsrfTokenType>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        eventueleVragenOpmerkingen?: Maybe<Scalars['String']>;
        /** The form’s fields. */
        formFields?: Maybe<Array<Maybe<FieldInterface>>>;
        /** The form’s handle. */
        handle?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Whether the form is considered available according to user checks, scheduling and more. */
        isAvailable?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        opgaveDeelnemersbijeenkomst20April2023?: Maybe<Scalars['String']>;
        /** The form’s pages. */
        pages?: Maybe<Array<Maybe<PageInterface>>>;
        /** The form’s rows. */
        rows?: Maybe<Array<Maybe<RowInterface>>>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The form’s settings. */
        settings?: Maybe<FormSettingsType>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The form’s endpoint for sending submissions to, if using POST requests. */
        submissionEndpoint?: Maybe<Scalars['String']>;
        /** The form’s GQL mutation name for submissions to use. */
        submissionMutationName?: Maybe<Scalars['String']>;
        /** The form’s CSS for rendering. */
        templateCss?: Maybe<Scalars['String']>;
        /** The form’s rendered HTML. */
        templateHtml?: Maybe<Scalars['String']>;
        /** The form’s JS for rendering and functionality. */
        templateJs?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        uwNaam?: Maybe<NameType>;
    };

export type Opgave20april_Form_CountArgs = {
    field: Scalars['String'];
};

export type Opgave20april_FormFormFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Opgave20april_FormRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type Opgave20april_FormTemplateHtmlArgs = {
    options?: InputMaybe<Scalars['String']>;
    populateFormValues?: InputMaybe<Scalars['String']>;
};

export type Opgave20april_FormTemplateJsArgs = {
    initJs?: InputMaybe<Scalars['Boolean']>;
    useObserver?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveBt2026_Form = ElementInterface &
    FormInterface & {
        __typename?: 'opgaveBt2026_Form';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        bedrijfsnaam1?: Maybe<Scalars['String']>;
        /** A list of captcha values (name and value) to assist with spam protection. */
        captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
        /** The form’s config as JSON. */
        configJson?: Maybe<Scalars['String']>;
        /** A CSRF token (name and value). */
        csrfToken?: Maybe<FormieCsrfTokenType>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        email?: Maybe<Scalars['String']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The form’s fields. */
        formFields?: Maybe<Array<Maybe<FieldInterface>>>;
        gewensteAdvertentie?: Maybe<Scalars['String']>;
        gewensteVermelding?: Maybe<Scalars['String']>;
        /** The form’s handle. */
        handle?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Whether the form is considered available according to user checks, scheduling and more. */
        isAvailable?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        mijnKeuzeVoor2026?: Maybe<Scalars['String']>;
        naam?: Maybe<NameType>;
        /** The form’s pages. */
        pages?: Maybe<Array<Maybe<PageInterface>>>;
        /** The form’s rows. */
        rows?: Maybe<Array<Maybe<RowInterface>>>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The form’s settings. */
        settings?: Maybe<FormSettingsType>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The form’s endpoint for sending submissions to, if using POST requests. */
        submissionEndpoint?: Maybe<Scalars['String']>;
        /** The form’s GQL mutation name for submissions to use. */
        submissionMutationName?: Maybe<Scalars['String']>;
        /** The form’s CSS for rendering. */
        templateCss?: Maybe<Scalars['String']>;
        /** The form’s rendered HTML. */
        templateHtml?: Maybe<Scalars['String']>;
        /** The form’s JS for rendering and functionality. */
        templateJs?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        uwTekst?: Maybe<Scalars['String']>;
    };

export type OpgaveBt2026_Form_CountArgs = {
    field: Scalars['String'];
};

export type OpgaveBt2026_FormFormFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveBt2026_FormGewensteAdvertentieArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveBt2026_FormGewensteVermeldingArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveBt2026_FormMijnKeuzeVoor2026Args = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveBt2026_FormRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveBt2026_FormTemplateHtmlArgs = {
    options?: InputMaybe<Scalars['String']>;
    populateFormValues?: InputMaybe<Scalars['String']>;
};

export type OpgaveBt2026_FormTemplateJsArgs = {
    initJs?: InputMaybe<Scalars['Boolean']>;
    useObserver?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveDeelname_Form = ElementInterface &
    FormInterface & {
        __typename?: 'opgaveDeelname_Form';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        bedrijfsnaam1?: Maybe<Scalars['String']>;
        /** A list of captcha values (name and value) to assist with spam protection. */
        captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
        /** The form’s config as JSON. */
        configJson?: Maybe<Scalars['String']>;
        /** A CSRF token (name and value). */
        csrfToken?: Maybe<FormieCsrfTokenType>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        deelnemersbijdrage?: Maybe<Scalars['String']>;
        email?: Maybe<Scalars['String']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The form’s fields. */
        formFields?: Maybe<Array<Maybe<FieldInterface>>>;
        gewensteAdvertentie?: Maybe<Scalars['String']>;
        /** The form’s handle. */
        handle?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        ikWilGraagTeruggebeldWordenOpNummer?: Maybe<Scalars['String']>;
        /** Whether the form is considered available according to user checks, scheduling and more. */
        isAvailable?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        mijnKeuzeVoor2023?: Maybe<Scalars['String']>;
        naam?: Maybe<NameType>;
        /** The form’s pages. */
        pages?: Maybe<Array<Maybe<PageInterface>>>;
        /** The form’s rows. */
        rows?: Maybe<Array<Maybe<RowInterface>>>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The form’s settings. */
        settings?: Maybe<FormSettingsType>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The form’s endpoint for sending submissions to, if using POST requests. */
        submissionEndpoint?: Maybe<Scalars['String']>;
        /** The form’s GQL mutation name for submissions to use. */
        submissionMutationName?: Maybe<Scalars['String']>;
        /** The form’s CSS for rendering. */
        templateCss?: Maybe<Scalars['String']>;
        /** The form’s rendered HTML. */
        templateHtml?: Maybe<Scalars['String']>;
        /** The form’s JS for rendering and functionality. */
        templateJs?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        uwTekst?: Maybe<Scalars['String']>;
    };

export type OpgaveDeelname_Form_CountArgs = {
    field: Scalars['String'];
};

export type OpgaveDeelname_FormFormFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveDeelname_FormGewensteAdvertentieArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveDeelname_FormMijnKeuzeVoor2023Args = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveDeelname_FormRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveDeelname_FormTemplateHtmlArgs = {
    options?: InputMaybe<Scalars['String']>;
    populateFormValues?: InputMaybe<Scalars['String']>;
};

export type OpgaveDeelname_FormTemplateJsArgs = {
    initJs?: InputMaybe<Scalars['Boolean']>;
    useObserver?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw22022_Form = ElementInterface &
    FormInterface & {
        __typename?: 'opgaveSjouw22022_Form';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        afbeelding: Array<Maybe<AssetInterface>>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        bedrijfsnaam1?: Maybe<Scalars['String']>;
        /** A list of captcha values (name and value) to assist with spam protection. */
        captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
        categorie?: Maybe<Scalars['String']>;
        /** The form’s config as JSON. */
        configJson?: Maybe<Scalars['String']>;
        /** A CSRF token (name and value). */
        csrfToken?: Maybe<FormieCsrfTokenType>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The form’s fields. */
        formFields?: Maybe<Array<Maybe<FieldInterface>>>;
        /** The form’s handle. */
        handle?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Whether the form is considered available according to user checks, scheduling and more. */
        isAvailable?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        naam?: Maybe<Scalars['String']>;
        opgaveSjouw32022?: Maybe<Scalars['String']>;
        opgaveTekst?: Maybe<Scalars['String']>;
        /** The form’s pages. */
        pages?: Maybe<Array<Maybe<PageInterface>>>;
        /** The form’s rows. */
        rows?: Maybe<Array<Maybe<RowInterface>>>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The form’s settings. */
        settings?: Maybe<FormSettingsType>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The form’s endpoint for sending submissions to, if using POST requests. */
        submissionEndpoint?: Maybe<Scalars['String']>;
        /** The form’s GQL mutation name for submissions to use. */
        submissionMutationName?: Maybe<Scalars['String']>;
        tekstVoorInDeSjouw?: Maybe<Scalars['String']>;
        /** The form’s CSS for rendering. */
        templateCss?: Maybe<Scalars['String']>;
        /** The form’s rendered HTML. */
        templateHtml?: Maybe<Scalars['String']>;
        /** The form’s JS for rendering and functionality. */
        templateJs?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type OpgaveSjouw22022_Form_CountArgs = {
    field: Scalars['String'];
};

export type OpgaveSjouw22022_FormAfbeeldingArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpgaveSjouw22022_FormCategorieArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw22022_FormFormFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw22022_FormRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw22022_FormTemplateHtmlArgs = {
    options?: InputMaybe<Scalars['String']>;
    populateFormValues?: InputMaybe<Scalars['String']>;
};

export type OpgaveSjouw22022_FormTemplateJsArgs = {
    initJs?: InputMaybe<Scalars['Boolean']>;
    useObserver?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw_Form = ElementInterface &
    FormInterface & {
        __typename?: 'opgaveSjouw_Form';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        afbeelding: Array<Maybe<AssetInterface>>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        bedrijfsnaam?: Maybe<Scalars['String']>;
        /** A list of captcha values (name and value) to assist with spam protection. */
        captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
        /** The form’s config as JSON. */
        configJson?: Maybe<Scalars['String']>;
        /** A CSRF token (name and value). */
        csrfToken?: Maybe<FormieCsrfTokenType>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The form’s fields. */
        formFields?: Maybe<Array<Maybe<FieldInterface>>>;
        /** The form’s handle. */
        handle?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Whether the form is considered available according to user checks, scheduling and more. */
        isAvailable?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The form’s pages. */
        pages?: Maybe<Array<Maybe<PageInterface>>>;
        /** The form’s rows. */
        rows?: Maybe<Array<Maybe<RowInterface>>>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The form’s settings. */
        settings?: Maybe<FormSettingsType>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The form’s endpoint for sending submissions to, if using POST requests. */
        submissionEndpoint?: Maybe<Scalars['String']>;
        /** The form’s GQL mutation name for submissions to use. */
        submissionMutationName?: Maybe<Scalars['String']>;
        /** The form’s CSS for rendering. */
        templateCss?: Maybe<Scalars['String']>;
        /** The form’s rendered HTML. */
        templateHtml?: Maybe<Scalars['String']>;
        /** The form’s JS for rendering and functionality. */
        templateJs?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        uwCategorie?: Maybe<Scalars['String']>;
        uwNaam?: Maybe<NameType>;
        uwTekst?: Maybe<Scalars['String']>;
    };

export type OpgaveSjouw_Form_CountArgs = {
    field: Scalars['String'];
};

export type OpgaveSjouw_FormAfbeeldingArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpgaveSjouw_FormFormFieldsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw_FormRowsArgs = {
    includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw_FormTemplateHtmlArgs = {
    options?: InputMaybe<Scalars['String']>;
    populateFormValues?: InputMaybe<Scalars['String']>;
};

export type OpgaveSjouw_FormTemplateJsArgs = {
    initJs?: InputMaybe<Scalars['Boolean']>;
    useObserver?: InputMaybe<Scalars['Boolean']>;
};

export type OpgaveSjouw_FormUwCategorieArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type Page_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'page_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        contentMatrix: Array<Maybe<ContentMatrix_MatrixField>>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        heroImage: Array<Maybe<AssetInterface>>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMenuHidden?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNoIndex?: Maybe<Scalars['Boolean']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Page_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Page_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryContentMatrixArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryHeroImageArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Page_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Page_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PagesSectionEntryUnion = Page_Entry;

export type Pins_TableRow = {
    __typename?: 'pins_TableRow';
    col1?: Maybe<Scalars['Number']>;
    col2?: Maybe<Scalars['Number']>;
    col3?: Maybe<Scalars['String']>;
    col4?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    latitude?: Maybe<Scalars['Number']>;
    longitude?: Maybe<Scalars['Number']>;
    symbol?: Maybe<Scalars['String']>;
};

export type SearchSectionEntryUnion = Search_Entry;

export type SearchTags_Tag = ElementInterface &
    TagInterface & {
        __typename?: 'searchTags_Tag';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The handle of the group that contains the tag. */
        groupHandle: Scalars['String'];
        /** The ID of the group that contains the tag. */
        groupId: Scalars['Int'];
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        tagsSynonyms: Array<Maybe<TagInterface>>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type SearchTags_Tag_CountArgs = {
    field: Scalars['String'];
};

export type SearchTags_TagTagsSynonymsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Search_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'search_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNoIndex?: Maybe<Scalars['Boolean']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Search_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Search_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Search_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionAccommodations_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        accommodationsQuery?: Maybe<Scalars['String']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionAccommodations_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionAccommodations_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccommodations_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionAccordion_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        header?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        text?: Maybe<Text2_CkeditorField>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionAccordion_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionAccordion_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAccordion_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionAction_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        action: Array<Maybe<EntryInterface>>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionAction_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionAction_EntryActionArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionAction_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionActivities_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        activitiesQuery?: Maybe<Scalars['String']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionActivities_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionActivities_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionActivities_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionBanner_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        banner: Array<Maybe<EntryInterface>>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionBanner_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionBanner_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryBannerArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBanner_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionBoat_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        boatBlockEnabled?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionBoat_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionBoat_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionBoat_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionButton_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        button?: Maybe<LinkData>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionButton_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionButton_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionButton_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionCompanies_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        companiesQuery?: Maybe<Scalars['String']>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionCompanies_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionCompanies_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionCompanies_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionEmbed_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        embed?: Maybe<Scalars['String']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionEmbed_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionEmbed_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionEmbed_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionForms_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        form?: Maybe<Array<Maybe<FormInterface>>>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionForms_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionForms_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryFormArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionForms_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionHeader_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        header?: Maybe<Scalars['String']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionHeader_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionHeader_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHeader_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionHierarchicalTiles_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        relationType?: Maybe<Scalars['String']>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionHierarchicalTiles_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionHierarchicalTiles_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryRelationTypeArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type SectionHierarchicalTiles_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionImages_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        images: Array<Maybe<AssetInterface>>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionImages_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionImages_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryImagesArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SectionImages_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionImages_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionMap_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        pins?: Maybe<Array<Maybe<Pins_TableRow>>>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionMap_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionMap_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionMap_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionText_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        text?: Maybe<Text_CkeditorField>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionText_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionText_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionText_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionTiles_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        tilesChildren?: Maybe<Scalars['Boolean']>;
        tilesEntries: Array<Maybe<EntryInterface>>;
        tilesSiblings?: Maybe<Scalars['Boolean']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionTiles_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionTiles_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTiles_EntryTilesEntriesArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionTip_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        tip: Array<Maybe<EntryInterface>>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionTip_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionTip_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTip_EntryTipArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionTravelbaseTiles_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        travelbaseEntityType?: Maybe<Scalars['String']>;
        travelbaseSlugs?: Maybe<Array<Maybe<TravelbaseSlugs_TableRow>>>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type SectionTravelbaseTiles_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionTravelbaseTiles_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionTravelbaseTiles_EntryTravelbaseEntityTypeArgs = {
    label?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionVideo_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
        videoUrl?: Maybe<Scalars['String']>;
    };

export type SectionVideo_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionVideo_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionVideo_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sectionWebcam_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
        webcamUrl?: Maybe<Scalars['String']>;
    };

export type SectionWebcam_Entry_CountArgs = {
    field: Scalars['String'];
};

export type SectionWebcam_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SectionWebcam_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SightsSectionEntryUnion = Sights_Entry;

export type Sights_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'sights_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Sights_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Sights_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Sights_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Synonyms_Tag = ElementInterface &
    TagInterface & {
        __typename?: 'synonyms_Tag';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** The handle of the group that contains the tag. */
        groupHandle: Scalars['String'];
        /** The ID of the group that contains the tag. */
        groupId: Scalars['Int'];
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
    };

export type Synonyms_Tag_CountArgs = {
    field: Scalars['String'];
};

export type Text2_CkeditorField = {
    __typename?: 'text2_CkeditorField';
    /** The content split into chunks of markup and nested entries. */
    chunks: Array<Maybe<Text2_CkeditorField_Chunks>>;
    /** The parsed content as HTML. */
    html?: Maybe<Scalars['String']>;
    /** The parsed content as Markdown. */
    markdown?: Maybe<Scalars['String']>;
    /** The parsed content as plain text. */
    plainText?: Maybe<Scalars['String']>;
    /** The raw HTML value, with reference tags and `<craft-entry>` nodes in-tact. */
    rawHtml?: Maybe<Scalars['String']>;
};

export type Text2_CkeditorFieldMarkdownArgs = {
    hard_break?: InputMaybe<Scalars['Boolean']>;
    header_style?: InputMaybe<Scalars['String']>;
    list_item_style?: InputMaybe<Scalars['String']>;
    preserve_comments?: InputMaybe<Scalars['Boolean']>;
    remove_nodes?: InputMaybe<Scalars['String']>;
    strip_placeholder_links?: InputMaybe<Scalars['Boolean']>;
    strip_tags?: InputMaybe<Scalars['Boolean']>;
    suppress_errors?: InputMaybe<Scalars['Boolean']>;
    table_caption_side?: InputMaybe<Scalars['String']>;
    table_pipe_escape?: InputMaybe<Scalars['String']>;
    use_autolinks?: InputMaybe<Scalars['Boolean']>;
};

export type Text2_CkeditorField_Chunks = CkeditorMarkup;

export type TextBody_CkeditorField = {
    __typename?: 'textBody_CkeditorField';
    /** The content split into chunks of markup and nested entries. */
    chunks: Array<Maybe<TextBody_CkeditorField_Chunks>>;
    /** The parsed content as HTML. */
    html?: Maybe<Scalars['String']>;
    /** The parsed content as Markdown. */
    markdown?: Maybe<Scalars['String']>;
    /** The parsed content as plain text. */
    plainText?: Maybe<Scalars['String']>;
    /** The raw HTML value, with reference tags and `<craft-entry>` nodes in-tact. */
    rawHtml?: Maybe<Scalars['String']>;
};

export type TextBody_CkeditorFieldMarkdownArgs = {
    hard_break?: InputMaybe<Scalars['Boolean']>;
    header_style?: InputMaybe<Scalars['String']>;
    list_item_style?: InputMaybe<Scalars['String']>;
    preserve_comments?: InputMaybe<Scalars['Boolean']>;
    remove_nodes?: InputMaybe<Scalars['String']>;
    strip_placeholder_links?: InputMaybe<Scalars['Boolean']>;
    strip_tags?: InputMaybe<Scalars['Boolean']>;
    suppress_errors?: InputMaybe<Scalars['Boolean']>;
    table_caption_side?: InputMaybe<Scalars['String']>;
    table_pipe_escape?: InputMaybe<Scalars['String']>;
    use_autolinks?: InputMaybe<Scalars['Boolean']>;
};

export type TextBody_CkeditorField_Chunks = CkeditorMarkup;

export type Text_CkeditorField = {
    __typename?: 'text_CkeditorField';
    /** The content split into chunks of markup and nested entries. */
    chunks: Array<Maybe<Text_CkeditorField_Chunks>>;
    /** The parsed content as HTML. */
    html?: Maybe<Scalars['String']>;
    /** The parsed content as Markdown. */
    markdown?: Maybe<Scalars['String']>;
    /** The parsed content as plain text. */
    plainText?: Maybe<Scalars['String']>;
    /** The raw HTML value, with reference tags and `<craft-entry>` nodes in-tact. */
    rawHtml?: Maybe<Scalars['String']>;
};

export type Text_CkeditorFieldMarkdownArgs = {
    hard_break?: InputMaybe<Scalars['Boolean']>;
    header_style?: InputMaybe<Scalars['String']>;
    list_item_style?: InputMaybe<Scalars['String']>;
    preserve_comments?: InputMaybe<Scalars['Boolean']>;
    remove_nodes?: InputMaybe<Scalars['String']>;
    strip_placeholder_links?: InputMaybe<Scalars['Boolean']>;
    strip_tags?: InputMaybe<Scalars['Boolean']>;
    suppress_errors?: InputMaybe<Scalars['Boolean']>;
    table_caption_side?: InputMaybe<Scalars['String']>;
    table_pipe_escape?: InputMaybe<Scalars['String']>;
    use_autolinks?: InputMaybe<Scalars['Boolean']>;
};

export type Text_CkeditorField_Chunks = CkeditorMarkup;

export type ThankYouSectionEntryUnion = ThankYou_Entry;

export type ThankYou_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'thankYou_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        settingsCookieConsent?: Maybe<Scalars['Boolean']>;
        settingsMetaDescription?: Maybe<Scalars['String']>;
        settingsNoIndex?: Maybe<Scalars['Boolean']>;
        settingsNotSearchable?: Maybe<Scalars['Boolean']>;
        settingsSearchTags: Array<Maybe<TagInterface>>;
        settingsSeoTitle?: Maybe<Scalars['String']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type ThankYou_Entry_CountArgs = {
    field: Scalars['String'];
};

export type ThankYou_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ThankYou_EntrySettingsSearchTagsArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    tagsSynonyms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TipText_CkeditorField = {
    __typename?: 'tipText_CkeditorField';
    /** The content split into chunks of markup and nested entries. */
    chunks: Array<Maybe<TipText_CkeditorField_Chunks>>;
    /** The parsed content as HTML. */
    html?: Maybe<Scalars['String']>;
    /** The parsed content as Markdown. */
    markdown?: Maybe<Scalars['String']>;
    /** The parsed content as plain text. */
    plainText?: Maybe<Scalars['String']>;
    /** The raw HTML value, with reference tags and `<craft-entry>` nodes in-tact. */
    rawHtml?: Maybe<Scalars['String']>;
};

export type TipText_CkeditorFieldMarkdownArgs = {
    hard_break?: InputMaybe<Scalars['Boolean']>;
    header_style?: InputMaybe<Scalars['String']>;
    list_item_style?: InputMaybe<Scalars['String']>;
    preserve_comments?: InputMaybe<Scalars['Boolean']>;
    remove_nodes?: InputMaybe<Scalars['String']>;
    strip_placeholder_links?: InputMaybe<Scalars['Boolean']>;
    strip_tags?: InputMaybe<Scalars['Boolean']>;
    suppress_errors?: InputMaybe<Scalars['Boolean']>;
    table_caption_side?: InputMaybe<Scalars['String']>;
    table_pipe_escape?: InputMaybe<Scalars['String']>;
    use_autolinks?: InputMaybe<Scalars['Boolean']>;
};

export type TipText_CkeditorField_Chunks = CkeditorMarkup;

export type Tip_Entry = ElementInterface &
    EntryInterface & {
        __typename?: 'tip_Entry';
        /** Return a number of related elements for a field. */
        _count?: Maybe<Scalars['Int']>;
        /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
        ancestors: Array<EntryInterface>;
        /** Whether the element is archived. */
        archived?: Maybe<Scalars['Boolean']>;
        /** Returns the entry’s canonical ID. */
        canonicalId?: Maybe<Scalars['Int']>;
        /** Returns the entry’s canonical UUID. */
        canonicalUid?: Maybe<Scalars['String']>;
        /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
        children: Array<EntryInterface>;
        /** The current revision for the entry. */
        currentRevision?: Maybe<EntryInterface>;
        /** The date the element was created. */
        dateCreated?: Maybe<Scalars['DateTime']>;
        /** The date the element was last updated. */
        dateUpdated?: Maybe<Scalars['DateTime']>;
        /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
        descendants: Array<EntryInterface>;
        /** The creator of a given draft. */
        draftCreator?: Maybe<UserInterface>;
        /** The draft ID (from the `drafts` table). */
        draftId?: Maybe<Scalars['Int']>;
        /** The name of the draft. */
        draftName?: Maybe<Scalars['String']>;
        /** The notes for the draft. */
        draftNotes?: Maybe<Scalars['String']>;
        /** The drafts for the entry. */
        drafts?: Maybe<Array<Maybe<EntryInterface>>>;
        /** Whether the element is enabled. */
        enabled?: Maybe<Scalars['Boolean']>;
        /** Whether the element is enabled for the site. */
        enabledForSite?: Maybe<Scalars['Boolean']>;
        /** The expiry date of the entry. */
        expiryDate?: Maybe<Scalars['DateTime']>;
        /** The handle of the field that contains the entry. */
        fieldHandle?: Maybe<Scalars['String']>;
        /** The ID of the field that contains the entry. */
        fieldId?: Maybe<Scalars['Int']>;
        /** The ID of the entity */
        id?: Maybe<Scalars['ID']>;
        /** Returns whether this is a draft. */
        isDraft?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is a revision. */
        isRevision?: Maybe<Scalars['Boolean']>;
        /** Returns whether this is an unpublished draft. */
        isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
        /** The language of the site element is associated with. */
        language?: Maybe<Scalars['String']>;
        /** The element’s level within its structure */
        level?: Maybe<Scalars['Int']>;
        /** The element’s left position within its structure. */
        lft?: Maybe<Scalars['Int']>;
        /** The same element in other locales. */
        localized: Array<EntryInterface>;
        /** Returns the next element relative to this one, from a given set of criteria. */
        next?: Maybe<EntryInterface>;
        /** The ID of the entry’s owner element. */
        ownerId?: Maybe<Scalars['Int']>;
        /** The entry’s parent, if the section is a structure. */
        parent?: Maybe<EntryInterface>;
        /** The entry’s post date. */
        postDate?: Maybe<Scalars['DateTime']>;
        /** Returns the previous element relative to this one, from a given set of criteria. */
        prev?: Maybe<EntryInterface>;
        /** The creator of a given revision. */
        revisionCreator?: Maybe<UserInterface>;
        /** The revision ID (from the `revisions` table). */
        revisionId?: Maybe<Scalars['Int']>;
        /** The revision notes (from the `revisions` table). */
        revisionNotes?: Maybe<Scalars['String']>;
        /** The revisions for the entry. */
        revisions?: Maybe<Array<Maybe<EntryInterface>>>;
        /** The element’s right position within its structure. */
        rgt?: Maybe<Scalars['Int']>;
        /** The element’s structure’s root ID */
        root?: Maybe<Scalars['Int']>;
        /** The element’s search score, if the `search` parameter was used when querying for the element. */
        searchScore?: Maybe<Scalars['Int']>;
        /** The handle of the section that contains the entry. */
        sectionHandle?: Maybe<Scalars['String']>;
        /** The ID of the section that contains the entry. */
        sectionId?: Maybe<Scalars['Int']>;
        /** The handle of the site the element is associated with. */
        siteHandle?: Maybe<Scalars['String']>;
        /** The ID of the site the element is associated with. */
        siteId?: Maybe<Scalars['Int']>;
        /** The unique identifier for an element-site relation. */
        siteSettingsId?: Maybe<Scalars['ID']>;
        /** The element’s slug. */
        slug?: Maybe<Scalars['String']>;
        /** The entry’s position within the field that contains it. */
        sortOrder?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical ID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
         */
        sourceId?: Maybe<Scalars['Int']>;
        /**
         * Returns the entry’s canonical UUID.
         * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
         */
        sourceUid?: Maybe<Scalars['String']>;
        /** The element’s status. */
        status?: Maybe<Scalars['String']>;
        /** The element’s structure ID. */
        structureId?: Maybe<Scalars['Int']>;
        tipAvatar: Array<Maybe<AssetInterface>>;
        tipName?: Maybe<Scalars['String']>;
        tipRole?: Maybe<Scalars['String']>;
        tipText?: Maybe<TipText_CkeditorField>;
        /** The element’s title. */
        title?: Maybe<Scalars['String']>;
        /** Whether the element has been soft-deleted. */
        trashed?: Maybe<Scalars['Boolean']>;
        /** The handle of the entry type that contains the entry. */
        typeHandle: Scalars['String'];
        /** The ID of the entry type that contains the entry. */
        typeId: Scalars['Int'];
        /** The UID of the entity */
        uid?: Maybe<Scalars['String']>;
        /** The element’s URI. */
        uri?: Maybe<Scalars['String']>;
        /** The element’s full URL */
        url?: Maybe<Scalars['String']>;
    };

export type Tip_Entry_CountArgs = {
    field: Scalars['String'];
};

export type Tip_EntryAncestorsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryChildrenArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryDescendantsArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryDraftsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryLocalizedArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryNextArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryParentArgs = {
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryPrevArgs = {
    accommodationsQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    activitiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    banner?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    boatBlockEnabled?: InputMaybe<Scalars['Boolean']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    companiesQuery?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    email?: InputMaybe<Scalars['Boolean']>;
    embed?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    form?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    messenger?: InputMaybe<Scalars['Boolean']>;
    myTerschelling?: InputMaybe<Scalars['Boolean']>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    phone?: InputMaybe<Scalars['Boolean']>;
    pins?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    relationType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    shop?: InputMaybe<Scalars['Boolean']>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    text?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesChildren?: InputMaybe<Scalars['Boolean']>;
    tilesEntries?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tilesSiblings?: InputMaybe<Scalars['Boolean']>;
    tip?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    travelbaseEntityType?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    travelbaseSlugs?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    videoUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    webcamUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    whatsapp?: InputMaybe<Scalars['Boolean']>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryRevisionsArgs = {
    action?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    after?: InputMaybe<Scalars['String']>;
    ancestorDist?: InputMaybe<Scalars['Int']>;
    ancestorOf?: InputMaybe<Scalars['Int']>;
    archived?: InputMaybe<Scalars['Boolean']>;
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    before?: InputMaybe<Scalars['String']>;
    button?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    descendantDist?: InputMaybe<Scalars['Int']>;
    descendantOf?: InputMaybe<Scalars['Int']>;
    description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    draftCreator?: InputMaybe<Scalars['Int']>;
    draftId?: InputMaybe<Scalars['Int']>;
    draftOf?: InputMaybe<Scalars['QueryArgument']>;
    drafts?: InputMaybe<Scalars['Boolean']>;
    editable?: InputMaybe<Scalars['Boolean']>;
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    externalLinkOpenInNewTab?: InputMaybe<Scalars['Boolean']>;
    externalLinkUrl?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    hasDescendants?: InputMaybe<Scalars['Boolean']>;
    header?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    heroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeCurrent?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    homeHighlightsTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    leaves?: InputMaybe<Scalars['Boolean']>;
    level?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
    menuLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsHeroImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    newsImages?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    nextSiblingOf?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    positionedAfter?: InputMaybe<Scalars['Int']>;
    positionedBefore?: InputMaybe<Scalars['Int']>;
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    prevSiblingOf?: InputMaybe<Scalars['Int']>;
    primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    revisionCreator?: InputMaybe<Scalars['Int']>;
    revisionId?: InputMaybe<Scalars['Int']>;
    revisionOf?: InputMaybe<Scalars['QueryArgument']>;
    revisions?: InputMaybe<Scalars['Boolean']>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsCookieConsent?: InputMaybe<Scalars['Boolean']>;
    settingsMenuHidden?: InputMaybe<Scalars['Boolean']>;
    settingsMetaDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsNoIndex?: InputMaybe<Scalars['Boolean']>;
    settingsNotSearchable?: InputMaybe<Scalars['Boolean']>;
    settingsSearchTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    settingsSeoTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    structureId?: InputMaybe<Scalars['Int']>;
    tagline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    textBody?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipAvatar?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipRole?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    tipText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withProvisionalDrafts?: InputMaybe<Scalars['Boolean']>;
    withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Tip_EntryTipAvatarArgs = {
    archived?: InputMaybe<Scalars['Boolean']>;
    assetRights?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetSource?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    assetTags?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    dateModified?: InputMaybe<Scalars['String']>;
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    fixedOrder?: InputMaybe<Scalars['Boolean']>;
    folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    hasAlt?: InputMaybe<Scalars['Boolean']>;
    height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    inReverse?: InputMaybe<Scalars['Boolean']>;
    includeSubfolders?: InputMaybe<Scalars['Boolean']>;
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    limit?: InputMaybe<Scalars['Int']>;
    notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    offset?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Scalars['String']>;
    preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
    relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
    relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
    relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
    relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
    search?: InputMaybe<Scalars['String']>;
    searchTermOptions?: InputMaybe<SearchTermOptions>;
    site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    trashed?: InputMaybe<Scalars['Boolean']>;
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    unique?: InputMaybe<Scalars['Boolean']>;
    uploader?: InputMaybe<Scalars['QueryArgument']>;
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
    width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TipsSectionEntryUnion = Tip_Entry;

export type TravelbaseSlugs_TableRow = {
    __typename?: 'travelbaseSlugs_TableRow';
    col1?: Maybe<Scalars['String']>;
    slug?: Maybe<Scalars['String']>;
};

export type ActionFragment = {
    title?: string | null;
    description?: ({ html?: string | null } & { __typename?: 'description_CkeditorField' }) | null;
    button?:
        | ({
              label?: string | null;
              target?: string | null;
              url?: string | null;
              type?: string | null;
              element?:
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'Address'
                            | 'Element'
                            | 'User'
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'assetTags_Tag'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'contact_GlobalSet'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'library_Asset'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'news_Entry'
                            | 'notification_GlobalSet'
                            | 'opgave20april_Form'
                            | 'opgaveBt2026_Form'
                            | 'opgaveDeelname_Form'
                            | 'opgaveSjouw22022_Form'
                            | 'opgaveSjouw_Form'
                            | 'page_Entry'
                            | 'searchTags_Tag'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'synonyms_Tag'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
          } & { __typename?: 'LinkData' })
        | null;
} & { __typename?: 'action_Entry' };

type Card_BjQaUSyN2kVg7HfXzBn2gp8HvewYOttu9YpivIihFk_Fragment = { title?: string | null; uri?: string | null } & {
    __typename?:
        | 'action_Entry'
        | 'banner_Entry'
        | 'contact2_Entry'
        | 'events_Entry'
        | 'footerCategory_Entry'
        | 'footerLink_Entry'
        | 'menu_Entry'
        | 'search_Entry'
        | 'sectionAccommodations_Entry'
        | 'sectionAccordion_Entry'
        | 'sectionAction_Entry'
        | 'sectionActivities_Entry'
        | 'sectionBanner_Entry'
        | 'sectionBoat_Entry'
        | 'sectionButton_Entry'
        | 'sectionCompanies_Entry'
        | 'sectionEmbed_Entry'
        | 'sectionForms_Entry'
        | 'sectionHeader_Entry'
        | 'sectionHierarchicalTiles_Entry';
};

type Card_GaSANRctDGxoU8RCo9ivpuDnRrMcwCSgz7VtTc_Fragment = { title?: string | null; uri?: string | null } & {
    __typename?:
        | 'sectionImages_Entry'
        | 'sectionMap_Entry'
        | 'sectionText_Entry'
        | 'sectionTiles_Entry'
        | 'sectionTip_Entry'
        | 'sectionTravelbaseTiles_Entry'
        | 'sectionVideo_Entry'
        | 'sectionWebcam_Entry'
        | 'sights_Entry'
        | 'tip_Entry';
};

type Card_Article_Entry_Fragment = {
    title?: string | null;
    uri?: string | null;
    postDate?: any | null;
    settingsMetaDescription?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'article_Entry' };

type Card_E1LTcbFbceXtM7Gh2aIGq3TtgVpw8Am6hc1A5S0X9E_Fragment = {
    title?: string | null;
    uri?: string | null;
    settingsMetaDescription?: string | null;
} & { __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry' };

type Card_Contact_Entry_Homepage_Entry_News_Entry_Fragment = {
    title?: string | null;
    uri?: string | null;
    settingsMetaDescription?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' };

type Card_ExternalLink_Entry_Fragment = {
    title?: string | null;
    uri?: string | null;
    externalLinkUrl?: string | null;
    externalLinkOpenInNewTab?: boolean | null;
    tagline?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'externalLink_Entry' };

type Card_Page_Entry_Fragment = {
    title?: string | null;
    uri?: string | null;
    id?: string | null;
    settingsMetaDescription?: string | null;
    settingsNotSearchable?: boolean | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'page_Entry' };

export type CardFragment =
    | Card_BjQaUSyN2kVg7HfXzBn2gp8HvewYOttu9YpivIihFk_Fragment
    | Card_GaSANRctDGxoU8RCo9ivpuDnRrMcwCSgz7VtTc_Fragment
    | Card_Article_Entry_Fragment
    | Card_E1LTcbFbceXtM7Gh2aIGq3TtgVpw8Am6hc1A5S0X9E_Fragment
    | Card_Contact_Entry_Homepage_Entry_News_Entry_Fragment
    | Card_ExternalLink_Entry_Fragment
    | Card_Page_Entry_Fragment;

export type CardImageFragment = {
    focalPoint?: Array<number | null> | null;
    title?: string | null;
    extension: string;
    url?: string | null;
    placeholderUrl?: string | null;
    srcset?: string | null;
    srcsetWebp?: string | null;
} & { __typename?: 'library_Asset' };

export type PageCardFragment = {
    id?: string | null;
    settingsMetaDescription?: string | null;
    settingsNotSearchable?: boolean | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'page_Entry' };

export type ArticleCardFragment = {
    postDate?: any | null;
    settingsMetaDescription?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'article_Entry' };

export type NewsCardFragment = {
    settingsMetaDescription?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'news_Entry' };

export type HomeCardFragment = {
    settingsMetaDescription?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'homepage_Entry' };

export type ContactCardFragment = {
    settingsMetaDescription?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'contact_Entry' };

export type AgendaCardFragment = { settingsMetaDescription?: string | null } & { __typename?: 'excursions_Entry' };

export type ThankYouCardFragment = { settingsMetaDescription?: string | null } & { __typename?: 'thankYou_Entry' };

export type CompanyCardFragment = { settingsMetaDescription?: string | null } & { __typename?: 'companies_Entry' };

export type MyTerschellingCardFragment = { settingsMetaDescription?: string | null } & {
    __typename?: 'myTerschelling_Entry';
};

export type ExternalLinkCardFragment = {
    externalLinkUrl?: string | null;
    externalLinkOpenInNewTab?: boolean | null;
    title?: string | null;
    tagline?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'externalLink_Entry' };

type ContentMatrix_SectionAccommodations_Entry_Fragment = { accommodationsQuery?: string | null } & {
    __typename?: 'sectionAccommodations_Entry';
};

type ContentMatrix_SectionAccordion_Entry_Fragment = {
    header?: string | null;
    text?: ({ html?: string | null } & { __typename?: 'text2_CkeditorField' }) | null;
} & { __typename?: 'sectionAccordion_Entry' };

type ContentMatrix_SectionAction_Entry_Fragment = { __typename?: 'sectionAction_Entry' };

type ContentMatrix_SectionActivities_Entry_Fragment = { activitiesQuery?: string | null } & {
    __typename?: 'sectionActivities_Entry';
};

type ContentMatrix_SectionBanner_Entry_Fragment = {
    banner: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              heroImage: Array<({ thumbUrl?: string | null } & { __typename?: 'library_Asset' }) | null>;
              button?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'page_Entry'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
          } & { __typename?: 'banner_Entry' })
        | null
    >;
} & { __typename?: 'sectionBanner_Entry' };

type ContentMatrix_SectionBoat_Entry_Fragment = { boatBlockEnabled?: boolean | null } & {
    __typename?: 'sectionBoat_Entry';
};

type ContentMatrix_SectionButton_Entry_Fragment = {
    button?:
        | ({
              label?: string | null;
              target?: string | null;
              url?: string | null;
              type?: string | null;
              element?:
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'Address'
                            | 'Element'
                            | 'User'
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'assetTags_Tag'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'contact_GlobalSet'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'library_Asset'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'news_Entry'
                            | 'notification_GlobalSet'
                            | 'opgave20april_Form'
                            | 'opgaveBt2026_Form'
                            | 'opgaveDeelname_Form'
                            | 'opgaveSjouw22022_Form'
                            | 'opgaveSjouw_Form'
                            | 'page_Entry'
                            | 'searchTags_Tag'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'synonyms_Tag'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
          } & { __typename?: 'LinkData' })
        | null;
} & { __typename?: 'sectionButton_Entry' };

type ContentMatrix_SectionCompanies_Entry_Fragment = { companiesQuery?: string | null } & {
    __typename?: 'sectionCompanies_Entry';
};

type ContentMatrix_SectionEmbed_Entry_Fragment = { embed?: string | null } & { __typename?: 'sectionEmbed_Entry' };

type ContentMatrix_SectionForms_Entry_Fragment = { id?: string | null } & { __typename?: 'sectionForms_Entry' };

type ContentMatrix_SectionHeader_Entry_Fragment = { header?: string | null } & { __typename?: 'sectionHeader_Entry' };

type ContentMatrix_SectionHierarchicalTiles_Entry_Fragment = { relationType?: string | null } & {
    __typename?: 'sectionHierarchicalTiles_Entry';
};

type ContentMatrix_SectionImages_Entry_Fragment = {
    gallery: Array<
        | ({
              assetSource?: string | null;
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              width?: number | null;
              height?: number | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename?: 'sectionImages_Entry' };

type ContentMatrix_SectionMap_Entry_Fragment = {
    pins?: Array<
        | ({ latitude?: any | null; longitude?: any | null; symbol?: string | null; label?: string | null } & {
              __typename?: 'pins_TableRow';
          })
        | null
    > | null;
} & { __typename?: 'sectionMap_Entry' };

type ContentMatrix_SectionText_Entry_Fragment = {
    text?: ({ html?: string | null } & { __typename?: 'text_CkeditorField' }) | null;
} & { __typename?: 'sectionText_Entry' };

type ContentMatrix_SectionTiles_Entry_Fragment = {
    tilesChildren?: boolean | null;
    tilesSiblings?: boolean | null;
    tilesEntries: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
        | null
    >;
} & { __typename?: 'sectionTiles_Entry' };

type ContentMatrix_SectionTip_Entry_Fragment = {
    tip: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          }
        | {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry';
          }
        | ({
              title?: string | null;
              tipName?: string | null;
              tipRole?: string | null;
              tipText?: ({ html?: string | null } & { __typename?: 'tipText_CkeditorField' }) | null;
              tipAvatar: Array<
                  | ({ height?: number | null; width?: number | null; thumbUrl?: string | null } & {
                        __typename?: 'library_Asset';
                    })
                  | null
              >;
          } & { __typename?: 'tip_Entry' })
        | null
    >;
} & { __typename?: 'sectionTip_Entry' };

type ContentMatrix_SectionTravelbaseTiles_Entry_Fragment = {
    travelbaseEntityType?: string | null;
    travelbaseSlugs?: Array<({ slug?: string | null } & { __typename?: 'travelbaseSlugs_TableRow' }) | null> | null;
} & { __typename?: 'sectionTravelbaseTiles_Entry' };

type ContentMatrix_SectionVideo_Entry_Fragment = { videoUrl?: string | null } & { __typename?: 'sectionVideo_Entry' };

type ContentMatrix_SectionWebcam_Entry_Fragment = { webcamUrl?: string | null } & {
    __typename?: 'sectionWebcam_Entry';
};

export type ContentMatrixFragment =
    | ContentMatrix_SectionAccommodations_Entry_Fragment
    | ContentMatrix_SectionAccordion_Entry_Fragment
    | ContentMatrix_SectionAction_Entry_Fragment
    | ContentMatrix_SectionActivities_Entry_Fragment
    | ContentMatrix_SectionBanner_Entry_Fragment
    | ContentMatrix_SectionBoat_Entry_Fragment
    | ContentMatrix_SectionButton_Entry_Fragment
    | ContentMatrix_SectionCompanies_Entry_Fragment
    | ContentMatrix_SectionEmbed_Entry_Fragment
    | ContentMatrix_SectionForms_Entry_Fragment
    | ContentMatrix_SectionHeader_Entry_Fragment
    | ContentMatrix_SectionHierarchicalTiles_Entry_Fragment
    | ContentMatrix_SectionImages_Entry_Fragment
    | ContentMatrix_SectionMap_Entry_Fragment
    | ContentMatrix_SectionText_Entry_Fragment
    | ContentMatrix_SectionTiles_Entry_Fragment
    | ContentMatrix_SectionTip_Entry_Fragment
    | ContentMatrix_SectionTravelbaseTiles_Entry_Fragment
    | ContentMatrix_SectionVideo_Entry_Fragment
    | ContentMatrix_SectionWebcam_Entry_Fragment;

export type TravelbaseTileFragment = {
    travelbaseEntityType?: string | null;
    travelbaseSlugs?: Array<({ slug?: string | null } & { __typename?: 'travelbaseSlugs_TableRow' }) | null> | null;
} & { __typename?: 'sectionTravelbaseTiles_Entry' };

type FieldRenderer_Field_Address_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    fields?: Array<
        | ({
              label?: string | null;
              enabled?: boolean | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              required?: boolean | null;
              placeholder?: string | null;
              handle?: string | null;
          } & {
              __typename?:
                  | 'Field_Address'
                  | 'Field_Address1'
                  | 'Field_Address2'
                  | 'Field_Address3'
                  | 'Field_AddressAutoComplete'
                  | 'Field_AddressCity'
                  | 'Field_AddressCountry'
                  | 'Field_AddressState'
                  | 'Field_AddressZip'
                  | 'Field_Agree'
                  | 'Field_Calculations'
                  | 'Field_Categories'
                  | 'Field_Checkboxes'
                  | 'Field_Date'
                  | 'Field_DateAmPmDropdown'
                  | 'Field_DateAmPmNumber'
                  | 'Field_DateDate'
                  | 'Field_DateDayDropdown'
                  | 'Field_DateDayNumber'
                  | 'Field_DateHourDropdown';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              required?: boolean | null;
              placeholder?: string | null;
              handle?: string | null;
          } & {
              __typename?:
                  | 'Field_DateHourNumber'
                  | 'Field_DateMinuteDropdown'
                  | 'Field_DateMinuteNumber'
                  | 'Field_DateMonthDropdown'
                  | 'Field_DateMonthNumber'
                  | 'Field_DateSecondDropdown'
                  | 'Field_DateSecondNumber'
                  | 'Field_DateTime'
                  | 'Field_DateYearDropdown'
                  | 'Field_DateYearNumber'
                  | 'Field_Dropdown'
                  | 'Field_Email'
                  | 'Field_Entries'
                  | 'Field_FileUpload'
                  | 'Field_Group'
                  | 'Field_Heading'
                  | 'Field_Hidden'
                  | 'Field_Html'
                  | 'Field_MultiLineText'
                  | 'Field_Name';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              required?: boolean | null;
              placeholder?: string | null;
              handle?: string | null;
          } & {
              __typename?:
                  | 'Field_NameFirst'
                  | 'Field_NameLast'
                  | 'Field_NameMiddle'
                  | 'Field_NamePrefix'
                  | 'Field_Newsletter'
                  | 'Field_Number'
                  | 'Field_Password'
                  | 'Field_Payment'
                  | 'Field_Phone'
                  | 'Field_Radio'
                  | 'Field_Recipients'
                  | 'Field_Repeater'
                  | 'Field_Section'
                  | 'Field_Signature'
                  | 'Field_SingleLineText'
                  | 'Field_Summary'
                  | 'Field_Table'
                  | 'Field_Tags'
                  | 'Field_Users';
          })
        | null
    > | null;
} & { __typename?: 'Field_Address' };

type FieldRenderer_XhMj2lGSkhJwfyqXQoCd0ZrQzq7H0yBlda1Htz0jQ_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
} & {
    __typename?:
        | 'Field_Address1'
        | 'Field_Address2'
        | 'Field_Address3'
        | 'Field_AddressAutoComplete'
        | 'Field_AddressCity'
        | 'Field_AddressCountry'
        | 'Field_AddressState'
        | 'Field_AddressZip'
        | 'Field_Calculations'
        | 'Field_Categories'
        | 'Field_DateAmPmDropdown'
        | 'Field_DateAmPmNumber'
        | 'Field_DateDate'
        | 'Field_DateDayDropdown'
        | 'Field_DateDayNumber'
        | 'Field_DateHourDropdown'
        | 'Field_DateHourNumber'
        | 'Field_DateMinuteDropdown'
        | 'Field_DateMinuteNumber'
        | 'Field_DateMonthDropdown';
};

type FieldRenderer_WOfGGxEulI2Hhcr8bBql70JsJtL6qh1cAnLfqfe_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
} & {
    __typename?:
        | 'Field_DateMonthNumber'
        | 'Field_DateSecondDropdown'
        | 'Field_DateSecondNumber'
        | 'Field_DateTime'
        | 'Field_DateYearDropdown'
        | 'Field_DateYearNumber'
        | 'Field_Entries'
        | 'Field_Group'
        | 'Field_Hidden'
        | 'Field_Html'
        | 'Field_NameFirst'
        | 'Field_NameLast'
        | 'Field_NameMiddle'
        | 'Field_NamePrefix'
        | 'Field_Password'
        | 'Field_Payment'
        | 'Field_Recipients'
        | 'Field_Repeater'
        | 'Field_Section'
        | 'Field_Signature';
};

type FieldRenderer_Fqkis68Ip6uxyVCij2jvEbhJd9oBq3JoJ8MvfdFr5X0_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
} & { __typename?: 'Field_Summary' | 'Field_Table' | 'Field_Tags' | 'Field_Users' };

type FieldRenderer_Field_Agree_Field_Newsletter_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    checkedValue?: string | null;
    uncheckedValue?: string | null;
    descriptionHtml?: string | null;
    defaultState?: boolean | null;
} & { __typename?: 'Field_Agree' | 'Field_Newsletter' };

type FieldRenderer_Field_Checkboxes_Field_Radio_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    options?: Array<
        ({ isDefault?: boolean | null; value?: string | null } & { __typename?: 'FieldOption' }) | null
    > | null;
} & { __typename?: 'Field_Checkboxes' | 'Field_Radio' };

type FieldRenderer_Field_Date_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    displayType?: string | null;
    defaultDate?: any | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_Date' };

type FieldRenderer_Field_Dropdown_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    options?: Array<
        | ({ label?: string | null; isDefault?: boolean | null; value?: string | null } & {
              __typename?: 'FieldOption';
          })
        | null
    > | null;
} & { __typename?: 'Field_Dropdown' };

type FieldRenderer_Field_Email_Field_Phone_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_Email' | 'Field_Phone' };

type FieldRenderer_Field_FileUpload_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    allowedKinds?: Array<string | null> | null;
    limitFiles?: string | null;
    sizeLimit?: string | null;
    sizeMinLimit?: string | null;
} & { __typename?: 'Field_FileUpload' };

type FieldRenderer_Field_Heading_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    headingSize?: string | null;
} & { __typename?: 'Field_Heading' };

type FieldRenderer_Field_MultiLineText_Field_SingleLineText_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    limit?: boolean | null;
    maxType?: string | null;
    max?: number | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_MultiLineText' | 'Field_SingleLineText' };

type FieldRenderer_Field_Name_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    fields?: Array<
        | ({
              label?: string | null;
              enabled?: boolean | null;
              required?: boolean | null;
              handle?: string | null;
              placeholder?: string | null;
          } & {
              __typename?:
                  | 'Field_Address'
                  | 'Field_Address1'
                  | 'Field_Address2'
                  | 'Field_Address3'
                  | 'Field_AddressAutoComplete'
                  | 'Field_AddressCity'
                  | 'Field_AddressCountry'
                  | 'Field_AddressState'
                  | 'Field_AddressZip'
                  | 'Field_Agree'
                  | 'Field_Calculations'
                  | 'Field_Categories'
                  | 'Field_Checkboxes'
                  | 'Field_Date'
                  | 'Field_DateAmPmDropdown'
                  | 'Field_DateAmPmNumber'
                  | 'Field_DateDate'
                  | 'Field_DateDayDropdown'
                  | 'Field_DateDayNumber'
                  | 'Field_DateHourDropdown';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              required?: boolean | null;
              handle?: string | null;
              placeholder?: string | null;
          } & {
              __typename?:
                  | 'Field_DateHourNumber'
                  | 'Field_DateMinuteDropdown'
                  | 'Field_DateMinuteNumber'
                  | 'Field_DateMonthDropdown'
                  | 'Field_DateMonthNumber'
                  | 'Field_DateSecondDropdown'
                  | 'Field_DateSecondNumber'
                  | 'Field_DateTime'
                  | 'Field_DateYearDropdown'
                  | 'Field_DateYearNumber'
                  | 'Field_Dropdown'
                  | 'Field_Email'
                  | 'Field_Entries'
                  | 'Field_FileUpload'
                  | 'Field_Group'
                  | 'Field_Heading'
                  | 'Field_Hidden'
                  | 'Field_Html'
                  | 'Field_MultiLineText'
                  | 'Field_Name';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              required?: boolean | null;
              handle?: string | null;
              placeholder?: string | null;
          } & {
              __typename?:
                  | 'Field_NameFirst'
                  | 'Field_NameLast'
                  | 'Field_NameMiddle'
                  | 'Field_NamePrefix'
                  | 'Field_Newsletter'
                  | 'Field_Number'
                  | 'Field_Password'
                  | 'Field_Payment'
                  | 'Field_Phone'
                  | 'Field_Radio'
                  | 'Field_Recipients'
                  | 'Field_Repeater'
                  | 'Field_Section'
                  | 'Field_Signature'
                  | 'Field_SingleLineText'
                  | 'Field_Summary'
                  | 'Field_Table'
                  | 'Field_Tags'
                  | 'Field_Users';
          })
        | null
    > | null;
} & { __typename?: 'Field_Name' };

type FieldRenderer_Field_Number_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
    defaultValue?: string | null;
    min?: number | null;
    max?: number | null;
} & { __typename?: 'Field_Number' };

export type FieldRendererFragment =
    | FieldRenderer_Field_Address_Fragment
    | FieldRenderer_XhMj2lGSkhJwfyqXQoCd0ZrQzq7H0yBlda1Htz0jQ_Fragment
    | FieldRenderer_WOfGGxEulI2Hhcr8bBql70JsJtL6qh1cAnLfqfe_Fragment
    | FieldRenderer_Fqkis68Ip6uxyVCij2jvEbhJd9oBq3JoJ8MvfdFr5X0_Fragment
    | FieldRenderer_Field_Agree_Field_Newsletter_Fragment
    | FieldRenderer_Field_Checkboxes_Field_Radio_Fragment
    | FieldRenderer_Field_Date_Fragment
    | FieldRenderer_Field_Dropdown_Fragment
    | FieldRenderer_Field_Email_Field_Phone_Fragment
    | FieldRenderer_Field_FileUpload_Fragment
    | FieldRenderer_Field_Heading_Fragment
    | FieldRenderer_Field_MultiLineText_Field_SingleLineText_Fragment
    | FieldRenderer_Field_Name_Fragment
    | FieldRenderer_Field_Number_Fragment;

type Field_My3BcfnixWzKkIiHUParmVrQxQhY539QciEsyJut4_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
} & {
    __typename?:
        | 'Field_Address'
        | 'Field_Address1'
        | 'Field_Address2'
        | 'Field_Address3'
        | 'Field_AddressAutoComplete'
        | 'Field_AddressCity'
        | 'Field_AddressCountry'
        | 'Field_AddressState'
        | 'Field_AddressZip'
        | 'Field_Agree'
        | 'Field_Calculations'
        | 'Field_Categories'
        | 'Field_Checkboxes'
        | 'Field_Date'
        | 'Field_DateAmPmDropdown'
        | 'Field_DateAmPmNumber'
        | 'Field_DateDate'
        | 'Field_DateDayDropdown'
        | 'Field_DateDayNumber'
        | 'Field_DateHourDropdown';
};

type Field_ZwuNgXcks4_3iRzbLj72umltEmZ9N8whadVFvZcvI_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
} & {
    __typename?:
        | 'Field_DateHourNumber'
        | 'Field_DateMinuteDropdown'
        | 'Field_DateMinuteNumber'
        | 'Field_DateMonthDropdown'
        | 'Field_DateMonthNumber'
        | 'Field_DateSecondDropdown'
        | 'Field_DateSecondNumber'
        | 'Field_DateTime'
        | 'Field_DateYearDropdown'
        | 'Field_DateYearNumber'
        | 'Field_Dropdown'
        | 'Field_Email'
        | 'Field_Entries'
        | 'Field_FileUpload'
        | 'Field_Group'
        | 'Field_Heading'
        | 'Field_Hidden'
        | 'Field_Html'
        | 'Field_MultiLineText'
        | 'Field_Name';
};

type Field_QXpd0tnJ6F31nZGmJkpKn2keG7YE52nPsj5IklZbu_Fragment = {
    instructions?: string | null;
    instructionsPosition?: string | null;
    label?: string | null;
    placeholder?: string | null;
    required?: boolean | null;
    handle?: string | null;
    errorMessage?: string | null;
} & {
    __typename?:
        | 'Field_NameFirst'
        | 'Field_NameLast'
        | 'Field_NameMiddle'
        | 'Field_NamePrefix'
        | 'Field_Newsletter'
        | 'Field_Number'
        | 'Field_Password'
        | 'Field_Payment'
        | 'Field_Phone'
        | 'Field_Radio'
        | 'Field_Recipients'
        | 'Field_Repeater'
        | 'Field_Section'
        | 'Field_Signature'
        | 'Field_SingleLineText'
        | 'Field_Summary'
        | 'Field_Table'
        | 'Field_Tags'
        | 'Field_Users';
};

export type FieldFragment =
    | Field_My3BcfnixWzKkIiHUParmVrQxQhY539QciEsyJut4_Fragment
    | Field_ZwuNgXcks4_3iRzbLj72umltEmZ9N8whadVFvZcvI_Fragment
    | Field_QXpd0tnJ6F31nZGmJkpKn2keG7YE52nPsj5IklZbu_Fragment;

export type FooterItemsFragment = {
    title?: string | null;
    children: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              menuLink?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'page_Entry'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
          } & { __typename: 'footerLink_Entry' })
    >;
} & { __typename?: 'footerCategory_Entry' };

export type FooterSubmenuFragment = {
    title?: string | null;
    menuLink?:
        | ({
              label?: string | null;
              target?: string | null;
              url?: string | null;
              type?: string | null;
              element?:
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'Address'
                            | 'Element'
                            | 'User'
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'assetTags_Tag'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'contact_GlobalSet'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'library_Asset'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'news_Entry'
                            | 'notification_GlobalSet'
                            | 'opgave20april_Form'
                            | 'opgaveBt2026_Form'
                            | 'opgaveDeelname_Form'
                            | 'opgaveSjouw22022_Form'
                            | 'opgaveSjouw_Form'
                            | 'page_Entry'
                            | 'searchTags_Tag'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'synonyms_Tag'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
          } & { __typename?: 'LinkData' })
        | null;
} & { __typename: 'footerLink_Entry' };

export type FormFragment = {
    id?: string | null;
    handle?: string | null;
    siteId?: number | null;
    settings?:
        | ({
              submitActionFormHide?: boolean | null;
              submitActionMessageHtml?: string | null;
              submitAction?: string | null;
              submitActionTab?: string | null;
              redirectUrl?: string | null;
              integrations?: Array<
                  | ({ handle?: string | null; enabled?: boolean | null } & { __typename?: 'FormIntegrationsType' })
                  | null
              > | null;
          } & { __typename?: 'FormSettingsType' })
        | null;
    formFields?: Array<
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              fields?: Array<
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        required?: boolean | null;
                        placeholder?: string | null;
                        handle?: string | null;
                    } & {
                        __typename?:
                            | 'Field_Address'
                            | 'Field_Address1'
                            | 'Field_Address2'
                            | 'Field_Address3'
                            | 'Field_AddressAutoComplete'
                            | 'Field_AddressCity'
                            | 'Field_AddressCountry'
                            | 'Field_AddressState'
                            | 'Field_AddressZip'
                            | 'Field_Agree'
                            | 'Field_Calculations'
                            | 'Field_Categories'
                            | 'Field_Checkboxes'
                            | 'Field_Date'
                            | 'Field_DateAmPmDropdown'
                            | 'Field_DateAmPmNumber'
                            | 'Field_DateDate'
                            | 'Field_DateDayDropdown'
                            | 'Field_DateDayNumber'
                            | 'Field_DateHourDropdown';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        required?: boolean | null;
                        placeholder?: string | null;
                        handle?: string | null;
                    } & {
                        __typename?:
                            | 'Field_DateHourNumber'
                            | 'Field_DateMinuteDropdown'
                            | 'Field_DateMinuteNumber'
                            | 'Field_DateMonthDropdown'
                            | 'Field_DateMonthNumber'
                            | 'Field_DateSecondDropdown'
                            | 'Field_DateSecondNumber'
                            | 'Field_DateTime'
                            | 'Field_DateYearDropdown'
                            | 'Field_DateYearNumber'
                            | 'Field_Dropdown'
                            | 'Field_Email'
                            | 'Field_Entries'
                            | 'Field_FileUpload'
                            | 'Field_Group'
                            | 'Field_Heading'
                            | 'Field_Hidden'
                            | 'Field_Html'
                            | 'Field_MultiLineText'
                            | 'Field_Name';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        required?: boolean | null;
                        placeholder?: string | null;
                        handle?: string | null;
                    } & {
                        __typename?:
                            | 'Field_NameFirst'
                            | 'Field_NameLast'
                            | 'Field_NameMiddle'
                            | 'Field_NamePrefix'
                            | 'Field_Newsletter'
                            | 'Field_Number'
                            | 'Field_Password'
                            | 'Field_Payment'
                            | 'Field_Phone'
                            | 'Field_Radio'
                            | 'Field_Recipients'
                            | 'Field_Repeater'
                            | 'Field_Section'
                            | 'Field_Signature'
                            | 'Field_SingleLineText'
                            | 'Field_Summary'
                            | 'Field_Table'
                            | 'Field_Tags'
                            | 'Field_Users';
                    })
                  | null
              > | null;
          } & { __typename?: 'Field_Address' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
          } & {
              __typename?:
                  | 'Field_Address1'
                  | 'Field_Address2'
                  | 'Field_Address3'
                  | 'Field_AddressAutoComplete'
                  | 'Field_AddressCity'
                  | 'Field_AddressCountry'
                  | 'Field_AddressState'
                  | 'Field_AddressZip'
                  | 'Field_Calculations'
                  | 'Field_Categories'
                  | 'Field_DateAmPmDropdown'
                  | 'Field_DateAmPmNumber'
                  | 'Field_DateDate'
                  | 'Field_DateDayDropdown'
                  | 'Field_DateDayNumber'
                  | 'Field_DateHourDropdown'
                  | 'Field_DateHourNumber'
                  | 'Field_DateMinuteDropdown'
                  | 'Field_DateMinuteNumber'
                  | 'Field_DateMonthDropdown';
          })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
          } & {
              __typename?:
                  | 'Field_DateMonthNumber'
                  | 'Field_DateSecondDropdown'
                  | 'Field_DateSecondNumber'
                  | 'Field_DateTime'
                  | 'Field_DateYearDropdown'
                  | 'Field_DateYearNumber'
                  | 'Field_Entries'
                  | 'Field_Hidden'
                  | 'Field_Html'
                  | 'Field_NameFirst'
                  | 'Field_NameLast'
                  | 'Field_NameMiddle'
                  | 'Field_NamePrefix'
                  | 'Field_Password'
                  | 'Field_Payment'
                  | 'Field_Recipients'
                  | 'Field_Repeater'
                  | 'Field_Section'
                  | 'Field_Signature'
                  | 'Field_Summary';
          })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
          } & { __typename?: 'Field_Table' | 'Field_Tags' | 'Field_Users' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              checkedValue?: string | null;
              uncheckedValue?: string | null;
              descriptionHtml?: string | null;
              defaultState?: boolean | null;
          } & { __typename?: 'Field_Agree' | 'Field_Newsletter' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              options?: Array<
                  ({ isDefault?: boolean | null; value?: string | null } & { __typename?: 'FieldOption' }) | null
              > | null;
          } & { __typename?: 'Field_Checkboxes' | 'Field_Radio' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              displayType?: string | null;
              defaultDate?: any | null;
              defaultValue?: string | null;
          } & { __typename?: 'Field_Date' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              options?: Array<
                  | ({ label?: string | null; isDefault?: boolean | null; value?: string | null } & {
                        __typename?: 'FieldOption';
                    })
                  | null
              > | null;
          } & { __typename?: 'Field_Dropdown' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
          } & { __typename?: 'Field_Email' | 'Field_Phone' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              allowedKinds?: Array<string | null> | null;
              limitFiles?: string | null;
              sizeLimit?: string | null;
              sizeMinLimit?: string | null;
          } & { __typename?: 'Field_FileUpload' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              fields?: Array<
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        fields?: Array<
                            | ({
                                  label?: string | null;
                                  enabled?: boolean | null;
                                  errorMessage?: string | null;
                                  defaultValue?: string | null;
                                  required?: boolean | null;
                                  placeholder?: string | null;
                                  handle?: string | null;
                              } & {
                                  __typename?:
                                      | 'Field_Address'
                                      | 'Field_Address1'
                                      | 'Field_Address2'
                                      | 'Field_Address3'
                                      | 'Field_AddressAutoComplete'
                                      | 'Field_AddressCity'
                                      | 'Field_AddressCountry'
                                      | 'Field_AddressState'
                                      | 'Field_AddressZip'
                                      | 'Field_Agree'
                                      | 'Field_Calculations'
                                      | 'Field_Categories'
                                      | 'Field_Checkboxes'
                                      | 'Field_Date'
                                      | 'Field_DateAmPmDropdown'
                                      | 'Field_DateAmPmNumber'
                                      | 'Field_DateDate'
                                      | 'Field_DateDayDropdown'
                                      | 'Field_DateDayNumber'
                                      | 'Field_DateHourDropdown';
                              })
                            | ({
                                  label?: string | null;
                                  enabled?: boolean | null;
                                  errorMessage?: string | null;
                                  defaultValue?: string | null;
                                  required?: boolean | null;
                                  placeholder?: string | null;
                                  handle?: string | null;
                              } & {
                                  __typename?:
                                      | 'Field_DateHourNumber'
                                      | 'Field_DateMinuteDropdown'
                                      | 'Field_DateMinuteNumber'
                                      | 'Field_DateMonthDropdown'
                                      | 'Field_DateMonthNumber'
                                      | 'Field_DateSecondDropdown'
                                      | 'Field_DateSecondNumber'
                                      | 'Field_DateTime'
                                      | 'Field_DateYearDropdown'
                                      | 'Field_DateYearNumber'
                                      | 'Field_Dropdown'
                                      | 'Field_Email'
                                      | 'Field_Entries'
                                      | 'Field_FileUpload'
                                      | 'Field_Group'
                                      | 'Field_Heading'
                                      | 'Field_Hidden'
                                      | 'Field_Html'
                                      | 'Field_MultiLineText'
                                      | 'Field_Name';
                              })
                            | ({
                                  label?: string | null;
                                  enabled?: boolean | null;
                                  errorMessage?: string | null;
                                  defaultValue?: string | null;
                                  required?: boolean | null;
                                  placeholder?: string | null;
                                  handle?: string | null;
                              } & {
                                  __typename?:
                                      | 'Field_NameFirst'
                                      | 'Field_NameLast'
                                      | 'Field_NameMiddle'
                                      | 'Field_NamePrefix'
                                      | 'Field_Newsletter'
                                      | 'Field_Number'
                                      | 'Field_Password'
                                      | 'Field_Payment'
                                      | 'Field_Phone'
                                      | 'Field_Radio'
                                      | 'Field_Recipients'
                                      | 'Field_Repeater'
                                      | 'Field_Section'
                                      | 'Field_Signature'
                                      | 'Field_SingleLineText'
                                      | 'Field_Summary'
                                      | 'Field_Table'
                                      | 'Field_Tags'
                                      | 'Field_Users';
                              })
                            | null
                        > | null;
                    } & { __typename?: 'Field_Address' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                    } & {
                        __typename?:
                            | 'Field_Address1'
                            | 'Field_Address2'
                            | 'Field_Address3'
                            | 'Field_AddressAutoComplete'
                            | 'Field_AddressCity'
                            | 'Field_AddressCountry'
                            | 'Field_AddressState'
                            | 'Field_AddressZip'
                            | 'Field_Calculations'
                            | 'Field_Categories'
                            | 'Field_DateAmPmDropdown'
                            | 'Field_DateAmPmNumber'
                            | 'Field_DateDate'
                            | 'Field_DateDayDropdown'
                            | 'Field_DateDayNumber'
                            | 'Field_DateHourDropdown'
                            | 'Field_DateHourNumber'
                            | 'Field_DateMinuteDropdown'
                            | 'Field_DateMinuteNumber'
                            | 'Field_DateMonthDropdown';
                    })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                    } & {
                        __typename?:
                            | 'Field_DateMonthNumber'
                            | 'Field_DateSecondDropdown'
                            | 'Field_DateSecondNumber'
                            | 'Field_DateTime'
                            | 'Field_DateYearDropdown'
                            | 'Field_DateYearNumber'
                            | 'Field_Entries'
                            | 'Field_Group'
                            | 'Field_Hidden'
                            | 'Field_Html'
                            | 'Field_NameFirst'
                            | 'Field_NameLast'
                            | 'Field_NameMiddle'
                            | 'Field_NamePrefix'
                            | 'Field_Password'
                            | 'Field_Payment'
                            | 'Field_Recipients'
                            | 'Field_Repeater'
                            | 'Field_Section'
                            | 'Field_Signature';
                    })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                    } & { __typename?: 'Field_Summary' | 'Field_Table' | 'Field_Tags' | 'Field_Users' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        checkedValue?: string | null;
                        uncheckedValue?: string | null;
                        descriptionHtml?: string | null;
                        defaultState?: boolean | null;
                    } & { __typename?: 'Field_Agree' | 'Field_Newsletter' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        options?: Array<
                            | ({ isDefault?: boolean | null; value?: string | null } & { __typename?: 'FieldOption' })
                            | null
                        > | null;
                    } & { __typename?: 'Field_Checkboxes' | 'Field_Radio' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        displayType?: string | null;
                        defaultDate?: any | null;
                        defaultValue?: string | null;
                    } & { __typename?: 'Field_Date' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        options?: Array<
                            | ({ label?: string | null; isDefault?: boolean | null; value?: string | null } & {
                                  __typename?: 'FieldOption';
                              })
                            | null
                        > | null;
                    } & { __typename?: 'Field_Dropdown' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                    } & { __typename?: 'Field_Email' | 'Field_Phone' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        allowedKinds?: Array<string | null> | null;
                        limitFiles?: string | null;
                        sizeLimit?: string | null;
                        sizeMinLimit?: string | null;
                    } & { __typename?: 'Field_FileUpload' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        headingSize?: string | null;
                    } & { __typename?: 'Field_Heading' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        limit?: boolean | null;
                        maxType?: string | null;
                        max?: number | null;
                        defaultValue?: string | null;
                    } & { __typename?: 'Field_MultiLineText' | 'Field_SingleLineText' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        fields?: Array<
                            | ({
                                  label?: string | null;
                                  enabled?: boolean | null;
                                  required?: boolean | null;
                                  handle?: string | null;
                                  placeholder?: string | null;
                              } & {
                                  __typename?:
                                      | 'Field_Address'
                                      | 'Field_Address1'
                                      | 'Field_Address2'
                                      | 'Field_Address3'
                                      | 'Field_AddressAutoComplete'
                                      | 'Field_AddressCity'
                                      | 'Field_AddressCountry'
                                      | 'Field_AddressState'
                                      | 'Field_AddressZip'
                                      | 'Field_Agree'
                                      | 'Field_Calculations'
                                      | 'Field_Categories'
                                      | 'Field_Checkboxes'
                                      | 'Field_Date'
                                      | 'Field_DateAmPmDropdown'
                                      | 'Field_DateAmPmNumber'
                                      | 'Field_DateDate'
                                      | 'Field_DateDayDropdown'
                                      | 'Field_DateDayNumber'
                                      | 'Field_DateHourDropdown';
                              })
                            | ({
                                  label?: string | null;
                                  enabled?: boolean | null;
                                  required?: boolean | null;
                                  handle?: string | null;
                                  placeholder?: string | null;
                              } & {
                                  __typename?:
                                      | 'Field_DateHourNumber'
                                      | 'Field_DateMinuteDropdown'
                                      | 'Field_DateMinuteNumber'
                                      | 'Field_DateMonthDropdown'
                                      | 'Field_DateMonthNumber'
                                      | 'Field_DateSecondDropdown'
                                      | 'Field_DateSecondNumber'
                                      | 'Field_DateTime'
                                      | 'Field_DateYearDropdown'
                                      | 'Field_DateYearNumber'
                                      | 'Field_Dropdown'
                                      | 'Field_Email'
                                      | 'Field_Entries'
                                      | 'Field_FileUpload'
                                      | 'Field_Group'
                                      | 'Field_Heading'
                                      | 'Field_Hidden'
                                      | 'Field_Html'
                                      | 'Field_MultiLineText'
                                      | 'Field_Name';
                              })
                            | ({
                                  label?: string | null;
                                  enabled?: boolean | null;
                                  required?: boolean | null;
                                  handle?: string | null;
                                  placeholder?: string | null;
                              } & {
                                  __typename?:
                                      | 'Field_NameFirst'
                                      | 'Field_NameLast'
                                      | 'Field_NameMiddle'
                                      | 'Field_NamePrefix'
                                      | 'Field_Newsletter'
                                      | 'Field_Number'
                                      | 'Field_Password'
                                      | 'Field_Payment'
                                      | 'Field_Phone'
                                      | 'Field_Radio'
                                      | 'Field_Recipients'
                                      | 'Field_Repeater'
                                      | 'Field_Section'
                                      | 'Field_Signature'
                                      | 'Field_SingleLineText'
                                      | 'Field_Summary'
                                      | 'Field_Table'
                                      | 'Field_Tags'
                                      | 'Field_Users';
                              })
                            | null
                        > | null;
                    } & { __typename?: 'Field_Name' })
                  | ({
                        instructions?: string | null;
                        instructionsPosition?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        required?: boolean | null;
                        handle?: string | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        min?: number | null;
                        max?: number | null;
                    } & { __typename?: 'Field_Number' })
                  | null
              > | null;
          } & { __typename?: 'Field_Group' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              headingSize?: string | null;
          } & { __typename?: 'Field_Heading' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              limit?: boolean | null;
              maxType?: string | null;
              max?: number | null;
              defaultValue?: string | null;
          } & { __typename?: 'Field_MultiLineText' | 'Field_SingleLineText' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              fields?: Array<
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        required?: boolean | null;
                        handle?: string | null;
                        placeholder?: string | null;
                    } & {
                        __typename?:
                            | 'Field_Address'
                            | 'Field_Address1'
                            | 'Field_Address2'
                            | 'Field_Address3'
                            | 'Field_AddressAutoComplete'
                            | 'Field_AddressCity'
                            | 'Field_AddressCountry'
                            | 'Field_AddressState'
                            | 'Field_AddressZip'
                            | 'Field_Agree'
                            | 'Field_Calculations'
                            | 'Field_Categories'
                            | 'Field_Checkboxes'
                            | 'Field_Date'
                            | 'Field_DateAmPmDropdown'
                            | 'Field_DateAmPmNumber'
                            | 'Field_DateDate'
                            | 'Field_DateDayDropdown'
                            | 'Field_DateDayNumber'
                            | 'Field_DateHourDropdown';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        required?: boolean | null;
                        handle?: string | null;
                        placeholder?: string | null;
                    } & {
                        __typename?:
                            | 'Field_DateHourNumber'
                            | 'Field_DateMinuteDropdown'
                            | 'Field_DateMinuteNumber'
                            | 'Field_DateMonthDropdown'
                            | 'Field_DateMonthNumber'
                            | 'Field_DateSecondDropdown'
                            | 'Field_DateSecondNumber'
                            | 'Field_DateTime'
                            | 'Field_DateYearDropdown'
                            | 'Field_DateYearNumber'
                            | 'Field_Dropdown'
                            | 'Field_Email'
                            | 'Field_Entries'
                            | 'Field_FileUpload'
                            | 'Field_Group'
                            | 'Field_Heading'
                            | 'Field_Hidden'
                            | 'Field_Html'
                            | 'Field_MultiLineText'
                            | 'Field_Name';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        required?: boolean | null;
                        handle?: string | null;
                        placeholder?: string | null;
                    } & {
                        __typename?:
                            | 'Field_NameFirst'
                            | 'Field_NameLast'
                            | 'Field_NameMiddle'
                            | 'Field_NamePrefix'
                            | 'Field_Newsletter'
                            | 'Field_Number'
                            | 'Field_Password'
                            | 'Field_Payment'
                            | 'Field_Phone'
                            | 'Field_Radio'
                            | 'Field_Recipients'
                            | 'Field_Repeater'
                            | 'Field_Section'
                            | 'Field_Signature'
                            | 'Field_SingleLineText'
                            | 'Field_Summary'
                            | 'Field_Table'
                            | 'Field_Tags'
                            | 'Field_Users';
                    })
                  | null
              > | null;
          } & { __typename?: 'Field_Name' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              min?: number | null;
              max?: number | null;
          } & { __typename?: 'Field_Number' })
        | null
    > | null;
} & {
    __typename?:
        | 'opgave20april_Form'
        | 'opgaveBt2026_Form'
        | 'opgaveDeelname_Form'
        | 'opgaveSjouw22022_Form'
        | 'opgaveSjouw_Form';
};

type Highlight_AHAfGVjzr9L8chcagHfCk2FiJdEVxmVc1yOsSYcxc_Fragment = { title?: string | null; uri?: string | null } & {
    __typename:
        | 'action_Entry'
        | 'banner_Entry'
        | 'companies_Entry'
        | 'contact2_Entry'
        | 'contact_Entry'
        | 'events_Entry'
        | 'excursions_Entry'
        | 'externalLink_Entry'
        | 'footerCategory_Entry'
        | 'footerLink_Entry'
        | 'homepage_Entry'
        | 'menu_Entry'
        | 'myTerschelling_Entry'
        | 'news_Entry'
        | 'search_Entry'
        | 'sectionAccommodations_Entry'
        | 'sectionAccordion_Entry'
        | 'sectionAction_Entry'
        | 'sectionActivities_Entry'
        | 'sectionBanner_Entry';
};

type Highlight_VwfDamwoJ5icF0r8Mj1MlOk9sU7_2Xzo3H8puvFAgw_Fragment = { title?: string | null; uri?: string | null } & {
    __typename:
        | 'sectionBoat_Entry'
        | 'sectionButton_Entry'
        | 'sectionCompanies_Entry'
        | 'sectionEmbed_Entry'
        | 'sectionForms_Entry'
        | 'sectionHeader_Entry'
        | 'sectionHierarchicalTiles_Entry'
        | 'sectionImages_Entry'
        | 'sectionMap_Entry'
        | 'sectionText_Entry'
        | 'sectionTiles_Entry'
        | 'sectionTip_Entry'
        | 'sectionTravelbaseTiles_Entry'
        | 'sectionVideo_Entry'
        | 'sectionWebcam_Entry'
        | 'sights_Entry'
        | 'thankYou_Entry'
        | 'tip_Entry';
};

type Highlight_Article_Entry_Fragment = {
    title?: string | null;
    uri?: string | null;
    newsHeroImage: Array<
        | ({
              width?: number | null;
              height?: number | null;
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              placeholderUrl?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename: 'article_Entry' };

type Highlight_Page_Entry_Fragment = {
    title?: string | null;
    uri?: string | null;
    heroImage: Array<
        | ({
              width?: number | null;
              height?: number | null;
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              placeholderUrl?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
} & { __typename: 'page_Entry' };

export type HighlightFragment =
    | Highlight_AHAfGVjzr9L8chcagHfCk2FiJdEVxmVc1yOsSYcxc_Fragment
    | Highlight_VwfDamwoJ5icF0r8Mj1MlOk9sU7_2Xzo3H8puvFAgw_Fragment
    | Highlight_Article_Entry_Fragment
    | Highlight_Page_Entry_Fragment;

export type LinkFieldFragment = {
    label?: string | null;
    target?: string | null;
    url?: string | null;
    type?: string | null;
    element?:
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'Address'
                  | 'Element'
                  | 'User'
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'assetTags_Tag'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'contact_GlobalSet'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'library_Asset'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'news_Entry'
                  | 'notification_GlobalSet'
                  | 'opgave20april_Form'
                  | 'opgaveBt2026_Form'
                  | 'opgaveDeelname_Form'
                  | 'opgaveSjouw22022_Form'
                  | 'opgaveSjouw_Form'
                  | 'page_Entry'
                  | 'searchTags_Tag'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'synonyms_Tag'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null;
} & { __typename?: 'LinkData' };

export type MenuItemsFragment = {
    id?: string | null;
    title?: string | null;
    menuLink?:
        | ({
              label?: string | null;
              target?: string | null;
              url?: string | null;
              type?: string | null;
              element?:
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'Address'
                            | 'Element'
                            | 'User'
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'assetTags_Tag'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'contact_GlobalSet'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'library_Asset'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'news_Entry'
                            | 'notification_GlobalSet'
                            | 'opgave20april_Form'
                            | 'opgaveBt2026_Form'
                            | 'opgaveDeelname_Form'
                            | 'opgaveSjouw22022_Form'
                            | 'opgaveSjouw_Form'
                            | 'searchTags_Tag'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'synonyms_Tag'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        slug?: string | null;
                        id?: string | null;
                        settingsMenuHidden?: boolean | null;
                        parent?:
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'page_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry';
                              })
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                        children: Array<
                            | ({
                                  children: Array<
                                      | ({
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry';
                                        })
                                      | ({
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | ({
                                            slug?: string | null;
                                            id?: string | null;
                                            title?: string | null;
                                            uri?: string | null;
                                            settingsMenuHidden?: boolean | null;
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                            parent?:
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'page_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry';
                                                  })
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'sectionActivities_Entry'
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | null;
                                        } & { __typename?: 'page_Entry' })
                                  >;
                              } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              })
                            | ({
                                  children: Array<
                                      | ({
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry';
                                        })
                                      | ({
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | ({
                                            slug?: string | null;
                                            id?: string | null;
                                            title?: string | null;
                                            uri?: string | null;
                                            settingsMenuHidden?: boolean | null;
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                            parent?:
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'page_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry';
                                                  })
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'sectionActivities_Entry'
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | null;
                                        } & { __typename?: 'page_Entry' })
                                  >;
                              } & {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  children: Array<
                                      | ({
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry';
                                        })
                                      | ({
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | ({
                                            slug?: string | null;
                                            id?: string | null;
                                            title?: string | null;
                                            uri?: string | null;
                                            settingsMenuHidden?: boolean | null;
                                            children: Array<
                                                | {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  }
                                                | {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  }
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                            parent?:
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'page_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry';
                                                  })
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'sectionActivities_Entry'
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | null;
                                        } & { __typename?: 'page_Entry' })
                                  >;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & { __typename?: 'page_Entry' })
                  | null;
          } & { __typename?: 'LinkData' })
        | null;
} & { __typename?: 'menu_Entry' };

export type MenuItemPageRecursiveFragment = {
    children: Array<
        | ({
              children: Array<
                  | ({
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    })
                  | ({
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        slug?: string | null;
                        id?: string | null;
                        title?: string | null;
                        uri?: string | null;
                        settingsMenuHidden?: boolean | null;
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                        parent?:
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'page_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry';
                              })
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'page_Entry' })
              >;
          } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          })
        | ({
              children: Array<
                  | ({
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    })
                  | ({
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        slug?: string | null;
                        id?: string | null;
                        title?: string | null;
                        uri?: string | null;
                        settingsMenuHidden?: boolean | null;
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                        parent?:
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'page_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry';
                              })
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'page_Entry' })
              >;
          } & {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | ({
              slug?: string | null;
              id?: string | null;
              title?: string | null;
              uri?: string | null;
              settingsMenuHidden?: boolean | null;
              children: Array<
                  | ({
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    })
                  | ({
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        slug?: string | null;
                        id?: string | null;
                        title?: string | null;
                        uri?: string | null;
                        settingsMenuHidden?: boolean | null;
                        children: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  slug?: string | null;
                                  id?: string | null;
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'page_Entry' })
                        >;
                        parent?:
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'page_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry';
                              })
                            | ({ uri?: string | null; id?: string | null } & {
                                  __typename?:
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'page_Entry' })
              >;
              parent?:
                  | ({ uri?: string | null; id?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ uri?: string | null; id?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
          } & { __typename?: 'page_Entry' })
    >;
} & { __typename?: 'page_Entry' };

export type MenuItemPageFieldsFragment = {
    slug?: string | null;
    id?: string | null;
    title?: string | null;
    uri?: string | null;
    settingsMenuHidden?: boolean | null;
    parent?:
        | ({ uri?: string | null; id?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ uri?: string | null; id?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null;
} & { __typename?: 'page_Entry' };

export type NotificationFragment = {
    header?: string | null;
    active?: boolean | null;
    enabled?: boolean | null;
    button?:
        | ({
              label?: string | null;
              target?: string | null;
              url?: string | null;
              type?: string | null;
              element?:
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'Address'
                            | 'Element'
                            | 'User'
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'assetTags_Tag'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'contact_GlobalSet'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'library_Asset'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'news_Entry'
                            | 'notification_GlobalSet'
                            | 'opgave20april_Form'
                            | 'opgaveBt2026_Form'
                            | 'opgaveDeelname_Form'
                            | 'opgaveSjouw22022_Form'
                            | 'opgaveSjouw_Form'
                            | 'page_Entry'
                            | 'searchTags_Tag'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'synonyms_Tag'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
          } & { __typename?: 'LinkData' })
        | null;
    description?: ({ html?: string | null } & { __typename?: 'description_CkeditorField' }) | null;
} & { __typename?: 'notification_GlobalSet' };

export type PhotosCarouselGalleryFragment = {
    assetSource?: string | null;
    focalPoint?: Array<number | null> | null;
    title?: string | null;
    extension: string;
    url?: string | null;
    width?: number | null;
    height?: number | null;
    placeholderUrl?: string | null;
    srcset?: string | null;
    srcsetWebp?: string | null;
} & { __typename?: 'library_Asset' };

export type ReadMoreQueryVariables = Exact<{
    parentId?: InputMaybe<Scalars['Int']>;
    id?: InputMaybe<Scalars['Int']>;
    q?: InputMaybe<Scalars['String']>;
    notId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>> | InputMaybe<Scalars['QueryArgument']>>;
    lang?: InputMaybe<Scalars['String']>;
}>;

export type ReadMoreQuery = {
    siblings?: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              newsHeroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'article_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              heroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'page_Entry' })
        | null
    > | null;
    ancestors?: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              newsHeroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'article_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              heroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'page_Entry' })
        | null
    > | null;
    search?: Array<
        | ({
              postDate?: string | null;
              title?: string | null;
              type?: string | null;
              uri?: string | null;
              image?:
                  | ({
                        extension?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        title?: string | null;
                        url?: string | null;
                    } & { __typename?: 'SearchImage' })
                  | null;
          } & { __typename?: 'SearchType' })
        | null
    > | null;
} & { __typename?: 'Query' };

export type RentalUnitsQueryVariables = Exact<{
    slugs: Array<Scalars['String']> | Scalars['String'];
}>;

export type RentalUnitsQuery = {
    rentalUnits: Array<
        {
            id: string;
            name: string;
            slug: string;
            type: RentalUnitTypeEnum;
            amountBedrooms?: number | null;
            maxOccupancy: number;
            tagline: string;
            accommodation: { name: string; hasPublicPage: boolean; place: string } & { __typename?: 'Accommodation' };
            reviewStats?: ({ average: number } & { __typename?: 'ReviewStats' }) | null;
            webpListImage: {
                transform?:
                    | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                          __typename?: 'ImageTransform';
                      })
                    | null;
            } & { __typename?: 'GenericImage' };
            listImage: {
                transform?:
                    | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                          __typename?: 'ImageTransform';
                      })
                    | null;
            } & { __typename?: 'GenericImage' };
        } & { __typename?: 'RentalUnit' }
    >;
} & { __typename?: 'Query' };

export type RentalUnitFragment = {
    id: string;
    name: string;
    slug: string;
    type: RentalUnitTypeEnum;
    amountBedrooms?: number | null;
    maxOccupancy: number;
    tagline: string;
    accommodation: { name: string; hasPublicPage: boolean; place: string } & { __typename?: 'Accommodation' };
    reviewStats?: ({ average: number } & { __typename?: 'ReviewStats' }) | null;
    webpListImage: {
        transform?:
            | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                  __typename?: 'ImageTransform';
              })
            | null;
    } & { __typename?: 'GenericImage' };
    listImage: {
        transform?:
            | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                  __typename?: 'ImageTransform';
              })
            | null;
    } & { __typename?: 'GenericImage' };
} & { __typename?: 'RentalUnit' };

export type ListImageFragment = { placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
    __typename?: 'ImageTransform';
};

export type SearchFieldQueryVariables = Exact<{
    locale: Scalars['String'];
    q: Scalars['String'];
}>;

export type SearchFieldQuery = {
    globalSearch?:
        | ({
              totalHits?: number | null;
              hits?: Array<
                  | ({
                        postDate?: string | null;
                        title?: string | null;
                        type?: string | null;
                        uri?: string | null;
                        image?:
                            | ({
                                  extension?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                                  title?: string | null;
                                  url?: string | null;
                              } & { __typename?: 'SearchImage' })
                            | null;
                    } & { __typename?: 'SearchType' })
                  | null
              > | null;
          } & { __typename?: 'SearchResult' })
        | null;
} & { __typename?: 'Query' };

export type SeeAlsoQueryVariables = Exact<{
    parentId?: InputMaybe<Scalars['Int']>;
    id?: InputMaybe<Scalars['Int']>;
    q?: InputMaybe<Scalars['String']>;
    notId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>> | InputMaybe<Scalars['QueryArgument']>>;
    lang?: InputMaybe<Scalars['String']>;
}>;

export type SeeAlsoQuery = {
    siblings?: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              newsHeroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'article_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              heroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'page_Entry' })
        | null
    > | null;
    ancestors?: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename:
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              newsHeroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'article_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              heroImage: Array<
                  | ({
                        width?: number | null;
                        height?: number | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        placeholderUrl?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename: 'page_Entry' })
        | null
    > | null;
    search?: Array<
        | ({
              postDate?: string | null;
              title?: string | null;
              type?: string | null;
              uri?: string | null;
              image?:
                  | ({
                        extension?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        title?: string | null;
                        url?: string | null;
                    } & { __typename?: 'SearchImage' })
                  | null;
          } & { __typename?: 'SearchType' })
        | null
    > | null;
} & { __typename?: 'Query' };

export type UpcomingReservationsQueryVariables = Exact<{ [key: string]: never }>;

export type UpcomingReservationsQuery = {
    viewer?:
        | ({
              id?: string | null;
              orders: Array<
                  {
                      id?: string | null;
                      number?: string | null;
                      createdDate?: string | null;
                      paymentOptions?:
                          | ({ fullPaymentDueDate?: string | null; totalAmountDue: number } & {
                                __typename?: 'PaymentOptions';
                            })
                          | null;
                      orderItems: Array<
                          | ({
                                downloadVoucherUrl?: string | null;
                                status: BookingStatus;
                                requiresApproval: boolean;
                                amountAdults: number;
                                amountPets: number;
                                amountChildren: number;
                                amountBabies: number;
                                amountYouths: number;
                                arrivalDate: string;
                                departureDate: string;
                                handleDepositPayment: boolean;
                                deposit: number;
                                paymentPrice: number;
                                rentalUnit?:
                                    | ({
                                          id: string;
                                          code: string;
                                          name: string;
                                          slug: string;
                                          type: RentalUnitTypeEnum;
                                          maxOccupancy: number;
                                          amountBedrooms?: number | null;
                                          accommodation: {
                                              id: string;
                                              hasPublicPage: boolean;
                                              name: string;
                                              place: string;
                                              checkInEndTime: string;
                                              checkInStartTime: string;
                                              checkOutTime: string;
                                              type: AccommodationTypeEnum;
                                          } & { __typename?: 'Accommodation' };
                                          jpegThumbnail: {
                                              transform?:
                                                  | ({
                                                        placeholder?: string | null;
                                                        srcSet: string;
                                                        src: string;
                                                        ratio: number;
                                                    } & { __typename?: 'ImageTransform' })
                                                  | null;
                                          } & { __typename?: 'GenericImage' };
                                          webpThumbnail: {
                                              transform?:
                                                  | ({
                                                        placeholder?: string | null;
                                                        srcSet: string;
                                                        src: string;
                                                        ratio: number;
                                                    } & { __typename?: 'ImageTransform' })
                                                  | null;
                                          } & { __typename?: 'GenericImage' };
                                      } & { __typename?: 'RentalUnit' })
                                    | null;
                            } & { __typename?: 'Booking' })
                          | { __typename?: 'Ticket' | 'UpsellPurchase' }
                      >;
                  } & { __typename?: 'Order' }
              >;
          } & { __typename?: 'Customer' })
        | null;
} & { __typename?: 'Query' };

export type MyOrderFragment = {
    id?: string | null;
    number?: string | null;
    createdDate?: string | null;
    paymentOptions?:
        | ({ fullPaymentDueDate?: string | null; totalAmountDue: number } & { __typename?: 'PaymentOptions' })
        | null;
    orderItems: Array<
        | ({
              downloadVoucherUrl?: string | null;
              status: BookingStatus;
              requiresApproval: boolean;
              amountAdults: number;
              amountPets: number;
              amountChildren: number;
              amountBabies: number;
              amountYouths: number;
              arrivalDate: string;
              departureDate: string;
              handleDepositPayment: boolean;
              deposit: number;
              paymentPrice: number;
              rentalUnit?:
                  | ({
                        id: string;
                        code: string;
                        name: string;
                        slug: string;
                        type: RentalUnitTypeEnum;
                        maxOccupancy: number;
                        amountBedrooms?: number | null;
                        accommodation: {
                            id: string;
                            hasPublicPage: boolean;
                            name: string;
                            place: string;
                            checkInEndTime: string;
                            checkInStartTime: string;
                            checkOutTime: string;
                            type: AccommodationTypeEnum;
                        } & { __typename?: 'Accommodation' };
                        jpegThumbnail: {
                            transform?:
                                | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                      __typename?: 'ImageTransform';
                                  })
                                | null;
                        } & { __typename?: 'GenericImage' };
                        webpThumbnail: {
                            transform?:
                                | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                      __typename?: 'ImageTransform';
                                  })
                                | null;
                        } & { __typename?: 'GenericImage' };
                    } & { __typename?: 'RentalUnit' })
                  | null;
          } & { __typename?: 'Booking' })
        | { __typename?: 'Ticket' | 'UpsellPurchase' }
    >;
} & { __typename?: 'Order' };

type OrderItem_Booking_Fragment = {
    downloadVoucherUrl?: string | null;
    status: BookingStatus;
    requiresApproval: boolean;
    amountAdults: number;
    amountPets: number;
    amountChildren: number;
    amountBabies: number;
    amountYouths: number;
    arrivalDate: string;
    departureDate: string;
    handleDepositPayment: boolean;
    deposit: number;
    paymentPrice: number;
    rentalUnit?:
        | ({
              id: string;
              code: string;
              name: string;
              slug: string;
              type: RentalUnitTypeEnum;
              maxOccupancy: number;
              amountBedrooms?: number | null;
              accommodation: {
                  id: string;
                  hasPublicPage: boolean;
                  name: string;
                  place: string;
                  checkInEndTime: string;
                  checkInStartTime: string;
                  checkOutTime: string;
                  type: AccommodationTypeEnum;
              } & { __typename?: 'Accommodation' };
              jpegThumbnail: {
                  transform?:
                      | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                            __typename?: 'ImageTransform';
                        })
                      | null;
              } & { __typename?: 'GenericImage' };
              webpThumbnail: {
                  transform?:
                      | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                            __typename?: 'ImageTransform';
                        })
                      | null;
              } & { __typename?: 'GenericImage' };
          } & { __typename?: 'RentalUnit' })
        | null;
} & { __typename?: 'Booking' };

type OrderItem_Ticket_UpsellPurchase_Fragment = { __typename?: 'Ticket' | 'UpsellPurchase' };

export type OrderItemFragment = OrderItem_Booking_Fragment | OrderItem_Ticket_UpsellPurchase_Fragment;

export type TransformFragment = { placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
    __typename?: 'ImageTransform';
};

export type BannerFragment = {
    title?: string | null;
    heroImage: Array<({ thumbUrl?: string | null } & { __typename?: 'library_Asset' }) | null>;
    button?:
        | ({
              label?: string | null;
              target?: string | null;
              url?: string | null;
              type?: string | null;
              element?:
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'Address'
                            | 'Element'
                            | 'User'
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'assetTags_Tag'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'contact_GlobalSet'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'library_Asset'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'news_Entry'
                            | 'notification_GlobalSet'
                            | 'opgave20april_Form'
                            | 'opgaveBt2026_Form'
                            | 'opgaveDeelname_Form'
                            | 'opgaveSjouw22022_Form'
                            | 'opgaveSjouw_Form'
                            | 'page_Entry'
                            | 'searchTags_Tag'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'synonyms_Tag'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
          } & { __typename?: 'LinkData' })
        | null;
} & { __typename?: 'banner_Entry' };

export type PinsFragment = {
    latitude?: any | null;
    longitude?: any | null;
    symbol?: string | null;
    label?: string | null;
} & { __typename?: 'pins_TableRow' };

export type TilesBlockFragment = {
    tilesChildren?: boolean | null;
    tilesSiblings?: boolean | null;
    tilesEntries: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
        | null
    >;
} & { __typename?: 'sectionTiles_Entry' };

export type HierarchicalTilesBlockFragment = { relationType?: string | null } & {
    __typename?: 'sectionHierarchicalTiles_Entry';
};

export type TipFragment = {
    title?: string | null;
    tipName?: string | null;
    tipRole?: string | null;
    tipText?: ({ html?: string | null } & { __typename?: 'tipText_CkeditorField' }) | null;
    tipAvatar: Array<
        | ({ height?: number | null; width?: number | null; thumbUrl?: string | null } & {
              __typename?: 'library_Asset';
          })
        | null
    >;
} & { __typename?: 'tip_Entry' };

export type RentalUnitsBySlugQueryVariables = Exact<{
    slugs: Array<Scalars['String']> | Scalars['String'];
}>;

export type RentalUnitsBySlugQuery = {
    rentalUnits: Array<
        {
            id: string;
            name: string;
            slug: string;
            tagline: string;
            webpListImage: {
                transform?:
                    | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                          __typename?: 'ImageTransform';
                      })
                    | null;
            } & { __typename?: 'GenericImage' };
            listImage: {
                transform?:
                    | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                          __typename?: 'ImageTransform';
                      })
                    | null;
            } & { __typename?: 'GenericImage' };
        } & { __typename?: 'RentalUnit' }
    >;
} & { __typename?: 'Query' };

export type CompaniesBySlugQueryVariables = Exact<{
    slugs: Array<Scalars['String']> | Scalars['String'];
}>;

export type CompaniesBySlugQuery = {
    companiesBySlug: Array<
        {
            id: string;
            name: string;
            slug: string;
            description?: string | null;
            webpListImage?:
                | ({
                      transform?:
                          | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                __typename?: 'ImageTransform';
                            })
                          | null;
                  } & { __typename?: 'GenericImage' })
                | null;
            listImage?:
                | ({
                      transform?:
                          | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                __typename?: 'ImageTransform';
                            })
                          | null;
                  } & { __typename?: 'GenericImage' })
                | null;
        } & { __typename?: 'Company' }
    >;
} & { __typename?: 'Query' };

export type ActivitiesBySlugQueryVariables = Exact<{
    slugs: Array<Scalars['String']> | Scalars['String'];
}>;

export type ActivitiesBySlugQuery = {
    activitiesBySlug: Array<
        {
            id: string;
            name: string;
            slug: string;
            description?: string | null;
            webpListImage?:
                | ({
                      transform?:
                          | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                __typename?: 'ImageTransform';
                            })
                          | null;
                  } & { __typename?: 'GenericImage' })
                | null;
            listImage?:
                | ({
                      transform?:
                          | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                __typename?: 'ImageTransform';
                            })
                          | null;
                  } & { __typename?: 'GenericImage' })
                | null;
        } & { __typename?: 'Activity' }
    >;
} & { __typename?: 'Query' };

export type AccommodationsBySlugQueryVariables = Exact<{
    slugs: Array<Scalars['String']> | Scalars['String'];
}>;

export type AccommodationsBySlugQuery = {
    accommodationsBySlug: Array<
        {
            id: string;
            name: string;
            slug: string;
            descriptionGeneral?: string | null;
            webpListImage?:
                | ({
                      transform?:
                          | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                __typename?: 'ImageTransform';
                            })
                          | null;
                  } & { __typename?: 'GenericImage' })
                | null;
            mainImage?:
                | ({
                      transform?:
                          | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                __typename?: 'ImageTransform';
                            })
                          | null;
                  } & { __typename?: 'GenericImage' })
                | null;
        } & { __typename?: 'Accommodation' }
    >;
} & { __typename?: 'Query' };

export type RentalUnitsBySlugFragment = {
    id: string;
    name: string;
    slug: string;
    tagline: string;
    webpListImage: {
        transform?:
            | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                  __typename?: 'ImageTransform';
              })
            | null;
    } & { __typename?: 'GenericImage' };
    listImage: {
        transform?:
            | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                  __typename?: 'ImageTransform';
              })
            | null;
    } & { __typename?: 'GenericImage' };
} & { __typename?: 'RentalUnit' };

export type AccommodationsBySlugFragment = {
    id: string;
    name: string;
    slug: string;
    descriptionGeneral?: string | null;
    webpListImage?:
        | ({
              transform?:
                  | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                        __typename?: 'ImageTransform';
                    })
                  | null;
          } & { __typename?: 'GenericImage' })
        | null;
    mainImage?:
        | ({
              transform?:
                  | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                        __typename?: 'ImageTransform';
                    })
                  | null;
          } & { __typename?: 'GenericImage' })
        | null;
} & { __typename?: 'Accommodation' };

export type AddressFieldFragment = {
    fields?: Array<
        | ({
              label?: string | null;
              enabled?: boolean | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              required?: boolean | null;
              placeholder?: string | null;
              handle?: string | null;
          } & {
              __typename?:
                  | 'Field_Address'
                  | 'Field_Address1'
                  | 'Field_Address2'
                  | 'Field_Address3'
                  | 'Field_AddressAutoComplete'
                  | 'Field_AddressCity'
                  | 'Field_AddressCountry'
                  | 'Field_AddressState'
                  | 'Field_AddressZip'
                  | 'Field_Agree'
                  | 'Field_Calculations'
                  | 'Field_Categories'
                  | 'Field_Checkboxes'
                  | 'Field_Date'
                  | 'Field_DateAmPmDropdown'
                  | 'Field_DateAmPmNumber'
                  | 'Field_DateDate'
                  | 'Field_DateDayDropdown'
                  | 'Field_DateDayNumber'
                  | 'Field_DateHourDropdown';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              required?: boolean | null;
              placeholder?: string | null;
              handle?: string | null;
          } & {
              __typename?:
                  | 'Field_DateHourNumber'
                  | 'Field_DateMinuteDropdown'
                  | 'Field_DateMinuteNumber'
                  | 'Field_DateMonthDropdown'
                  | 'Field_DateMonthNumber'
                  | 'Field_DateSecondDropdown'
                  | 'Field_DateSecondNumber'
                  | 'Field_DateTime'
                  | 'Field_DateYearDropdown'
                  | 'Field_DateYearNumber'
                  | 'Field_Dropdown'
                  | 'Field_Email'
                  | 'Field_Entries'
                  | 'Field_FileUpload'
                  | 'Field_Group'
                  | 'Field_Heading'
                  | 'Field_Hidden'
                  | 'Field_Html'
                  | 'Field_MultiLineText'
                  | 'Field_Name';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              required?: boolean | null;
              placeholder?: string | null;
              handle?: string | null;
          } & {
              __typename?:
                  | 'Field_NameFirst'
                  | 'Field_NameLast'
                  | 'Field_NameMiddle'
                  | 'Field_NamePrefix'
                  | 'Field_Newsletter'
                  | 'Field_Number'
                  | 'Field_Password'
                  | 'Field_Payment'
                  | 'Field_Phone'
                  | 'Field_Radio'
                  | 'Field_Recipients'
                  | 'Field_Repeater'
                  | 'Field_Section'
                  | 'Field_Signature'
                  | 'Field_SingleLineText'
                  | 'Field_Summary'
                  | 'Field_Table'
                  | 'Field_Tags'
                  | 'Field_Users';
          })
        | null
    > | null;
} & { __typename?: 'Field_Address' };

type AgreeField_2bJwn8FkVrOg5YboXpRo8VapiGvpeZy0dvS1fsr2yc_Fragment = {
    __typename?:
        | 'Field_Address'
        | 'Field_Address1'
        | 'Field_Address2'
        | 'Field_Address3'
        | 'Field_AddressAutoComplete'
        | 'Field_AddressCity'
        | 'Field_AddressCountry'
        | 'Field_AddressState'
        | 'Field_AddressZip'
        | 'Field_Calculations'
        | 'Field_Categories'
        | 'Field_Checkboxes'
        | 'Field_Date'
        | 'Field_DateAmPmDropdown'
        | 'Field_DateAmPmNumber'
        | 'Field_DateDate'
        | 'Field_DateDayDropdown'
        | 'Field_DateDayNumber'
        | 'Field_DateHourDropdown'
        | 'Field_DateHourNumber';
};

type AgreeField_VEj7YjRcDbH2mxelS4eFTdZtutz9Qn1elRmaBbE8Q_Fragment = {
    __typename?:
        | 'Field_DateMinuteDropdown'
        | 'Field_DateMinuteNumber'
        | 'Field_DateMonthDropdown'
        | 'Field_DateMonthNumber'
        | 'Field_DateSecondDropdown'
        | 'Field_DateSecondNumber'
        | 'Field_DateTime'
        | 'Field_DateYearDropdown'
        | 'Field_DateYearNumber'
        | 'Field_Dropdown'
        | 'Field_Email'
        | 'Field_Entries'
        | 'Field_FileUpload'
        | 'Field_Group'
        | 'Field_Heading'
        | 'Field_Hidden'
        | 'Field_Html'
        | 'Field_MultiLineText'
        | 'Field_Name'
        | 'Field_NameFirst';
};

type AgreeField_1lhmjvl1X4OfwdrAfBd3xcNxaGxNlgCwHcetKNrq_Fragment = {
    __typename?:
        | 'Field_NameLast'
        | 'Field_NameMiddle'
        | 'Field_NamePrefix'
        | 'Field_Number'
        | 'Field_Password'
        | 'Field_Payment'
        | 'Field_Phone'
        | 'Field_Radio'
        | 'Field_Recipients'
        | 'Field_Repeater'
        | 'Field_Section'
        | 'Field_Signature'
        | 'Field_SingleLineText'
        | 'Field_Summary'
        | 'Field_Table'
        | 'Field_Tags'
        | 'Field_Users';
};

type AgreeField_Field_Agree_Field_Newsletter_Fragment = {
    checkedValue?: string | null;
    uncheckedValue?: string | null;
    descriptionHtml?: string | null;
    defaultState?: boolean | null;
    required?: boolean | null;
} & { __typename?: 'Field_Agree' | 'Field_Newsletter' };

export type AgreeFieldFragment =
    | AgreeField_2bJwn8FkVrOg5YboXpRo8VapiGvpeZy0dvS1fsr2yc_Fragment
    | AgreeField_VEj7YjRcDbH2mxelS4eFTdZtutz9Qn1elRmaBbE8Q_Fragment
    | AgreeField_1lhmjvl1X4OfwdrAfBd3xcNxaGxNlgCwHcetKNrq_Fragment
    | AgreeField_Field_Agree_Field_Newsletter_Fragment;

export type BaseAgreeFieldFragment = {
    checkedValue?: string | null;
    uncheckedValue?: string | null;
    descriptionHtml?: string | null;
    defaultState?: boolean | null;
    required?: boolean | null;
} & { __typename?: 'Field_Agree' };

export type NewsletterAgreeFieldFragment = {
    checkedValue?: string | null;
    uncheckedValue?: string | null;
    descriptionHtml?: string | null;
    defaultState?: boolean | null;
    required?: boolean | null;
} & { __typename?: 'Field_Newsletter' };

export type CheckboxesFieldFragment = {
    options?: Array<
        ({ isDefault?: boolean | null; value?: string | null } & { __typename?: 'FieldOption' }) | null
    > | null;
} & { __typename?: 'Field_Checkboxes' };

export type DateFieldFragment = {
    displayType?: string | null;
    defaultDate?: any | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_Date' };

export type DropdownFieldFragment = {
    options?: Array<
        | ({ label?: string | null; isDefault?: boolean | null; value?: string | null } & {
              __typename?: 'FieldOption';
          })
        | null
    > | null;
} & { __typename?: 'Field_Dropdown' };

export type FileFieldFragment = {
    allowedKinds?: Array<string | null> | null;
    limitFiles?: string | null;
    sizeLimit?: string | null;
    sizeMinLimit?: string | null;
} & { __typename?: 'Field_FileUpload' };

export type GroupFieldFragment = {
    fields?: Array<
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              fields?: Array<
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        required?: boolean | null;
                        placeholder?: string | null;
                        handle?: string | null;
                    } & {
                        __typename?:
                            | 'Field_Address'
                            | 'Field_Address1'
                            | 'Field_Address2'
                            | 'Field_Address3'
                            | 'Field_AddressAutoComplete'
                            | 'Field_AddressCity'
                            | 'Field_AddressCountry'
                            | 'Field_AddressState'
                            | 'Field_AddressZip'
                            | 'Field_Agree'
                            | 'Field_Calculations'
                            | 'Field_Categories'
                            | 'Field_Checkboxes'
                            | 'Field_Date'
                            | 'Field_DateAmPmDropdown'
                            | 'Field_DateAmPmNumber'
                            | 'Field_DateDate'
                            | 'Field_DateDayDropdown'
                            | 'Field_DateDayNumber'
                            | 'Field_DateHourDropdown';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        required?: boolean | null;
                        placeholder?: string | null;
                        handle?: string | null;
                    } & {
                        __typename?:
                            | 'Field_DateHourNumber'
                            | 'Field_DateMinuteDropdown'
                            | 'Field_DateMinuteNumber'
                            | 'Field_DateMonthDropdown'
                            | 'Field_DateMonthNumber'
                            | 'Field_DateSecondDropdown'
                            | 'Field_DateSecondNumber'
                            | 'Field_DateTime'
                            | 'Field_DateYearDropdown'
                            | 'Field_DateYearNumber'
                            | 'Field_Dropdown'
                            | 'Field_Email'
                            | 'Field_Entries'
                            | 'Field_FileUpload'
                            | 'Field_Group'
                            | 'Field_Heading'
                            | 'Field_Hidden'
                            | 'Field_Html'
                            | 'Field_MultiLineText'
                            | 'Field_Name';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        errorMessage?: string | null;
                        defaultValue?: string | null;
                        required?: boolean | null;
                        placeholder?: string | null;
                        handle?: string | null;
                    } & {
                        __typename?:
                            | 'Field_NameFirst'
                            | 'Field_NameLast'
                            | 'Field_NameMiddle'
                            | 'Field_NamePrefix'
                            | 'Field_Newsletter'
                            | 'Field_Number'
                            | 'Field_Password'
                            | 'Field_Payment'
                            | 'Field_Phone'
                            | 'Field_Radio'
                            | 'Field_Recipients'
                            | 'Field_Repeater'
                            | 'Field_Section'
                            | 'Field_Signature'
                            | 'Field_SingleLineText'
                            | 'Field_Summary'
                            | 'Field_Table'
                            | 'Field_Tags'
                            | 'Field_Users';
                    })
                  | null
              > | null;
          } & { __typename?: 'Field_Address' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
          } & {
              __typename?:
                  | 'Field_Address1'
                  | 'Field_Address2'
                  | 'Field_Address3'
                  | 'Field_AddressAutoComplete'
                  | 'Field_AddressCity'
                  | 'Field_AddressCountry'
                  | 'Field_AddressState'
                  | 'Field_AddressZip'
                  | 'Field_Calculations'
                  | 'Field_Categories'
                  | 'Field_DateAmPmDropdown'
                  | 'Field_DateAmPmNumber'
                  | 'Field_DateDate'
                  | 'Field_DateDayDropdown'
                  | 'Field_DateDayNumber'
                  | 'Field_DateHourDropdown'
                  | 'Field_DateHourNumber'
                  | 'Field_DateMinuteDropdown'
                  | 'Field_DateMinuteNumber'
                  | 'Field_DateMonthDropdown';
          })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
          } & {
              __typename?:
                  | 'Field_DateMonthNumber'
                  | 'Field_DateSecondDropdown'
                  | 'Field_DateSecondNumber'
                  | 'Field_DateTime'
                  | 'Field_DateYearDropdown'
                  | 'Field_DateYearNumber'
                  | 'Field_Entries'
                  | 'Field_Group'
                  | 'Field_Hidden'
                  | 'Field_Html'
                  | 'Field_NameFirst'
                  | 'Field_NameLast'
                  | 'Field_NameMiddle'
                  | 'Field_NamePrefix'
                  | 'Field_Password'
                  | 'Field_Payment'
                  | 'Field_Recipients'
                  | 'Field_Repeater'
                  | 'Field_Section'
                  | 'Field_Signature';
          })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
          } & { __typename?: 'Field_Summary' | 'Field_Table' | 'Field_Tags' | 'Field_Users' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              checkedValue?: string | null;
              uncheckedValue?: string | null;
              descriptionHtml?: string | null;
              defaultState?: boolean | null;
          } & { __typename?: 'Field_Agree' | 'Field_Newsletter' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              options?: Array<
                  ({ isDefault?: boolean | null; value?: string | null } & { __typename?: 'FieldOption' }) | null
              > | null;
          } & { __typename?: 'Field_Checkboxes' | 'Field_Radio' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              displayType?: string | null;
              defaultDate?: any | null;
              defaultValue?: string | null;
          } & { __typename?: 'Field_Date' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              options?: Array<
                  | ({ label?: string | null; isDefault?: boolean | null; value?: string | null } & {
                        __typename?: 'FieldOption';
                    })
                  | null
              > | null;
          } & { __typename?: 'Field_Dropdown' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
          } & { __typename?: 'Field_Email' | 'Field_Phone' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              allowedKinds?: Array<string | null> | null;
              limitFiles?: string | null;
              sizeLimit?: string | null;
              sizeMinLimit?: string | null;
          } & { __typename?: 'Field_FileUpload' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              headingSize?: string | null;
          } & { __typename?: 'Field_Heading' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              limit?: boolean | null;
              maxType?: string | null;
              max?: number | null;
              defaultValue?: string | null;
          } & { __typename?: 'Field_MultiLineText' | 'Field_SingleLineText' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              fields?: Array<
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        required?: boolean | null;
                        handle?: string | null;
                        placeholder?: string | null;
                    } & {
                        __typename?:
                            | 'Field_Address'
                            | 'Field_Address1'
                            | 'Field_Address2'
                            | 'Field_Address3'
                            | 'Field_AddressAutoComplete'
                            | 'Field_AddressCity'
                            | 'Field_AddressCountry'
                            | 'Field_AddressState'
                            | 'Field_AddressZip'
                            | 'Field_Agree'
                            | 'Field_Calculations'
                            | 'Field_Categories'
                            | 'Field_Checkboxes'
                            | 'Field_Date'
                            | 'Field_DateAmPmDropdown'
                            | 'Field_DateAmPmNumber'
                            | 'Field_DateDate'
                            | 'Field_DateDayDropdown'
                            | 'Field_DateDayNumber'
                            | 'Field_DateHourDropdown';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        required?: boolean | null;
                        handle?: string | null;
                        placeholder?: string | null;
                    } & {
                        __typename?:
                            | 'Field_DateHourNumber'
                            | 'Field_DateMinuteDropdown'
                            | 'Field_DateMinuteNumber'
                            | 'Field_DateMonthDropdown'
                            | 'Field_DateMonthNumber'
                            | 'Field_DateSecondDropdown'
                            | 'Field_DateSecondNumber'
                            | 'Field_DateTime'
                            | 'Field_DateYearDropdown'
                            | 'Field_DateYearNumber'
                            | 'Field_Dropdown'
                            | 'Field_Email'
                            | 'Field_Entries'
                            | 'Field_FileUpload'
                            | 'Field_Group'
                            | 'Field_Heading'
                            | 'Field_Hidden'
                            | 'Field_Html'
                            | 'Field_MultiLineText'
                            | 'Field_Name';
                    })
                  | ({
                        label?: string | null;
                        enabled?: boolean | null;
                        required?: boolean | null;
                        handle?: string | null;
                        placeholder?: string | null;
                    } & {
                        __typename?:
                            | 'Field_NameFirst'
                            | 'Field_NameLast'
                            | 'Field_NameMiddle'
                            | 'Field_NamePrefix'
                            | 'Field_Newsletter'
                            | 'Field_Number'
                            | 'Field_Password'
                            | 'Field_Payment'
                            | 'Field_Phone'
                            | 'Field_Radio'
                            | 'Field_Recipients'
                            | 'Field_Repeater'
                            | 'Field_Section'
                            | 'Field_Signature'
                            | 'Field_SingleLineText'
                            | 'Field_Summary'
                            | 'Field_Table'
                            | 'Field_Tags'
                            | 'Field_Users';
                    })
                  | null
              > | null;
          } & { __typename?: 'Field_Name' })
        | ({
              instructions?: string | null;
              instructionsPosition?: string | null;
              label?: string | null;
              placeholder?: string | null;
              required?: boolean | null;
              handle?: string | null;
              errorMessage?: string | null;
              defaultValue?: string | null;
              min?: number | null;
              max?: number | null;
          } & { __typename?: 'Field_Number' })
        | null
    > | null;
} & { __typename?: 'Field_Group' };

export type HeadingFieldFragment = { headingSize?: string | null } & { __typename?: 'Field_Heading' };

export type NameFieldFragment = {
    fields?: Array<
        | ({
              label?: string | null;
              enabled?: boolean | null;
              required?: boolean | null;
              handle?: string | null;
              placeholder?: string | null;
          } & {
              __typename?:
                  | 'Field_Address'
                  | 'Field_Address1'
                  | 'Field_Address2'
                  | 'Field_Address3'
                  | 'Field_AddressAutoComplete'
                  | 'Field_AddressCity'
                  | 'Field_AddressCountry'
                  | 'Field_AddressState'
                  | 'Field_AddressZip'
                  | 'Field_Agree'
                  | 'Field_Calculations'
                  | 'Field_Categories'
                  | 'Field_Checkboxes'
                  | 'Field_Date'
                  | 'Field_DateAmPmDropdown'
                  | 'Field_DateAmPmNumber'
                  | 'Field_DateDate'
                  | 'Field_DateDayDropdown'
                  | 'Field_DateDayNumber'
                  | 'Field_DateHourDropdown';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              required?: boolean | null;
              handle?: string | null;
              placeholder?: string | null;
          } & {
              __typename?:
                  | 'Field_DateHourNumber'
                  | 'Field_DateMinuteDropdown'
                  | 'Field_DateMinuteNumber'
                  | 'Field_DateMonthDropdown'
                  | 'Field_DateMonthNumber'
                  | 'Field_DateSecondDropdown'
                  | 'Field_DateSecondNumber'
                  | 'Field_DateTime'
                  | 'Field_DateYearDropdown'
                  | 'Field_DateYearNumber'
                  | 'Field_Dropdown'
                  | 'Field_Email'
                  | 'Field_Entries'
                  | 'Field_FileUpload'
                  | 'Field_Group'
                  | 'Field_Heading'
                  | 'Field_Hidden'
                  | 'Field_Html'
                  | 'Field_MultiLineText'
                  | 'Field_Name';
          })
        | ({
              label?: string | null;
              enabled?: boolean | null;
              required?: boolean | null;
              handle?: string | null;
              placeholder?: string | null;
          } & {
              __typename?:
                  | 'Field_NameFirst'
                  | 'Field_NameLast'
                  | 'Field_NameMiddle'
                  | 'Field_NamePrefix'
                  | 'Field_Newsletter'
                  | 'Field_Number'
                  | 'Field_Password'
                  | 'Field_Payment'
                  | 'Field_Phone'
                  | 'Field_Radio'
                  | 'Field_Recipients'
                  | 'Field_Repeater'
                  | 'Field_Section'
                  | 'Field_Signature'
                  | 'Field_SingleLineText'
                  | 'Field_Summary'
                  | 'Field_Table'
                  | 'Field_Tags'
                  | 'Field_Users';
          })
        | null
    > | null;
} & { __typename?: 'Field_Name' };

export type NumberFieldFragment = { defaultValue?: string | null; min?: number | null; max?: number | null } & {
    __typename?: 'Field_Number';
};

export type RadioFieldFragment = {
    options?: Array<
        ({ isDefault?: boolean | null; value?: string | null } & { __typename?: 'FieldOption' }) | null
    > | null;
} & { __typename?: 'Field_Radio' };

type TextField_My3BcfnixWzKkIiHUParmVrQxQhY539QciEsyJut4_Fragment = {
    __typename?:
        | 'Field_Address'
        | 'Field_Address1'
        | 'Field_Address2'
        | 'Field_Address3'
        | 'Field_AddressAutoComplete'
        | 'Field_AddressCity'
        | 'Field_AddressCountry'
        | 'Field_AddressState'
        | 'Field_AddressZip'
        | 'Field_Agree'
        | 'Field_Calculations'
        | 'Field_Categories'
        | 'Field_Checkboxes'
        | 'Field_Date'
        | 'Field_DateAmPmDropdown'
        | 'Field_DateAmPmNumber'
        | 'Field_DateDate'
        | 'Field_DateDayDropdown'
        | 'Field_DateDayNumber'
        | 'Field_DateHourDropdown';
};

type TextField_Y4oshq8HoPnL9Zyydjpbxo3QwBioBikT6oISt80POpw_Fragment = {
    __typename?:
        | 'Field_DateHourNumber'
        | 'Field_DateMinuteDropdown'
        | 'Field_DateMinuteNumber'
        | 'Field_DateMonthDropdown'
        | 'Field_DateMonthNumber'
        | 'Field_DateSecondDropdown'
        | 'Field_DateSecondNumber'
        | 'Field_DateTime'
        | 'Field_DateYearDropdown'
        | 'Field_DateYearNumber'
        | 'Field_Dropdown'
        | 'Field_Entries'
        | 'Field_FileUpload'
        | 'Field_Group'
        | 'Field_Heading'
        | 'Field_Hidden'
        | 'Field_Html'
        | 'Field_Name'
        | 'Field_NameFirst'
        | 'Field_NameLast';
};

type TextField_A8sANo95jf0Sbnxm6Lsa3Sop4EsndAo5ixQTuTlC4_Fragment = {
    __typename?:
        | 'Field_NameMiddle'
        | 'Field_NamePrefix'
        | 'Field_Newsletter'
        | 'Field_Number'
        | 'Field_Password'
        | 'Field_Payment'
        | 'Field_Radio'
        | 'Field_Recipients'
        | 'Field_Repeater'
        | 'Field_Section'
        | 'Field_Signature'
        | 'Field_Summary'
        | 'Field_Table'
        | 'Field_Tags'
        | 'Field_Users';
};

type TextField_Field_Email_Field_Phone_Fragment = { defaultValue?: string | null } & {
    __typename?: 'Field_Email' | 'Field_Phone';
};

type TextField_Field_MultiLineText_Field_SingleLineText_Fragment = {
    limit?: boolean | null;
    maxType?: string | null;
    max?: number | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_MultiLineText' | 'Field_SingleLineText' };

export type TextFieldFragment =
    | TextField_My3BcfnixWzKkIiHUParmVrQxQhY539QciEsyJut4_Fragment
    | TextField_Y4oshq8HoPnL9Zyydjpbxo3QwBioBikT6oISt80POpw_Fragment
    | TextField_A8sANo95jf0Sbnxm6Lsa3Sop4EsndAo5ixQTuTlC4_Fragment
    | TextField_Field_Email_Field_Phone_Fragment
    | TextField_Field_MultiLineText_Field_SingleLineText_Fragment;

export type SingleTextFieldFragment = {
    limit?: boolean | null;
    maxType?: string | null;
    max?: number | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_SingleLineText' };

export type MultipleTextFieldFragment = {
    limit?: boolean | null;
    maxType?: string | null;
    max?: number | null;
    defaultValue?: string | null;
} & { __typename?: 'Field_MultiLineText' };

export type EmailTextFieldFragment = { defaultValue?: string | null } & { __typename?: 'Field_Email' };

export type PhoneTextFieldFragment = { defaultValue?: string | null } & { __typename?: 'Field_Phone' };

export type ActivitySearchQueryVariables = Exact<{
    params: ActivitySearchParamsInput;
    limit?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
    startDate: Scalars['String'];
    endDate: Scalars['String'];
    order: ActivitySearchOrderEnum;
}>;

export type ActivitySearchQuery = {
    activities: {
        totalHits: number;
        hits: Array<
            {
                id: string;
                name: string;
                slug: string;
                highlighted: boolean;
                place?: string | null;
                videoUrl?: string | null;
                bookingType: ActivityBookingTypesEnum;
                minCapacity?: number | null;
                maxCapacity?: number | null;
                themes: Array<{ slug: string; name?: string | null } & { __typename?: 'ActivityTheme' }>;
                timeslots: Array<
                    {
                        id: string;
                        allotment?: number | null;
                        startDateTime: string;
                        endDateTime: string;
                        label?: string | null;
                        rateGroup?:
                            | ({
                                  canBuyTickets: boolean;
                                  releaseHours?: number | null;
                                  rates: Array<{ id: string; name: string; price: number } & { __typename?: 'Rate' }>;
                              } & { __typename?: 'ActivityRateGroup' })
                            | null;
                    } & { __typename?: 'Timeslot' }
                >;
                mainImage?:
                    | ({
                          transform?:
                              | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                    __typename?: 'ImageTransform';
                                })
                              | null;
                      } & { __typename?: 'GenericImage' })
                    | null;
                webpMainImage?:
                    | ({
                          transform?:
                              | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                    __typename?: 'ImageTransform';
                                })
                              | null;
                      } & { __typename?: 'GenericImage' })
                    | null;
                webpListImage?:
                    | ({
                          transform?:
                              | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                    __typename?: 'ImageTransform';
                                })
                              | null;
                      } & { __typename?: 'GenericImage' })
                    | null;
                listImage?:
                    | ({
                          transform?:
                              | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                                    __typename?: 'ImageTransform';
                                })
                              | null;
                      } & { __typename?: 'GenericImage' })
                    | null;
            } & { __typename?: 'Activity' }
        >;
        placeCounts: Array<{ value: string; hits: number } & { __typename?: 'GenericAggregationCount' }>;
        themeCounts: Array<{ value: string; hits: number } & { __typename?: 'GenericAggregationCount' }>;
        targetAudienceCount: Array<
            { value: TargetAudienceEnum; hits: number } & { __typename?: 'TargetAudienceAggregationCount' }
        >;
    } & { __typename?: 'ActivitySearchResult' };
} & { __typename?: 'Query' };

export type ActivityHitFragment = {
    id: string;
    name: string;
    slug: string;
    highlighted: boolean;
    place?: string | null;
    videoUrl?: string | null;
    bookingType: ActivityBookingTypesEnum;
    minCapacity?: number | null;
    maxCapacity?: number | null;
    themes: Array<{ slug: string; name?: string | null } & { __typename?: 'ActivityTheme' }>;
    timeslots: Array<
        {
            id: string;
            allotment?: number | null;
            startDateTime: string;
            endDateTime: string;
            label?: string | null;
            rateGroup?:
                | ({
                      canBuyTickets: boolean;
                      releaseHours?: number | null;
                      rates: Array<{ id: string; name: string; price: number } & { __typename?: 'Rate' }>;
                  } & { __typename?: 'ActivityRateGroup' })
                | null;
        } & { __typename?: 'Timeslot' }
    >;
    mainImage?:
        | ({
              transform?:
                  | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                        __typename?: 'ImageTransform';
                    })
                  | null;
          } & { __typename?: 'GenericImage' })
        | null;
    webpMainImage?:
        | ({
              transform?:
                  | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                        __typename?: 'ImageTransform';
                    })
                  | null;
          } & { __typename?: 'GenericImage' })
        | null;
    webpListImage?:
        | ({
              transform?:
                  | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                        __typename?: 'ImageTransform';
                    })
                  | null;
          } & { __typename?: 'GenericImage' })
        | null;
    listImage?:
        | ({
              transform?:
                  | ({ placeholder?: string | null; srcSet: string; src: string; ratio: number } & {
                        __typename?: 'ImageTransform';
                    })
                  | null;
          } & { __typename?: 'GenericImage' })
        | null;
} & { __typename?: 'Activity' };

export type ActivityPlannerTimeslotFragment = {
    id: string;
    allotment?: number | null;
    startDateTime: string;
    endDateTime: string;
    label?: string | null;
    rateGroup?:
        | ({
              canBuyTickets: boolean;
              releaseHours?: number | null;
              rates: Array<{ id: string; name: string; price: number } & { __typename?: 'Rate' }>;
          } & { __typename?: 'ActivityRateGroup' })
        | null;
} & { __typename?: 'Timeslot' };

export type ArticleQueryVariables = Exact<{
    slug?: InputMaybe<Scalars['String']>;
    lang?: InputMaybe<Scalars['String']>;
    notSlug?: InputMaybe<Scalars['String']>;
}>;

export type ArticleQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              postDate?: any | null;
              title?: string | null;
              settingsCookieConsent?: boolean | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              id?: string | null;
              newsHeroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        ogImageUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        srcsetMobile?: string | null;
                        srcsetMobileWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
              textBody?: ({ html?: string | null } & { __typename?: 'textBody_CkeditorField' }) | null;
              gallery: Array<
                  | ({
                        assetSource?: string | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        width?: number | null;
                        height?: number | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
              parent?:
                  | ({ id?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ id?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
              settingsSearchTags: Array<
                  | ({ title?: string | null } & { __typename?: 'assetTags_Tag' | 'searchTags_Tag' | 'synonyms_Tag' })
                  | null
              >;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'article_Entry' })
        | null;
    related?: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
        | null
    > | null;
} & { __typename?: 'Query' };

export type ArticlePathsQueryVariables = Exact<{ [key: string]: never }>;

export type ArticlePathsQuery = {
    entries?: Array<
        | ({ slug?: string | null; language?: string | null } & {
              __typename:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ slug?: string | null; language?: string | null } & {
              __typename:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null
    > | null;
} & { __typename?: 'Query' };

export type ArticleFragment = {
    postDate?: any | null;
    title?: string | null;
    settingsCookieConsent?: boolean | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    id?: string | null;
    newsHeroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              ogImageUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              srcsetMobile?: string | null;
              srcsetMobileWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
    textBody?: ({ html?: string | null } & { __typename?: 'textBody_CkeditorField' }) | null;
    gallery: Array<
        | ({
              assetSource?: string | null;
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              width?: number | null;
              height?: number | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
    parent?:
        | ({ id?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ id?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null;
    settingsSearchTags: Array<
        ({ title?: string | null } & { __typename?: 'assetTags_Tag' | 'searchTags_Tag' | 'synonyms_Tag' }) | null
    >;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'article_Entry' };

export type HomeQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type HomeQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              homeHighlightsTitle?: string | null;
              settingsCookieConsent?: boolean | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              header?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        ogImageUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        srcsetMobile?: string | null;
                        srcsetMobileWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
              homeHighlights: Array<
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'banner_Entry'
                            | 'contact2_Entry'
                            | 'events_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'menu_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        postDate?: any | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'article_Entry' })
                  | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
                        __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        externalLinkUrl?: string | null;
                        externalLinkOpenInNewTab?: boolean | null;
                        tagline?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'externalLink_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        id?: string | null;
                        settingsMetaDescription?: string | null;
                        settingsNotSearchable?: boolean | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'page_Entry' })
                  | null
              >;
              homeCurrent: Array<
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'banner_Entry'
                            | 'contact2_Entry'
                            | 'events_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'menu_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        postDate?: any | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'article_Entry' })
                  | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
                        __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        externalLinkUrl?: string | null;
                        externalLinkOpenInNewTab?: boolean | null;
                        tagline?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'externalLink_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        id?: string | null;
                        settingsMetaDescription?: string | null;
                        settingsNotSearchable?: boolean | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'page_Entry' })
                  | null
              >;
              action: Array<
                  | ({
                        title?: string | null;
                        description?: ({ html?: string | null } & { __typename?: 'description_CkeditorField' }) | null;
                        button?:
                            | ({
                                  label?: string | null;
                                  target?: string | null;
                                  url?: string | null;
                                  type?: string | null;
                                  element?:
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'Address'
                                                | 'Element'
                                                | 'User'
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'assetTags_Tag'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'contact_GlobalSet'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'library_Asset'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'news_Entry'
                                                | 'notification_GlobalSet'
                                                | 'opgave20april_Form'
                                                | 'opgaveBt2026_Form'
                                                | 'opgaveDeelname_Form'
                                                | 'opgaveSjouw22022_Form'
                                                | 'opgaveSjouw_Form'
                                                | 'page_Entry'
                                                | 'searchTags_Tag'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'synonyms_Tag'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'LinkData' })
                            | null;
                    } & { __typename?: 'action_Entry' })
                  | {
                        __typename?:
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    }
                  | {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    }
                  | null
              >;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'homepage_Entry' })
        | null;
} & { __typename?: 'Query' };

export type HomeFragment = {
    title?: string | null;
    homeHighlightsTitle?: string | null;
    settingsCookieConsent?: boolean | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    header?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              ogImageUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              srcsetMobile?: string | null;
              srcsetMobileWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
    homeHighlights: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
        | null
    >;
    homeCurrent: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
        | null
    >;
    action: Array<
        | ({
              title?: string | null;
              description?: ({ html?: string | null } & { __typename?: 'description_CkeditorField' }) | null;
              button?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'page_Entry'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
          } & { __typename?: 'action_Entry' })
        | {
              __typename?:
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | null
    >;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'homepage_Entry' };

export type NewsQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
    offset?: InputMaybe<Scalars['Int']>;
    limit?: InputMaybe<Scalars['Int']>;
}>;

export type NewsQuery = {
    articleCount: number;
    articles?: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
        | null
    > | null;
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              settingsCookieConsent?: boolean | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        ogImageUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        srcsetMobile?: string | null;
                        srcsetMobileWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
              textBody?:
                  | ({ html?: string | null; plainText?: string | null } & { __typename?: 'textBody_CkeditorField' })
                  | null;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'news_Entry' })
        | null;
} & { __typename?: 'Query' };

export type NewsFragment = {
    title?: string | null;
    settingsCookieConsent?: boolean | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              ogImageUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              srcsetMobile?: string | null;
              srcsetMobileWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
    textBody?: ({ html?: string | null; plainText?: string | null } & { __typename?: 'textBody_CkeditorField' }) | null;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'news_Entry' };

export type PageQueryVariables = Exact<{
    uri?: InputMaybe<Scalars['String']>;
    lang?: InputMaybe<Scalars['String']>;
}>;

export type PageQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              uri?: string | null;
              title?: string | null;
              settingsCookieConsent?: boolean | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              settingsNotSearchable?: boolean | null;
              settingsNoIndex?: boolean | null;
              root?: number | null;
              id?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        ogImageUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                        srcsetMobile?: string | null;
                        srcsetMobileWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
              contentMatrix: Array<
                  | ({ accommodationsQuery?: string | null } & { __typename?: 'sectionAccommodations_Entry' })
                  | ({
                        header?: string | null;
                        text?: ({ html?: string | null } & { __typename?: 'text2_CkeditorField' }) | null;
                    } & { __typename?: 'sectionAccordion_Entry' })
                  | { __typename?: 'sectionAction_Entry' }
                  | ({ activitiesQuery?: string | null } & { __typename?: 'sectionActivities_Entry' })
                  | ({
                        banner: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'page_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              }
                            | ({
                                  title?: string | null;
                                  heroImage: Array<
                                      ({ thumbUrl?: string | null } & { __typename?: 'library_Asset' }) | null
                                  >;
                                  button?:
                                      | ({
                                            label?: string | null;
                                            target?: string | null;
                                            url?: string | null;
                                            type?: string | null;
                                            element?:
                                                | ({ title?: string | null; uri?: string | null } & {
                                                      __typename?:
                                                          | 'Address'
                                                          | 'Element'
                                                          | 'User'
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'assetTags_Tag'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'contact_GlobalSet'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'library_Asset'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry';
                                                  })
                                                | ({ title?: string | null; uri?: string | null } & {
                                                      __typename?:
                                                          | 'news_Entry'
                                                          | 'notification_GlobalSet'
                                                          | 'opgave20april_Form'
                                                          | 'opgaveBt2026_Form'
                                                          | 'opgaveDeelname_Form'
                                                          | 'opgaveSjouw22022_Form'
                                                          | 'opgaveSjouw_Form'
                                                          | 'page_Entry'
                                                          | 'searchTags_Tag'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry'
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry';
                                                  })
                                                | ({ title?: string | null; uri?: string | null } & {
                                                      __typename?:
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'synonyms_Tag'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | null;
                                        } & { __typename?: 'LinkData' })
                                      | null;
                              } & { __typename?: 'banner_Entry' })
                            | null
                        >;
                    } & { __typename?: 'sectionBanner_Entry' })
                  | ({ boatBlockEnabled?: boolean | null } & { __typename?: 'sectionBoat_Entry' })
                  | ({
                        button?:
                            | ({
                                  label?: string | null;
                                  target?: string | null;
                                  url?: string | null;
                                  type?: string | null;
                                  element?:
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'Address'
                                                | 'Element'
                                                | 'User'
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'assetTags_Tag'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'contact_GlobalSet'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'library_Asset'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'news_Entry'
                                                | 'notification_GlobalSet'
                                                | 'opgave20april_Form'
                                                | 'opgaveBt2026_Form'
                                                | 'opgaveDeelname_Form'
                                                | 'opgaveSjouw22022_Form'
                                                | 'opgaveSjouw_Form'
                                                | 'page_Entry'
                                                | 'searchTags_Tag'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'synonyms_Tag'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'LinkData' })
                            | null;
                    } & { __typename?: 'sectionButton_Entry' })
                  | ({ companiesQuery?: string | null } & { __typename?: 'sectionCompanies_Entry' })
                  | ({ embed?: string | null } & { __typename?: 'sectionEmbed_Entry' })
                  | ({ id?: string | null } & { __typename?: 'sectionForms_Entry' })
                  | ({ header?: string | null } & { __typename?: 'sectionHeader_Entry' })
                  | ({ relationType?: string | null } & { __typename?: 'sectionHierarchicalTiles_Entry' })
                  | ({
                        gallery: Array<
                            | ({
                                  assetSource?: string | null;
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  width?: number | null;
                                  height?: number | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'sectionImages_Entry' })
                  | ({
                        pins?: Array<
                            | ({
                                  latitude?: any | null;
                                  longitude?: any | null;
                                  symbol?: string | null;
                                  label?: string | null;
                              } & { __typename?: 'pins_TableRow' })
                            | null
                        > | null;
                    } & { __typename?: 'sectionMap_Entry' })
                  | ({ text?: ({ html?: string | null } & { __typename?: 'text_CkeditorField' }) | null } & {
                        __typename?: 'sectionText_Entry';
                    })
                  | ({
                        tilesChildren?: boolean | null;
                        tilesSiblings?: boolean | null;
                        tilesEntries: Array<
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'banner_Entry'
                                      | 'contact2_Entry'
                                      | 'events_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'menu_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'tip_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  postDate?: any | null;
                                  settingsMetaDescription?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'article_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMetaDescription?: string | null;
                              } & {
                                  __typename?:
                                      | 'companies_Entry'
                                      | 'excursions_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'thankYou_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMetaDescription?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  externalLinkUrl?: string | null;
                                  externalLinkOpenInNewTab?: boolean | null;
                                  tagline?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'externalLink_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  id?: string | null;
                                  settingsMetaDescription?: string | null;
                                  settingsNotSearchable?: boolean | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'page_Entry' })
                            | null
                        >;
                    } & { __typename?: 'sectionTiles_Entry' })
                  | ({
                        tip: Array<
                            | {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'news_Entry'
                                      | 'page_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry';
                              }
                            | {
                                  __typename?:
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'thankYou_Entry';
                              }
                            | ({
                                  title?: string | null;
                                  tipName?: string | null;
                                  tipRole?: string | null;
                                  tipText?:
                                      | ({ html?: string | null } & { __typename?: 'tipText_CkeditorField' })
                                      | null;
                                  tipAvatar: Array<
                                      | ({ height?: number | null; width?: number | null; thumbUrl?: string | null } & {
                                            __typename?: 'library_Asset';
                                        })
                                      | null
                                  >;
                              } & { __typename?: 'tip_Entry' })
                            | null
                        >;
                    } & { __typename?: 'sectionTip_Entry' })
                  | ({
                        travelbaseEntityType?: string | null;
                        travelbaseSlugs?: Array<
                            ({ slug?: string | null } & { __typename?: 'travelbaseSlugs_TableRow' }) | null
                        > | null;
                    } & { __typename?: 'sectionTravelbaseTiles_Entry' })
                  | ({ videoUrl?: string | null } & { __typename?: 'sectionVideo_Entry' })
                  | ({ webcamUrl?: string | null } & { __typename?: 'sectionWebcam_Entry' })
                  | null
              >;
              children: Array<
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'banner_Entry'
                            | 'contact2_Entry'
                            | 'events_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'menu_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        postDate?: any | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'article_Entry' })
                  | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
                        __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        externalLinkUrl?: string | null;
                        externalLinkOpenInNewTab?: boolean | null;
                        tagline?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'externalLink_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        id?: string | null;
                        settingsMetaDescription?: string | null;
                        settingsNotSearchable?: boolean | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'page_Entry' })
              >;
              parent?:
                  | ({
                        id?: string | null;
                        children: Array<
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'banner_Entry'
                                      | 'contact2_Entry'
                                      | 'events_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'menu_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'tip_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  postDate?: any | null;
                                  settingsMetaDescription?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'article_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMetaDescription?: string | null;
                              } & {
                                  __typename?:
                                      | 'companies_Entry'
                                      | 'excursions_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'thankYou_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMetaDescription?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  externalLinkUrl?: string | null;
                                  externalLinkOpenInNewTab?: boolean | null;
                                  tagline?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'externalLink_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  id?: string | null;
                                  settingsMetaDescription?: string | null;
                                  settingsNotSearchable?: boolean | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({
                        id?: string | null;
                        children: Array<
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'action_Entry'
                                      | 'banner_Entry'
                                      | 'contact2_Entry'
                                      | 'events_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'menu_Entry'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'tip_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  postDate?: any | null;
                                  settingsMetaDescription?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'article_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMetaDescription?: string | null;
                              } & {
                                  __typename?:
                                      | 'companies_Entry'
                                      | 'excursions_Entry'
                                      | 'myTerschelling_Entry'
                                      | 'thankYou_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  settingsMetaDescription?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  externalLinkUrl?: string | null;
                                  externalLinkOpenInNewTab?: boolean | null;
                                  tagline?: string | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'externalLink_Entry' })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  id?: string | null;
                                  settingsMetaDescription?: string | null;
                                  settingsNotSearchable?: boolean | null;
                                  heroImage: Array<
                                      | ({
                                            focalPoint?: Array<number | null> | null;
                                            title?: string | null;
                                            extension: string;
                                            url?: string | null;
                                            placeholderUrl?: string | null;
                                            srcset?: string | null;
                                            srcsetWebp?: string | null;
                                        } & { __typename?: 'library_Asset' })
                                      | null
                                  >;
                              } & { __typename?: 'page_Entry' })
                        >;
                    } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
                  | null;
              settingsSearchTags: Array<
                  | ({ title?: string | null } & { __typename?: 'assetTags_Tag' | 'searchTags_Tag' | 'synonyms_Tag' })
                  | null
              >;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'page_Entry' })
        | null;
} & { __typename?: 'Query' };

export type PageFragment = {
    uri?: string | null;
    title?: string | null;
    settingsCookieConsent?: boolean | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    settingsNotSearchable?: boolean | null;
    settingsNoIndex?: boolean | null;
    root?: number | null;
    id?: string | null;
    heroImage: Array<
        | ({
              focalPoint?: Array<number | null> | null;
              title?: string | null;
              extension: string;
              url?: string | null;
              placeholderUrl?: string | null;
              ogImageUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              srcsetMobile?: string | null;
              srcsetMobileWebp?: string | null;
          } & { __typename?: 'library_Asset' })
        | null
    >;
    contentMatrix: Array<
        | ({ accommodationsQuery?: string | null } & { __typename?: 'sectionAccommodations_Entry' })
        | ({
              header?: string | null;
              text?: ({ html?: string | null } & { __typename?: 'text2_CkeditorField' }) | null;
          } & { __typename?: 'sectionAccordion_Entry' })
        | { __typename?: 'sectionAction_Entry' }
        | ({ activitiesQuery?: string | null } & { __typename?: 'sectionActivities_Entry' })
        | ({
              banner: Array<
                  | {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    }
                  | {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    }
                  | ({
                        title?: string | null;
                        heroImage: Array<({ thumbUrl?: string | null } & { __typename?: 'library_Asset' }) | null>;
                        button?:
                            | ({
                                  label?: string | null;
                                  target?: string | null;
                                  url?: string | null;
                                  type?: string | null;
                                  element?:
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'Address'
                                                | 'Element'
                                                | 'User'
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'assetTags_Tag'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'contact_GlobalSet'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'library_Asset'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'news_Entry'
                                                | 'notification_GlobalSet'
                                                | 'opgave20april_Form'
                                                | 'opgaveBt2026_Form'
                                                | 'opgaveDeelname_Form'
                                                | 'opgaveSjouw22022_Form'
                                                | 'opgaveSjouw_Form'
                                                | 'page_Entry'
                                                | 'searchTags_Tag'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'synonyms_Tag'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'LinkData' })
                            | null;
                    } & { __typename?: 'banner_Entry' })
                  | null
              >;
          } & { __typename?: 'sectionBanner_Entry' })
        | ({ boatBlockEnabled?: boolean | null } & { __typename?: 'sectionBoat_Entry' })
        | ({
              button?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'page_Entry'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
          } & { __typename?: 'sectionButton_Entry' })
        | ({ companiesQuery?: string | null } & { __typename?: 'sectionCompanies_Entry' })
        | ({ embed?: string | null } & { __typename?: 'sectionEmbed_Entry' })
        | ({ id?: string | null } & { __typename?: 'sectionForms_Entry' })
        | ({ header?: string | null } & { __typename?: 'sectionHeader_Entry' })
        | ({ relationType?: string | null } & { __typename?: 'sectionHierarchicalTiles_Entry' })
        | ({
              gallery: Array<
                  | ({
                        assetSource?: string | null;
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        width?: number | null;
                        height?: number | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'sectionImages_Entry' })
        | ({
              pins?: Array<
                  | ({
                        latitude?: any | null;
                        longitude?: any | null;
                        symbol?: string | null;
                        label?: string | null;
                    } & { __typename?: 'pins_TableRow' })
                  | null
              > | null;
          } & { __typename?: 'sectionMap_Entry' })
        | ({ text?: ({ html?: string | null } & { __typename?: 'text_CkeditorField' }) | null } & {
              __typename?: 'sectionText_Entry';
          })
        | ({
              tilesChildren?: boolean | null;
              tilesSiblings?: boolean | null;
              tilesEntries: Array<
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'banner_Entry'
                            | 'contact2_Entry'
                            | 'events_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'menu_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        postDate?: any | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'article_Entry' })
                  | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
                        __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        externalLinkUrl?: string | null;
                        externalLinkOpenInNewTab?: boolean | null;
                        tagline?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'externalLink_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        id?: string | null;
                        settingsMetaDescription?: string | null;
                        settingsNotSearchable?: boolean | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'page_Entry' })
                  | null
              >;
          } & { __typename?: 'sectionTiles_Entry' })
        | ({
              tip: Array<
                  | {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    }
                  | {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry';
                    }
                  | ({
                        title?: string | null;
                        tipName?: string | null;
                        tipRole?: string | null;
                        tipText?: ({ html?: string | null } & { __typename?: 'tipText_CkeditorField' }) | null;
                        tipAvatar: Array<
                            | ({ height?: number | null; width?: number | null; thumbUrl?: string | null } & {
                                  __typename?: 'library_Asset';
                              })
                            | null
                        >;
                    } & { __typename?: 'tip_Entry' })
                  | null
              >;
          } & { __typename?: 'sectionTip_Entry' })
        | ({
              travelbaseEntityType?: string | null;
              travelbaseSlugs?: Array<
                  ({ slug?: string | null } & { __typename?: 'travelbaseSlugs_TableRow' }) | null
              > | null;
          } & { __typename?: 'sectionTravelbaseTiles_Entry' })
        | ({ videoUrl?: string | null } & { __typename?: 'sectionVideo_Entry' })
        | ({ webcamUrl?: string | null } & { __typename?: 'sectionWebcam_Entry' })
        | null
    >;
    children: Array<
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'events_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'menu_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry';
          })
        | ({ title?: string | null; uri?: string | null } & {
              __typename?:
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'tip_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              postDate?: any | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'article_Entry' })
        | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
              __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
          })
        | ({
              title?: string | null;
              uri?: string | null;
              settingsMetaDescription?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              externalLinkUrl?: string | null;
              externalLinkOpenInNewTab?: boolean | null;
              tagline?: string | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'externalLink_Entry' })
        | ({
              title?: string | null;
              uri?: string | null;
              id?: string | null;
              settingsMetaDescription?: string | null;
              settingsNotSearchable?: boolean | null;
              heroImage: Array<
                  | ({
                        focalPoint?: Array<number | null> | null;
                        title?: string | null;
                        extension: string;
                        url?: string | null;
                        placeholderUrl?: string | null;
                        srcset?: string | null;
                        srcsetWebp?: string | null;
                    } & { __typename?: 'library_Asset' })
                  | null
              >;
          } & { __typename?: 'page_Entry' })
    >;
    parent?:
        | ({
              id?: string | null;
              children: Array<
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'banner_Entry'
                            | 'contact2_Entry'
                            | 'events_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'menu_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        postDate?: any | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'article_Entry' })
                  | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
                        __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        externalLinkUrl?: string | null;
                        externalLinkOpenInNewTab?: boolean | null;
                        tagline?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'externalLink_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        id?: string | null;
                        settingsMetaDescription?: string | null;
                        settingsNotSearchable?: boolean | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'page_Entry' })
              >;
          } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({
              id?: string | null;
              children: Array<
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'banner_Entry'
                            | 'contact2_Entry'
                            | 'events_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'menu_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry';
                    })
                  | ({ title?: string | null; uri?: string | null } & {
                        __typename?:
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'tip_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        postDate?: any | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'article_Entry' })
                  | ({ title?: string | null; uri?: string | null; settingsMetaDescription?: string | null } & {
                        __typename?: 'companies_Entry' | 'excursions_Entry' | 'myTerschelling_Entry' | 'thankYou_Entry';
                    })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        settingsMetaDescription?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'contact_Entry' | 'homepage_Entry' | 'news_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        externalLinkUrl?: string | null;
                        externalLinkOpenInNewTab?: boolean | null;
                        tagline?: string | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'externalLink_Entry' })
                  | ({
                        title?: string | null;
                        uri?: string | null;
                        id?: string | null;
                        settingsMetaDescription?: string | null;
                        settingsNotSearchable?: boolean | null;
                        heroImage: Array<
                            | ({
                                  focalPoint?: Array<number | null> | null;
                                  title?: string | null;
                                  extension: string;
                                  url?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                              } & { __typename?: 'library_Asset' })
                            | null
                        >;
                    } & { __typename?: 'page_Entry' })
              >;
          } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null;
    settingsSearchTags: Array<
        ({ title?: string | null } & { __typename?: 'assetTags_Tag' | 'searchTags_Tag' | 'synonyms_Tag' }) | null
    >;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'page_Entry' };

export type PagePathsQueryVariables = Exact<{ [key: string]: never }>;

export type PagePathsQuery = {
    entries?: Array<
        | ({ uri?: string | null; slug?: string | null; language?: string | null } & {
              __typename:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ uri?: string | null; slug?: string | null; language?: string | null } & {
              __typename:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null
    > | null;
} & { __typename?: 'Query' };

export type SearchPageQueryVariables = Exact<{
    lang: Scalars['String'];
    q: Scalars['String'];
    types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type SearchPageQuery = {
    globalSearch?:
        | ({
              totalHits?: number | null;
              typeCounts?: Array<
                  ({ count?: number | null; label?: string | null } & { __typename?: 'Bucket' }) | null
              > | null;
              hits?: Array<
                  | ({
                        postDate?: string | null;
                        title?: string | null;
                        type?: string | null;
                        uri?: string | null;
                        image?:
                            | ({
                                  extension?: string | null;
                                  placeholderUrl?: string | null;
                                  srcset?: string | null;
                                  srcsetWebp?: string | null;
                                  title?: string | null;
                                  url?: string | null;
                              } & { __typename?: 'SearchImage' })
                            | null;
                    } & { __typename?: 'SearchType' })
                  | null
              > | null;
          } & { __typename?: 'SearchResult' })
        | null;
} & { __typename?: 'Query' };

export type SearchPageAllAvailableFiltersQueryVariables = Exact<{
    lang: Scalars['String'];
    q: Scalars['String'];
}>;

export type SearchPageAllAvailableFiltersQuery = {
    globalSearch?:
        | ({
              totalHits?: number | null;
              typeCounts?: Array<
                  ({ count?: number | null; label?: string | null } & { __typename?: 'Bucket' }) | null
              > | null;
          } & { __typename?: 'SearchResult' })
        | null;
} & { __typename?: 'Query' };

export type SearchQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type SearchQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              settingsCookieConsent?: boolean | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'search_Entry' })
        | null;
} & { __typename?: 'Query' };

export type SearchFragment = {
    title?: string | null;
    settingsCookieConsent?: boolean | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'search_Entry' };

export type SearchHitFragment = {
    postDate?: string | null;
    title?: string | null;
    type?: string | null;
    uri?: string | null;
    image?:
        | ({
              extension?: string | null;
              placeholderUrl?: string | null;
              srcset?: string | null;
              srcsetWebp?: string | null;
              title?: string | null;
              url?: string | null;
          } & { __typename?: 'SearchImage' })
        | null;
} & { __typename?: 'SearchType' };

export type HeroTransformFragment = {
    focalPoint?: Array<number | null> | null;
    title?: string | null;
    extension: string;
    url?: string | null;
    placeholderUrl?: string | null;
    ogImageUrl?: string | null;
    srcset?: string | null;
    srcsetWebp?: string | null;
    srcsetMobile?: string | null;
    srcsetMobileWebp?: string | null;
} & { __typename?: 'library_Asset' };

export type TileTransformFragment = {
    focalPoint?: Array<number | null> | null;
    title?: string | null;
    extension: string;
    url?: string | null;
    placeholderUrl?: string | null;
    srcset?: string | null;
    srcsetWebp?: string | null;
} & { __typename?: 'library_Asset' };

export type GalleryTransformFragment = {
    focalPoint?: Array<number | null> | null;
    title?: string | null;
    extension: string;
    url?: string | null;
    width?: number | null;
    height?: number | null;
    placeholderUrl?: string | null;
    srcset?: string | null;
    srcsetWebp?: string | null;
} & { __typename?: 'library_Asset' };

export type HighlightTransformFragment = {
    width?: number | null;
    height?: number | null;
    focalPoint?: Array<number | null> | null;
    title?: string | null;
    extension: string;
    url?: string | null;
    srcset?: string | null;
    srcsetWebp?: string | null;
    placeholderUrl?: string | null;
} & { __typename?: 'library_Asset' };

export type AccoFeedQueryVariables = Exact<{
    amount?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
}>;

export type AccoFeedQuery = {
    unitSearch: {
        totalHits: number;
        hits: Array<
            {
                rentalUnit: {
                    id: string;
                    name: string;
                    slug: string;
                    tagline: string;
                    descriptionLayout: string;
                    type: RentalUnitTypeEnum;
                    maxOccupancy: number;
                    livingArea?: number | null;
                    outdoorArea?: number | null;
                    images: Array<
                        { transform?: ({ src: string } & { __typename?: 'ImageTransform' }) | null } & {
                            __typename?: 'AccommodationImage';
                        }
                    >;
                    accommodation: { place: string } & { __typename?: 'Accommodation' };
                } & { __typename?: 'RentalUnit' };
                trips: Array<{ price: number } & { __typename?: 'Trip' }>;
            } & { __typename?: 'UnitSearchHit' }
        >;
    } & { __typename?: 'UnitSearchResult' };
} & { __typename?: 'Query' };

export type SitemapQueryVariables = Exact<{
    locale?: InputMaybe<Scalars['String']>;
    size?: InputMaybe<Scalars['Int']>;
}>;

export type SitemapQuery = {
    entries?: Array<
        | ({ url?: string | null; dateUpdated?: any | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry';
          })
        | ({ url?: string | null; dateUpdated?: any | null } & {
              __typename?:
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | ({
              url?: string | null;
              dateUpdated?: any | null;
              heroImage: Array<
                  ({ url?: string | null; title?: string | null } & { __typename?: 'library_Asset' }) | null
              >;
          } & { __typename?: 'news_Entry' | 'page_Entry' })
        | null
    > | null;
    travelbaseObjectsSitemap?: Array<
        | ({
              url?: string | null;
              image?: ({ url?: string | null; title?: string | null } & { __typename?: 'SearchImage' }) | null;
          } & { __typename?: 'TravelbaseObjectsSitemapType' })
        | null
    > | null;
} & { __typename?: 'Query' };

export type SqzlyFeedQueryVariables = Exact<{
    amount?: InputMaybe<Scalars['Int']>;
    offset?: InputMaybe<Scalars['Int']>;
}>;

export type SqzlyFeedQuery = {
    unitSearch: {
        totalHits: number;
        hits: Array<
            {
                rentalUnit: {
                    code: string;
                    name: string;
                    slug: string;
                    type: RentalUnitTypeEnum;
                    listImage: { transform?: ({ src: string } & { __typename?: 'ImageTransform' }) | null } & {
                        __typename?: 'GenericImage';
                    };
                    accommodation: { name: string; id: string } & { __typename?: 'Accommodation' };
                } & { __typename?: 'RentalUnit' };
                trips: Array<{ price: number } & { __typename?: 'Trip' }>;
            } & { __typename?: 'UnitSearchHit' }
        >;
    } & { __typename?: 'UnitSearchResult' };
} & { __typename?: 'Query' };

export type AgendaQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type AgendaQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'excursions_Entry' })
        | null;
} & { __typename?: 'Query' };

export type AgendaFragment = {
    title?: string | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'excursions_Entry' };

export type CompanyQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type CompanyQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              settingsSeoTitle?: string | null;
              settingsMetaDescription?: string | null;
              title?: string | null;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'companies_Entry' })
        | null;
} & { __typename?: 'Query' };

export type CompaniesFragment = {
    settingsSeoTitle?: string | null;
    settingsMetaDescription?: string | null;
    title?: string | null;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'companies_Entry' };

export type SightsQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type SightsQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          }
        | {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              settingsSeoTitle?: string | null;
              settingsMetaDescription?: string | null;
              title?: string | null;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'sights_Entry' })
        | null;
} & { __typename?: 'Query' };

export type SightsFragment = {
    settingsSeoTitle?: string | null;
    settingsMetaDescription?: string | null;
    title?: string | null;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'sights_Entry' };

export type EventsQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type EventsQuery = {
    entry?:
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              settingsMetaDescription?: string | null;
              settingsSeoTitle?: string | null;
              localized: Array<
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'footerLink_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry';
                    })
                  | ({ url?: string | null; language?: string | null } & {
                        __typename?:
                            | 'sectionActivities_Entry'
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    })
              >;
          } & { __typename?: 'events_Entry' })
        | null;
} & { __typename?: 'Query' };

export type EventsFragment = {
    title?: string | null;
    settingsMetaDescription?: string | null;
    settingsSeoTitle?: string | null;
    localized: Array<
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ url?: string | null; language?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
    >;
} & { __typename?: 'events_Entry' };

export type GlobalQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']>;
}>;

export type GlobalQuery = {
    menu?: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              id?: string | null;
              title?: string | null;
              menuLink?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  slug?: string | null;
                                  id?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                                  children: Array<
                                      | ({
                                            children: Array<
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  })
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry';
                                        })
                                      | ({
                                            children: Array<
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  })
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | ({
                                            slug?: string | null;
                                            id?: string | null;
                                            title?: string | null;
                                            uri?: string | null;
                                            settingsMenuHidden?: boolean | null;
                                            children: Array<
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  })
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                            parent?:
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'page_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry';
                                                  })
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'sectionActivities_Entry'
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | null;
                                        } & { __typename?: 'page_Entry' })
                                  >;
                              } & { __typename?: 'page_Entry' })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
          } & { __typename?: 'menu_Entry' })
        | null
    > | null;
    footer?: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              children: Array<
                  | {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    }
                  | {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    }
                  | ({
                        title?: string | null;
                        menuLink?:
                            | ({
                                  label?: string | null;
                                  target?: string | null;
                                  url?: string | null;
                                  type?: string | null;
                                  element?:
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'Address'
                                                | 'Element'
                                                | 'User'
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'assetTags_Tag'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'contact_GlobalSet'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'library_Asset'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'news_Entry'
                                                | 'notification_GlobalSet'
                                                | 'opgave20april_Form'
                                                | 'opgaveBt2026_Form'
                                                | 'opgaveDeelname_Form'
                                                | 'opgaveSjouw22022_Form'
                                                | 'opgaveSjouw_Form'
                                                | 'page_Entry'
                                                | 'searchTags_Tag'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'synonyms_Tag'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'LinkData' })
                            | null;
                    } & { __typename: 'footerLink_Entry' })
              >;
          } & { __typename?: 'footerCategory_Entry' })
        | null
    > | null;
    notification?:
        | { __typename?: 'contact_GlobalSet' }
        | ({
              header?: string | null;
              active?: boolean | null;
              enabled?: boolean | null;
              button?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'page_Entry'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
              description?: ({ html?: string | null } & { __typename?: 'description_CkeditorField' }) | null;
          } & { __typename?: 'notification_GlobalSet' })
        | null;
    search?:
        | ({ uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ uri?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null;
} & { __typename?: 'Query' };

export type GlobalQueryFragment = {
    menu?: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              id?: string | null;
              title?: string | null;
              menuLink?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry'
                                      | 'sectionHeader_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | ({
                                  title?: string | null;
                                  uri?: string | null;
                                  slug?: string | null;
                                  id?: string | null;
                                  settingsMenuHidden?: boolean | null;
                                  parent?:
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'page_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry';
                                        })
                                      | ({ uri?: string | null; id?: string | null } & {
                                            __typename?:
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                                  children: Array<
                                      | ({
                                            children: Array<
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  })
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry'
                                                | 'news_Entry'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry';
                                        })
                                      | ({
                                            children: Array<
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  })
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                        } & {
                                            __typename?:
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry'
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | ({
                                            slug?: string | null;
                                            id?: string | null;
                                            title?: string | null;
                                            uri?: string | null;
                                            settingsMenuHidden?: boolean | null;
                                            children: Array<
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry'
                                                          | 'sectionActivities_Entry';
                                                  })
                                                | ({
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                  } & {
                                                      __typename?:
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | ({
                                                      slug?: string | null;
                                                      id?: string | null;
                                                      title?: string | null;
                                                      uri?: string | null;
                                                      settingsMenuHidden?: boolean | null;
                                                      children: Array<
                                                          | {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry'
                                                                    | 'sectionActivities_Entry';
                                                            }
                                                          | {
                                                                __typename?:
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            }
                                                          | ({
                                                                slug?: string | null;
                                                                id?: string | null;
                                                                title?: string | null;
                                                                uri?: string | null;
                                                                settingsMenuHidden?: boolean | null;
                                                                parent?:
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'action_Entry'
                                                                              | 'article_Entry'
                                                                              | 'banner_Entry'
                                                                              | 'companies_Entry'
                                                                              | 'contact2_Entry'
                                                                              | 'contact_Entry'
                                                                              | 'events_Entry'
                                                                              | 'excursions_Entry'
                                                                              | 'externalLink_Entry'
                                                                              | 'footerCategory_Entry'
                                                                              | 'footerLink_Entry'
                                                                              | 'homepage_Entry'
                                                                              | 'menu_Entry'
                                                                              | 'myTerschelling_Entry'
                                                                              | 'news_Entry'
                                                                              | 'page_Entry'
                                                                              | 'search_Entry'
                                                                              | 'sectionAccommodations_Entry'
                                                                              | 'sectionAccordion_Entry'
                                                                              | 'sectionAction_Entry';
                                                                      })
                                                                    | ({ uri?: string | null; id?: string | null } & {
                                                                          __typename?:
                                                                              | 'sectionActivities_Entry'
                                                                              | 'sectionBanner_Entry'
                                                                              | 'sectionBoat_Entry'
                                                                              | 'sectionButton_Entry'
                                                                              | 'sectionCompanies_Entry'
                                                                              | 'sectionEmbed_Entry'
                                                                              | 'sectionForms_Entry'
                                                                              | 'sectionHeader_Entry'
                                                                              | 'sectionHierarchicalTiles_Entry'
                                                                              | 'sectionImages_Entry'
                                                                              | 'sectionMap_Entry'
                                                                              | 'sectionText_Entry'
                                                                              | 'sectionTiles_Entry'
                                                                              | 'sectionTip_Entry'
                                                                              | 'sectionTravelbaseTiles_Entry'
                                                                              | 'sectionVideo_Entry'
                                                                              | 'sectionWebcam_Entry'
                                                                              | 'sights_Entry'
                                                                              | 'thankYou_Entry'
                                                                              | 'tip_Entry';
                                                                      })
                                                                    | null;
                                                            } & { __typename?: 'page_Entry' })
                                                      >;
                                                      parent?:
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'action_Entry'
                                                                    | 'article_Entry'
                                                                    | 'banner_Entry'
                                                                    | 'companies_Entry'
                                                                    | 'contact2_Entry'
                                                                    | 'contact_Entry'
                                                                    | 'events_Entry'
                                                                    | 'excursions_Entry'
                                                                    | 'externalLink_Entry'
                                                                    | 'footerCategory_Entry'
                                                                    | 'footerLink_Entry'
                                                                    | 'homepage_Entry'
                                                                    | 'menu_Entry'
                                                                    | 'myTerschelling_Entry'
                                                                    | 'news_Entry'
                                                                    | 'page_Entry'
                                                                    | 'search_Entry'
                                                                    | 'sectionAccommodations_Entry'
                                                                    | 'sectionAccordion_Entry'
                                                                    | 'sectionAction_Entry';
                                                            })
                                                          | ({ uri?: string | null; id?: string | null } & {
                                                                __typename?:
                                                                    | 'sectionActivities_Entry'
                                                                    | 'sectionBanner_Entry'
                                                                    | 'sectionBoat_Entry'
                                                                    | 'sectionButton_Entry'
                                                                    | 'sectionCompanies_Entry'
                                                                    | 'sectionEmbed_Entry'
                                                                    | 'sectionForms_Entry'
                                                                    | 'sectionHeader_Entry'
                                                                    | 'sectionHierarchicalTiles_Entry'
                                                                    | 'sectionImages_Entry'
                                                                    | 'sectionMap_Entry'
                                                                    | 'sectionText_Entry'
                                                                    | 'sectionTiles_Entry'
                                                                    | 'sectionTip_Entry'
                                                                    | 'sectionTravelbaseTiles_Entry'
                                                                    | 'sectionVideo_Entry'
                                                                    | 'sectionWebcam_Entry'
                                                                    | 'sights_Entry'
                                                                    | 'thankYou_Entry'
                                                                    | 'tip_Entry';
                                                            })
                                                          | null;
                                                  } & { __typename?: 'page_Entry' })
                                            >;
                                            parent?:
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'action_Entry'
                                                          | 'article_Entry'
                                                          | 'banner_Entry'
                                                          | 'companies_Entry'
                                                          | 'contact2_Entry'
                                                          | 'contact_Entry'
                                                          | 'events_Entry'
                                                          | 'excursions_Entry'
                                                          | 'externalLink_Entry'
                                                          | 'footerCategory_Entry'
                                                          | 'footerLink_Entry'
                                                          | 'homepage_Entry'
                                                          | 'menu_Entry'
                                                          | 'myTerschelling_Entry'
                                                          | 'news_Entry'
                                                          | 'page_Entry'
                                                          | 'search_Entry'
                                                          | 'sectionAccommodations_Entry'
                                                          | 'sectionAccordion_Entry'
                                                          | 'sectionAction_Entry';
                                                  })
                                                | ({ uri?: string | null; id?: string | null } & {
                                                      __typename?:
                                                          | 'sectionActivities_Entry'
                                                          | 'sectionBanner_Entry'
                                                          | 'sectionBoat_Entry'
                                                          | 'sectionButton_Entry'
                                                          | 'sectionCompanies_Entry'
                                                          | 'sectionEmbed_Entry'
                                                          | 'sectionForms_Entry'
                                                          | 'sectionHeader_Entry'
                                                          | 'sectionHierarchicalTiles_Entry'
                                                          | 'sectionImages_Entry'
                                                          | 'sectionMap_Entry'
                                                          | 'sectionText_Entry'
                                                          | 'sectionTiles_Entry'
                                                          | 'sectionTip_Entry'
                                                          | 'sectionTravelbaseTiles_Entry'
                                                          | 'sectionVideo_Entry'
                                                          | 'sectionWebcam_Entry'
                                                          | 'sights_Entry'
                                                          | 'thankYou_Entry'
                                                          | 'tip_Entry';
                                                  })
                                                | null;
                                        } & { __typename?: 'page_Entry' })
                                  >;
                              } & { __typename?: 'page_Entry' })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
          } & { __typename?: 'menu_Entry' })
        | null
    > | null;
    footer?: Array<
        | {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry'
                  | 'sectionActivities_Entry';
          }
        | {
              __typename?:
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          }
        | ({
              title?: string | null;
              children: Array<
                  | {
                        __typename?:
                            | 'action_Entry'
                            | 'article_Entry'
                            | 'banner_Entry'
                            | 'companies_Entry'
                            | 'contact2_Entry'
                            | 'contact_Entry'
                            | 'events_Entry'
                            | 'excursions_Entry'
                            | 'externalLink_Entry'
                            | 'footerCategory_Entry'
                            | 'homepage_Entry'
                            | 'menu_Entry'
                            | 'myTerschelling_Entry'
                            | 'news_Entry'
                            | 'page_Entry'
                            | 'search_Entry'
                            | 'sectionAccommodations_Entry'
                            | 'sectionAccordion_Entry'
                            | 'sectionAction_Entry'
                            | 'sectionActivities_Entry';
                    }
                  | {
                        __typename?:
                            | 'sectionBanner_Entry'
                            | 'sectionBoat_Entry'
                            | 'sectionButton_Entry'
                            | 'sectionCompanies_Entry'
                            | 'sectionEmbed_Entry'
                            | 'sectionForms_Entry'
                            | 'sectionHeader_Entry'
                            | 'sectionHierarchicalTiles_Entry'
                            | 'sectionImages_Entry'
                            | 'sectionMap_Entry'
                            | 'sectionText_Entry'
                            | 'sectionTiles_Entry'
                            | 'sectionTip_Entry'
                            | 'sectionTravelbaseTiles_Entry'
                            | 'sectionVideo_Entry'
                            | 'sectionWebcam_Entry'
                            | 'sights_Entry'
                            | 'thankYou_Entry'
                            | 'tip_Entry';
                    }
                  | ({
                        title?: string | null;
                        menuLink?:
                            | ({
                                  label?: string | null;
                                  target?: string | null;
                                  url?: string | null;
                                  type?: string | null;
                                  element?:
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'Address'
                                                | 'Element'
                                                | 'User'
                                                | 'action_Entry'
                                                | 'article_Entry'
                                                | 'assetTags_Tag'
                                                | 'banner_Entry'
                                                | 'companies_Entry'
                                                | 'contact2_Entry'
                                                | 'contact_Entry'
                                                | 'contact_GlobalSet'
                                                | 'events_Entry'
                                                | 'excursions_Entry'
                                                | 'externalLink_Entry'
                                                | 'footerCategory_Entry'
                                                | 'footerLink_Entry'
                                                | 'homepage_Entry'
                                                | 'library_Asset'
                                                | 'menu_Entry'
                                                | 'myTerschelling_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'news_Entry'
                                                | 'notification_GlobalSet'
                                                | 'opgave20april_Form'
                                                | 'opgaveBt2026_Form'
                                                | 'opgaveDeelname_Form'
                                                | 'opgaveSjouw22022_Form'
                                                | 'opgaveSjouw_Form'
                                                | 'page_Entry'
                                                | 'searchTags_Tag'
                                                | 'search_Entry'
                                                | 'sectionAccommodations_Entry'
                                                | 'sectionAccordion_Entry'
                                                | 'sectionAction_Entry'
                                                | 'sectionActivities_Entry'
                                                | 'sectionBanner_Entry'
                                                | 'sectionBoat_Entry'
                                                | 'sectionButton_Entry'
                                                | 'sectionCompanies_Entry'
                                                | 'sectionEmbed_Entry'
                                                | 'sectionForms_Entry';
                                        })
                                      | ({ title?: string | null; uri?: string | null } & {
                                            __typename?:
                                                | 'sectionHeader_Entry'
                                                | 'sectionHierarchicalTiles_Entry'
                                                | 'sectionImages_Entry'
                                                | 'sectionMap_Entry'
                                                | 'sectionText_Entry'
                                                | 'sectionTiles_Entry'
                                                | 'sectionTip_Entry'
                                                | 'sectionTravelbaseTiles_Entry'
                                                | 'sectionVideo_Entry'
                                                | 'sectionWebcam_Entry'
                                                | 'sights_Entry'
                                                | 'synonyms_Tag'
                                                | 'thankYou_Entry'
                                                | 'tip_Entry';
                                        })
                                      | null;
                              } & { __typename?: 'LinkData' })
                            | null;
                    } & { __typename: 'footerLink_Entry' })
              >;
          } & { __typename?: 'footerCategory_Entry' })
        | null
    > | null;
    notification?:
        | { __typename?: 'contact_GlobalSet' }
        | ({
              header?: string | null;
              active?: boolean | null;
              enabled?: boolean | null;
              button?:
                  | ({
                        label?: string | null;
                        target?: string | null;
                        url?: string | null;
                        type?: string | null;
                        element?:
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'Address'
                                      | 'Element'
                                      | 'User'
                                      | 'action_Entry'
                                      | 'article_Entry'
                                      | 'assetTags_Tag'
                                      | 'banner_Entry'
                                      | 'companies_Entry'
                                      | 'contact2_Entry'
                                      | 'contact_Entry'
                                      | 'contact_GlobalSet'
                                      | 'events_Entry'
                                      | 'excursions_Entry'
                                      | 'externalLink_Entry'
                                      | 'footerCategory_Entry'
                                      | 'footerLink_Entry'
                                      | 'homepage_Entry'
                                      | 'library_Asset'
                                      | 'menu_Entry'
                                      | 'myTerschelling_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'news_Entry'
                                      | 'notification_GlobalSet'
                                      | 'opgave20april_Form'
                                      | 'opgaveBt2026_Form'
                                      | 'opgaveDeelname_Form'
                                      | 'opgaveSjouw22022_Form'
                                      | 'opgaveSjouw_Form'
                                      | 'page_Entry'
                                      | 'searchTags_Tag'
                                      | 'search_Entry'
                                      | 'sectionAccommodations_Entry'
                                      | 'sectionAccordion_Entry'
                                      | 'sectionAction_Entry'
                                      | 'sectionActivities_Entry'
                                      | 'sectionBanner_Entry'
                                      | 'sectionBoat_Entry'
                                      | 'sectionButton_Entry'
                                      | 'sectionCompanies_Entry'
                                      | 'sectionEmbed_Entry'
                                      | 'sectionForms_Entry';
                              })
                            | ({ title?: string | null; uri?: string | null } & {
                                  __typename?:
                                      | 'sectionHeader_Entry'
                                      | 'sectionHierarchicalTiles_Entry'
                                      | 'sectionImages_Entry'
                                      | 'sectionMap_Entry'
                                      | 'sectionText_Entry'
                                      | 'sectionTiles_Entry'
                                      | 'sectionTip_Entry'
                                      | 'sectionTravelbaseTiles_Entry'
                                      | 'sectionVideo_Entry'
                                      | 'sectionWebcam_Entry'
                                      | 'sights_Entry'
                                      | 'synonyms_Tag'
                                      | 'thankYou_Entry'
                                      | 'tip_Entry';
                              })
                            | null;
                    } & { __typename?: 'LinkData' })
                  | null;
              description?: ({ html?: string | null } & { __typename?: 'description_CkeditorField' }) | null;
          } & { __typename?: 'notification_GlobalSet' })
        | null;
    search?:
        | ({ uri?: string | null } & {
              __typename?:
                  | 'action_Entry'
                  | 'article_Entry'
                  | 'banner_Entry'
                  | 'companies_Entry'
                  | 'contact2_Entry'
                  | 'contact_Entry'
                  | 'events_Entry'
                  | 'excursions_Entry'
                  | 'externalLink_Entry'
                  | 'footerCategory_Entry'
                  | 'footerLink_Entry'
                  | 'homepage_Entry'
                  | 'menu_Entry'
                  | 'myTerschelling_Entry'
                  | 'news_Entry'
                  | 'page_Entry'
                  | 'search_Entry'
                  | 'sectionAccommodations_Entry'
                  | 'sectionAccordion_Entry'
                  | 'sectionAction_Entry';
          })
        | ({ uri?: string | null } & {
              __typename?:
                  | 'sectionActivities_Entry'
                  | 'sectionBanner_Entry'
                  | 'sectionBoat_Entry'
                  | 'sectionButton_Entry'
                  | 'sectionCompanies_Entry'
                  | 'sectionEmbed_Entry'
                  | 'sectionForms_Entry'
                  | 'sectionHeader_Entry'
                  | 'sectionHierarchicalTiles_Entry'
                  | 'sectionImages_Entry'
                  | 'sectionMap_Entry'
                  | 'sectionText_Entry'
                  | 'sectionTiles_Entry'
                  | 'sectionTip_Entry'
                  | 'sectionTravelbaseTiles_Entry'
                  | 'sectionVideo_Entry'
                  | 'sectionWebcam_Entry'
                  | 'sights_Entry'
                  | 'thankYou_Entry'
                  | 'tip_Entry';
          })
        | null;
} & { __typename?: 'Query' };

export const FieldFragmentDoc = gql`
    fragment Field on FieldInterface {
        instructions
        instructionsPosition
        label
        placeholder
        required
        handle
        errorMessage
    }
`;
export const SingleTextFieldFragmentDoc = gql`
    fragment SingleTextField on Field_SingleLineText {
        limit
        maxType
        max
        defaultValue
    }
`;
export const MultipleTextFieldFragmentDoc = gql`
    fragment MultipleTextField on Field_MultiLineText {
        limit
        maxType
        max
        defaultValue
    }
`;
export const EmailTextFieldFragmentDoc = gql`
    fragment EmailTextField on Field_Email {
        defaultValue
    }
`;
export const PhoneTextFieldFragmentDoc = gql`
    fragment PhoneTextField on Field_Phone {
        defaultValue
    }
`;
export const TextFieldFragmentDoc = gql`
    fragment TextField on FieldInterface {
        ...SingleTextField
        ...MultipleTextField
        ...EmailTextField
        ...PhoneTextField
    }
    ${SingleTextFieldFragmentDoc}
    ${MultipleTextFieldFragmentDoc}
    ${EmailTextFieldFragmentDoc}
    ${PhoneTextFieldFragmentDoc}
`;
export const NumberFieldFragmentDoc = gql`
    fragment NumberField on Field_Number {
        defaultValue
        min
        max
    }
`;
export const CheckboxesFieldFragmentDoc = gql`
    fragment CheckboxesField on Field_Checkboxes {
        options {
            isDefault
            value
        }
    }
`;
export const RadioFieldFragmentDoc = gql`
    fragment RadioField on Field_Radio {
        options {
            isDefault
            value
        }
    }
`;
export const DropdownFieldFragmentDoc = gql`
    fragment DropdownField on Field_Dropdown {
        options {
            label
            isDefault
            value
        }
    }
`;
export const DateFieldFragmentDoc = gql`
    fragment DateField on Field_Date {
        displayType
        defaultDate
        defaultValue
    }
`;
export const FileFieldFragmentDoc = gql`
    fragment FileField on Field_FileUpload {
        allowedKinds
        limitFiles
        sizeLimit
        sizeMinLimit
    }
`;
export const HeadingFieldFragmentDoc = gql`
    fragment HeadingField on Field_Heading {
        headingSize
    }
`;
export const AddressFieldFragmentDoc = gql`
    fragment AddressField on Field_Address {
        fields {
            label
            enabled
            errorMessage
            defaultValue
            required
            placeholder
            handle
        }
    }
`;
export const BaseAgreeFieldFragmentDoc = gql`
    fragment BaseAgreeField on Field_Agree {
        checkedValue
        uncheckedValue
        descriptionHtml
        defaultState
        required
    }
`;
export const NewsletterAgreeFieldFragmentDoc = gql`
    fragment NewsletterAgreeField on Field_Newsletter {
        checkedValue
        uncheckedValue
        descriptionHtml
        defaultState
        required
    }
`;
export const AgreeFieldFragmentDoc = gql`
    fragment AgreeField on FieldInterface {
        ...BaseAgreeField
        ...NewsletterAgreeField
    }
    ${BaseAgreeFieldFragmentDoc}
    ${NewsletterAgreeFieldFragmentDoc}
`;
export const NameFieldFragmentDoc = gql`
    fragment NameField on Field_Name {
        fields {
            label
            enabled
            required
            handle
            placeholder
        }
    }
`;
export const FieldRendererFragmentDoc = gql`
    fragment FieldRenderer on FieldInterface {
        ...Field
        ...TextField
        ...NumberField
        ...CheckboxesField
        ...RadioField
        ...DropdownField
        ...DateField
        ...FileField
        ...HeadingField
        ...AddressField
        ...AgreeField
        ...NameField
    }
    ${FieldFragmentDoc}
    ${TextFieldFragmentDoc}
    ${NumberFieldFragmentDoc}
    ${CheckboxesFieldFragmentDoc}
    ${RadioFieldFragmentDoc}
    ${DropdownFieldFragmentDoc}
    ${DateFieldFragmentDoc}
    ${FileFieldFragmentDoc}
    ${HeadingFieldFragmentDoc}
    ${AddressFieldFragmentDoc}
    ${AgreeFieldFragmentDoc}
    ${NameFieldFragmentDoc}
`;
export const GroupFieldFragmentDoc = gql`
    fragment GroupField on Field_Group {
        fields {
            ...FieldRenderer
        }
    }
    ${FieldRendererFragmentDoc}
`;
export const FormFragmentDoc = gql`
    fragment Form on FormInterface {
        id
        handle
        siteId
        settings {
            submitActionFormHide
            submitActionMessageHtml
            submitAction
            submitActionTab
            redirectUrl
            integrations {
                handle
                enabled
            }
        }
        formFields {
            ...FieldRenderer
            ...GroupField
        }
    }
    ${FieldRendererFragmentDoc}
    ${GroupFieldFragmentDoc}
`;
export const HighlightTransformFragmentDoc = gql`
    fragment HighlightTransform on AssetInterface {
        width
        height
        focalPoint
        title
        extension
        url
        srcset: url
            @transformsrcset(
                sizes: ["64w", "128w", "80w", "160w"]
                width: 64
                height: 64
                mode: "crop"
                immediately: false
                quality: 70
            )
        srcsetWebp: url
            @transformsrcset(
                sizes: ["64w", "128w", "80w", "160w"]
                width: 64
                height: 64
                mode: "crop"
                format: "webp"
                immediately: false
                quality: 70
            )
        placeholderUrl: url @transform(width: 4, height: 4, mode: "crop", immediately: false, quality: 70)
    }
`;
export const HighlightFragmentDoc = gql`
    fragment Highlight on EntryInterface {
        title
        uri
        __typename
        ... on page_Entry {
            heroImage {
                ...HighlightTransform
            }
        }
        ... on article_Entry {
            newsHeroImage {
                ...HighlightTransform
            }
        }
    }
    ${HighlightTransformFragmentDoc}
`;
export const ListImageFragmentDoc = gql`
    fragment ListImage on ImageTransform {
        placeholder
        srcSet
        src
        ratio
    }
`;
export const RentalUnitFragmentDoc = gql`
    fragment rentalUnit on RentalUnit {
        id
        name
        slug
        type
        amountBedrooms
        maxOccupancy
        tagline
        accommodation {
            name
            hasPublicPage
            place
        }
        reviewStats {
            average
        }
        webpListImage: listImage {
            transform(config: TILE, format: WEBP) {
                ...ListImage
            }
        }
        listImage {
            transform(config: TILE, format: JPEG) {
                ...ListImage
            }
        }
    }
    ${ListImageFragmentDoc}
`;
export const TransformFragmentDoc = gql`
    fragment Transform on ImageTransform {
        placeholder
        srcSet
        src
        ratio
    }
`;
export const OrderItemFragmentDoc = gql`
    fragment OrderItem on OrderItem {
        ... on Booking {
            downloadVoucherUrl
            status
            requiresApproval
            amountAdults
            amountPets
            amountChildren
            amountBabies
            amountYouths
            arrivalDate
            departureDate
            handleDepositPayment
            deposit
            paymentPrice
            rentalUnit {
                id
                code
                name
                slug
                accommodation {
                    id
                    hasPublicPage
                    name
                    place
                    checkInEndTime
                    checkInStartTime
                    checkOutTime
                    type
                }
                type
                maxOccupancy
                amountBedrooms
                jpegThumbnail: listImage {
                    transform(config: TILE, format: JPEG) {
                        ...Transform
                    }
                }
                webpThumbnail: listImage {
                    transform(config: TILE, format: WEBP) {
                        ...Transform
                    }
                }
            }
        }
    }
    ${TransformFragmentDoc}
`;
export const MyOrderFragmentDoc = gql`
    fragment MyOrder on Order {
        id
        number
        createdDate
        paymentOptions {
            fullPaymentDueDate
            totalAmountDue
        }
        orderItems {
            ...OrderItem
        }
    }
    ${OrderItemFragmentDoc}
`;
export const RentalUnitsBySlugFragmentDoc = gql`
    fragment RentalUnitsBySlug on RentalUnit {
        id
        name
        slug
        tagline
        webpListImage: listImage {
            transform(config: TILE, format: WEBP) {
                ...ListImage
            }
        }
        listImage {
            transform(config: TILE, format: JPEG) {
                ...ListImage
            }
        }
    }
    ${ListImageFragmentDoc}
`;
export const AccommodationsBySlugFragmentDoc = gql`
    fragment AccommodationsBySlug on Accommodation {
        id
        name
        slug
        descriptionGeneral
        webpListImage: mainImage {
            transform(config: TILE, format: WEBP) {
                ...ListImage
            }
        }
        mainImage {
            transform(config: TILE, format: JPEG) {
                ...ListImage
            }
        }
    }
    ${ListImageFragmentDoc}
`;
export const ActivityPlannerTimeslotFragmentDoc = gql`
    fragment ActivityPlannerTimeslot on Timeslot {
        id
        allotment
        startDateTime
        endDateTime
        label
        rateGroup {
            canBuyTickets
            releaseHours
            rates {
                id
                name
                price
            }
        }
    }
`;
export const ActivityHitFragmentDoc = gql`
    fragment ActivityHit on Activity {
        id
        name
        slug
        highlighted
        place
        videoUrl
        bookingType
        themes {
            slug
            name
        }
        minCapacity
        maxCapacity
        timeslots(startDate: $startDate, endDate: $endDate) {
            ...ActivityPlannerTimeslot
        }
        themes {
            slug
        }
        mainImage {
            transform(config: HERO, format: JPEG) {
                ...ListImage
            }
        }
        webpMainImage: mainImage {
            transform(config: HERO, format: WEBP) {
                ...ListImage
            }
        }
        webpListImage: listImage {
            transform(config: HERO, format: WEBP) {
                ...ListImage
            }
        }
        listImage {
            transform(config: HERO, format: JPEG) {
                ...ListImage
            }
        }
    }
    ${ActivityPlannerTimeslotFragmentDoc}
    ${ListImageFragmentDoc}
`;
export const HeroTransformFragmentDoc = gql`
    fragment HeroTransform on AssetInterface {
        focalPoint
        title
        placeholderUrl: url @transform(width: 48, height: 15, mode: "crop", immediately: false)
        extension
        url
        ogImageUrl: url @transform(width: 1200, immediately: false)
        srcset: url
            @transformsrcset(
                sizes: ["1024w", "1920w", "2560w"]
                width: 1920
                height: 640
                mode: "crop"
                immediately: false
                quality: 70
            )
        srcsetWebp: url
            @transformsrcset(
                sizes: ["1024w", "1920w", "2560w"]
                width: 1920
                height: 640
                mode: "crop"
                immediately: false
            )
        srcsetMobile: url
            @transformsrcset(sizes: ["320w", "640w"], width: 640, height: 480, mode: "crop", immediately: false)
        srcsetMobileWebp: url
            @transformsrcset(
                sizes: ["320w", "640w"]
                width: 640
                height: 480
                mode: "crop"
                format: "webp"
                immediately: false
                quality: 70
            )
    }
`;
export const GalleryTransformFragmentDoc = gql`
    fragment GalleryTransform on AssetInterface {
        focalPoint
        title
        placeholderUrl: url @transform(width: 48, height: 27, mode: "crop", immediately: false)
        extension
        url
        width
        height
        srcset: url
            @transformsrcset(
                sizes: ["320w", "640w", "1024w", "1920w", "2560w"]
                width: 1920
                immediately: false
                quality: 70
            )
        srcsetWebp: url
            @transformsrcset(
                sizes: ["320w", "640w", "1024w", "1920w", "2560w"]
                width: 1920
                format: "webp"
                immediately: false
                quality: 70
            )
    }
`;
export const PhotosCarouselGalleryFragmentDoc = gql`
    fragment PhotosCarouselGallery on AssetInterface {
        ... on library_Asset {
            assetSource
        }
        ...GalleryTransform
    }
    ${GalleryTransformFragmentDoc}
`;
export const ArticleFragmentDoc = gql`
    fragment Article on article_Entry {
        newsHeroImage {
            ...HeroTransform
        }
        postDate @formatDateTime(format: "j F Y", locale: $lang)
        title
        textBody {
            html
        }
        gallery: newsImages {
            ...PhotosCarouselGallery
        }
        settingsCookieConsent
        settingsMetaDescription
        settingsSeoTitle
        id
        parent {
            id
        }
        settingsSearchTags {
            title
        }
        localized {
            url
            language
        }
    }
    ${HeroTransformFragmentDoc}
    ${PhotosCarouselGalleryFragmentDoc}
`;
export const TileTransformFragmentDoc = gql`
    fragment TileTransform on AssetInterface {
        focalPoint
        title
        placeholderUrl: url @transform(width: 64, height: 45, mode: "crop", immediately: false)
        extension
        url
        srcset: url
            @transformsrcset(
                sizes: ["64w", "320w", "640w"]
                width: 1920
                height: 1080
                mode: "crop"
                immediately: false
                quality: 70
            )
        srcsetWebp: url
            @transformsrcset(
                sizes: ["64w", "320w", "640w"]
                width: 1920
                height: 1080
                mode: "crop"
                format: "webp"
                immediately: false
                quality: 70
            )
    }
`;
export const CardImageFragmentDoc = gql`
    fragment CardImage on AssetInterface {
        ...TileTransform
    }
    ${TileTransformFragmentDoc}
`;
export const PageCardFragmentDoc = gql`
    fragment PageCard on page_Entry {
        id
        settingsMetaDescription
        settingsNotSearchable
        heroImage {
            ...CardImage
        }
    }
    ${CardImageFragmentDoc}
`;
export const NewsCardFragmentDoc = gql`
    fragment NewsCard on news_Entry {
        settingsMetaDescription
        heroImage {
            ...CardImage
        }
    }
    ${CardImageFragmentDoc}
`;
export const ArticleCardFragmentDoc = gql`
    fragment ArticleCard on article_Entry {
        postDate @formatDateTime(format: "j F Y", locale: $lang)
        settingsMetaDescription
        heroImage: newsHeroImage {
            ...CardImage
        }
    }
    ${CardImageFragmentDoc}
`;
export const HomeCardFragmentDoc = gql`
    fragment HomeCard on homepage_Entry {
        settingsMetaDescription
        heroImage {
            ...CardImage
        }
    }
    ${CardImageFragmentDoc}
`;
export const ContactCardFragmentDoc = gql`
    fragment ContactCard on contact_Entry {
        settingsMetaDescription
        heroImage {
            ...CardImage
        }
    }
    ${CardImageFragmentDoc}
`;
export const AgendaCardFragmentDoc = gql`
    fragment AgendaCard on excursions_Entry {
        settingsMetaDescription
    }
`;
export const ThankYouCardFragmentDoc = gql`
    fragment ThankYouCard on thankYou_Entry {
        settingsMetaDescription
    }
`;
export const CompanyCardFragmentDoc = gql`
    fragment CompanyCard on companies_Entry {
        settingsMetaDescription
    }
`;
export const MyTerschellingCardFragmentDoc = gql`
    fragment MyTerschellingCard on myTerschelling_Entry {
        settingsMetaDescription
    }
`;
export const ExternalLinkCardFragmentDoc = gql`
    fragment ExternalLinkCard on externalLink_Entry {
        externalLinkUrl
        externalLinkOpenInNewTab
        title
        tagline
        heroImage {
            ...CardImage
        }
    }
    ${CardImageFragmentDoc}
`;
export const CardFragmentDoc = gql`
    fragment Card on EntryInterface {
        title
        uri
        ...PageCard
        ...NewsCard
        ...ArticleCard
        ...HomeCard
        ...ContactCard
        ...AgendaCard
        ...ThankYouCard
        ...CompanyCard
        ...MyTerschellingCard
        ...ExternalLinkCard
    }
    ${PageCardFragmentDoc}
    ${NewsCardFragmentDoc}
    ${ArticleCardFragmentDoc}
    ${HomeCardFragmentDoc}
    ${ContactCardFragmentDoc}
    ${AgendaCardFragmentDoc}
    ${ThankYouCardFragmentDoc}
    ${CompanyCardFragmentDoc}
    ${MyTerschellingCardFragmentDoc}
    ${ExternalLinkCardFragmentDoc}
`;
export const LinkFieldFragmentDoc = gql`
    fragment LinkField on LinkData {
        label
        target
        url
        type
        element {
            title
            uri
        }
    }
`;
export const ActionFragmentDoc = gql`
    fragment Action on action_Entry {
        title
        description {
            html
        }
        button {
            ...LinkField
        }
    }
    ${LinkFieldFragmentDoc}
`;
export const HomeFragmentDoc = gql`
    fragment Home on homepage_Entry {
        heroImage {
            ...HeroTransform
        }
        title
        homeHighlightsTitle
        homeHighlights {
            ...Card
        }
        homeCurrent {
            ...Card
        }
        action {
            ...Action
        }
        settingsCookieConsent
        settingsMetaDescription
        settingsSeoTitle
        header
        localized {
            url
            language
        }
    }
    ${HeroTransformFragmentDoc}
    ${CardFragmentDoc}
    ${ActionFragmentDoc}
`;
export const NewsFragmentDoc = gql`
    fragment News on news_Entry {
        title
        heroImage {
            ...HeroTransform
        }
        textBody {
            html
            plainText
        }
        settingsCookieConsent
        settingsMetaDescription
        settingsSeoTitle
        localized {
            url
            language
        }
    }
    ${HeroTransformFragmentDoc}
`;
export const PinsFragmentDoc = gql`
    fragment Pins on pins_TableRow {
        latitude
        longitude
        symbol
        label
    }
`;
export const TipFragmentDoc = gql`
    fragment Tip on tip_Entry {
        title
        tipText {
            html
        }
        tipName
        tipRole
        tipAvatar {
            height
            width
            thumbUrl: url @transform(width: 56, height: 56, immediately: true)
        }
    }
`;
export const BannerFragmentDoc = gql`
    fragment Banner on banner_Entry {
        title
        heroImage {
            thumbUrl: url @transform(width: 328, height: 340, immediately: true)
        }
        button {
            ...LinkField
        }
    }
    ${LinkFieldFragmentDoc}
`;
export const TilesBlockFragmentDoc = gql`
    fragment TilesBlock on sectionTiles_Entry {
        tilesChildren
        tilesSiblings
        tilesEntries {
            ...Card
        }
    }
    ${CardFragmentDoc}
`;
export const HierarchicalTilesBlockFragmentDoc = gql`
    fragment HierarchicalTilesBlock on sectionHierarchicalTiles_Entry {
        relationType
    }
`;
export const TravelbaseTileFragmentDoc = gql`
    fragment TravelbaseTile on sectionTravelbaseTiles_Entry {
        travelbaseSlugs {
            slug
        }
        travelbaseEntityType
    }
`;
export const ContentMatrixFragmentDoc = gql`
    fragment ContentMatrix on contentMatrix_MatrixField {
        ... on sectionText_Entry {
            text {
                html
            }
        }
        ... on sectionHeader_Entry {
            header
        }
        ... on sectionVideo_Entry {
            videoUrl
        }
        ... on sectionImages_Entry {
            gallery: images {
                ...PhotosCarouselGallery
            }
        }
        ... on sectionAccordion_Entry {
            header
            text {
                html
            }
        }
        ... on sectionButton_Entry {
            button {
                ...LinkField
            }
        }
        ... on sectionWebcam_Entry {
            webcamUrl
        }
        ... on sectionMap_Entry {
            pins {
                ...Pins
            }
        }
        ... on sectionAccommodations_Entry {
            accommodationsQuery
        }
        ... on sectionCompanies_Entry {
            companiesQuery
        }
        ... on sectionActivities_Entry {
            activitiesQuery
        }
        ... on sectionTip_Entry {
            tip {
                ...Tip
            }
        }
        ... on sectionBanner_Entry {
            banner {
                ...Banner
            }
        }
        ... on sectionTiles_Entry {
            ...TilesBlock
        }
        ... on sectionHierarchicalTiles_Entry {
            ...HierarchicalTilesBlock
        }
        ... on sectionEmbed_Entry {
            embed
        }
        ... on sectionForms_Entry {
            id
        }
        ... on sectionTravelbaseTiles_Entry {
            ...TravelbaseTile
        }
        ... on sectionBoat_Entry {
            boatBlockEnabled
        }
    }
    ${PhotosCarouselGalleryFragmentDoc}
    ${LinkFieldFragmentDoc}
    ${PinsFragmentDoc}
    ${TipFragmentDoc}
    ${BannerFragmentDoc}
    ${TilesBlockFragmentDoc}
    ${HierarchicalTilesBlockFragmentDoc}
    ${TravelbaseTileFragmentDoc}
`;
export const PageFragmentDoc = gql`
    fragment Page on page_Entry {
        uri
        title
        settingsCookieConsent
        settingsMetaDescription
        settingsSeoTitle
        settingsNotSearchable
        settingsNoIndex
        heroImage {
            ...HeroTransform
        }
        root
        contentMatrix {
            ...ContentMatrix
        }
        children {
            ...Card
        }
        id
        parent {
            id
            children(section: ["pages"]) {
                ...Card
            }
        }
        settingsSearchTags {
            title
        }
        localized {
            url
            language
        }
    }
    ${HeroTransformFragmentDoc}
    ${ContentMatrixFragmentDoc}
    ${CardFragmentDoc}
`;
export const SearchFragmentDoc = gql`
    fragment Search on search_Entry {
        title
        settingsCookieConsent
        settingsMetaDescription
        settingsSeoTitle
        localized {
            url
            language
        }
    }
`;
export const SearchHitFragmentDoc = gql`
    fragment SearchHit on SearchType {
        postDate
        title
        type
        uri
        image {
            extension
            placeholderUrl
            srcset
            srcsetWebp
            title
            url
        }
    }
`;
export const AgendaFragmentDoc = gql`
    fragment Agenda on excursions_Entry {
        title
        settingsMetaDescription
        settingsSeoTitle
        localized {
            url
            language
        }
    }
`;
export const CompaniesFragmentDoc = gql`
    fragment Companies on companies_Entry {
        settingsSeoTitle
        settingsMetaDescription
        localized {
            url
            language
        }
        title
    }
`;
export const SightsFragmentDoc = gql`
    fragment Sights on sights_Entry {
        settingsSeoTitle
        settingsMetaDescription
        localized {
            url
            language
        }
        title
    }
`;
export const EventsFragmentDoc = gql`
    fragment Events on events_Entry {
        title
        settingsMetaDescription
        settingsSeoTitle
        localized {
            url
            language
        }
    }
`;
export const MenuItemPageFieldsFragmentDoc = gql`
    fragment MenuItemPageFields on page_Entry {
        slug
        id
        title
        uri
        settingsMenuHidden
        parent {
            uri
            id
        }
    }
`;
export const MenuItemPageRecursiveFragmentDoc = gql`
    fragment MenuItemPageRecursive on page_Entry {
        children {
            ...MenuItemPageFields
            children {
                ...MenuItemPageFields
                children {
                    ...MenuItemPageFields
                }
            }
        }
    }
    ${MenuItemPageFieldsFragmentDoc}
`;
export const MenuItemsFragmentDoc = gql`
    fragment MenuItems on menu_Entry {
        id
        title
        menuLink {
            ...LinkField
            element {
                ...MenuItemPageFields
                ...MenuItemPageRecursive
            }
        }
    }
    ${LinkFieldFragmentDoc}
    ${MenuItemPageFieldsFragmentDoc}
    ${MenuItemPageRecursiveFragmentDoc}
`;
export const FooterSubmenuFragmentDoc = gql`
    fragment FooterSubmenu on footerLink_Entry {
        title
        __typename
        menuLink {
            ...LinkField
        }
    }
    ${LinkFieldFragmentDoc}
`;
export const FooterItemsFragmentDoc = gql`
    fragment FooterItems on footerCategory_Entry {
        title
        children {
            ...FooterSubmenu
        }
    }
    ${FooterSubmenuFragmentDoc}
`;
export const NotificationFragmentDoc = gql`
    fragment Notification on notification_GlobalSet {
        button {
            ...LinkField
        }
        header
        active
        enabled
        description {
            html
        }
    }
    ${LinkFieldFragmentDoc}
`;
export const GlobalQueryFragmentDoc = gql`
    fragment GlobalQuery on Query {
        menu: entries(level: 1, site: [$lang], section: "menu") {
            ...MenuItems
        }
        footer: entries(level: 1, site: [$lang], section: "footer") {
            ...FooterItems
        }
        notification: globalSet(handle: "notification", site: [$lang]) {
            ...Notification
        }
        search: entry(type: "search", site: [$lang]) {
            uri
        }
    }
    ${MenuItemsFragmentDoc}
    ${FooterItemsFragmentDoc}
    ${NotificationFragmentDoc}
`;
export const ReadMoreDocument = gql`
    query ReadMore($parentId: Int, $id: Int, $q: String, $notId: [QueryArgument], $lang: String) {
        siblings: entries(descendantOf: $parentId, descendantDist: 1, limit: 4, type: ["page", "article"], id: $notId) {
            ...Highlight
        }
        ancestors: entries(ancestorOf: $id, limit: 4, type: ["page", "article"]) {
            ...Highlight
        }
        search(q: $q, language: $lang, type: ["pages", "articles"]) {
            ...SearchHit
        }
    }
    ${HighlightFragmentDoc}
    ${SearchHitFragmentDoc}
`;

/**
 * __useReadMoreQuery__
 *
 * To run a query within a React component, call `useReadMoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMoreQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      id: // value for 'id'
 *      q: // value for 'q'
 *      notId: // value for 'notId'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useReadMoreQuery(baseOptions?: Apollo.QueryHookOptions<ReadMoreQuery, ReadMoreQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ReadMoreQuery, ReadMoreQueryVariables>(ReadMoreDocument, options);
}
export function useReadMoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMoreQuery, ReadMoreQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ReadMoreQuery, ReadMoreQueryVariables>(ReadMoreDocument, options);
}
export type ReadMoreQueryHookResult = ReturnType<typeof useReadMoreQuery>;
export type ReadMoreLazyQueryHookResult = ReturnType<typeof useReadMoreLazyQuery>;
export type ReadMoreQueryResult = Apollo.QueryResult<ReadMoreQuery, ReadMoreQueryVariables>;
export const RentalUnitsDocument = gql`
    query RentalUnits($slugs: [String!]!) {
        rentalUnits(slugs: $slugs) {
            ...rentalUnit
        }
    }
    ${RentalUnitFragmentDoc}
`;

/**
 * __useRentalUnitsQuery__
 *
 * To run a query within a React component, call `useRentalUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalUnitsQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useRentalUnitsQuery(baseOptions: Apollo.QueryHookOptions<RentalUnitsQuery, RentalUnitsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<RentalUnitsQuery, RentalUnitsQueryVariables>(RentalUnitsDocument, options);
}
export function useRentalUnitsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<RentalUnitsQuery, RentalUnitsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<RentalUnitsQuery, RentalUnitsQueryVariables>(RentalUnitsDocument, options);
}
export type RentalUnitsQueryHookResult = ReturnType<typeof useRentalUnitsQuery>;
export type RentalUnitsLazyQueryHookResult = ReturnType<typeof useRentalUnitsLazyQuery>;
export type RentalUnitsQueryResult = Apollo.QueryResult<RentalUnitsQuery, RentalUnitsQueryVariables>;
export const SearchFieldDocument = gql`
    query SearchField($locale: String!, $q: String!) {
        globalSearch(language: $locale, query: $q, limit: 50) {
            totalHits
            hits {
                ...SearchHit
            }
        }
    }
    ${SearchHitFragmentDoc}
`;

/**
 * __useSearchFieldQuery__
 *
 * To run a query within a React component, call `useSearchFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFieldQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSearchFieldQuery(baseOptions: Apollo.QueryHookOptions<SearchFieldQuery, SearchFieldQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SearchFieldQuery, SearchFieldQueryVariables>(SearchFieldDocument, options);
}
export function useSearchFieldLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchFieldQuery, SearchFieldQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SearchFieldQuery, SearchFieldQueryVariables>(SearchFieldDocument, options);
}
export type SearchFieldQueryHookResult = ReturnType<typeof useSearchFieldQuery>;
export type SearchFieldLazyQueryHookResult = ReturnType<typeof useSearchFieldLazyQuery>;
export type SearchFieldQueryResult = Apollo.QueryResult<SearchFieldQuery, SearchFieldQueryVariables>;
export const SeeAlsoDocument = gql`
    query SeeAlso($parentId: Int, $id: Int, $q: String, $notId: [QueryArgument], $lang: String) {
        siblings: entries(descendantOf: $parentId, descendantDist: 1, limit: 3, type: ["page", "article"], id: $notId) {
            ...Highlight
        }
        ancestors: entries(ancestorOf: $id, limit: 3, type: ["page", "article"]) {
            ...Highlight
        }
        search(q: $q, language: $lang, type: ["pages", "articles"]) {
            ...SearchHit
        }
    }
    ${HighlightFragmentDoc}
    ${SearchHitFragmentDoc}
`;

/**
 * __useSeeAlsoQuery__
 *
 * To run a query within a React component, call `useSeeAlsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeeAlsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeeAlsoQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      id: // value for 'id'
 *      q: // value for 'q'
 *      notId: // value for 'notId'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useSeeAlsoQuery(baseOptions?: Apollo.QueryHookOptions<SeeAlsoQuery, SeeAlsoQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SeeAlsoQuery, SeeAlsoQueryVariables>(SeeAlsoDocument, options);
}
export function useSeeAlsoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeeAlsoQuery, SeeAlsoQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SeeAlsoQuery, SeeAlsoQueryVariables>(SeeAlsoDocument, options);
}
export type SeeAlsoQueryHookResult = ReturnType<typeof useSeeAlsoQuery>;
export type SeeAlsoLazyQueryHookResult = ReturnType<typeof useSeeAlsoLazyQuery>;
export type SeeAlsoQueryResult = Apollo.QueryResult<SeeAlsoQuery, SeeAlsoQueryVariables>;
export const UpcomingReservationsDocument = gql`
    query UpcomingReservations {
        viewer {
            id
            orders {
                ...MyOrder
            }
        }
    }
    ${MyOrderFragmentDoc}
`;

/**
 * __useUpcomingReservationsQuery__
 *
 * To run a query within a React component, call `useUpcomingReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingReservationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpcomingReservationsQuery(
    baseOptions?: Apollo.QueryHookOptions<UpcomingReservationsQuery, UpcomingReservationsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<UpcomingReservationsQuery, UpcomingReservationsQueryVariables>(
        UpcomingReservationsDocument,
        options
    );
}
export function useUpcomingReservationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<UpcomingReservationsQuery, UpcomingReservationsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<UpcomingReservationsQuery, UpcomingReservationsQueryVariables>(
        UpcomingReservationsDocument,
        options
    );
}
export type UpcomingReservationsQueryHookResult = ReturnType<typeof useUpcomingReservationsQuery>;
export type UpcomingReservationsLazyQueryHookResult = ReturnType<typeof useUpcomingReservationsLazyQuery>;
export type UpcomingReservationsQueryResult = Apollo.QueryResult<
    UpcomingReservationsQuery,
    UpcomingReservationsQueryVariables
>;
export const RentalUnitsBySlugDocument = gql`
    query RentalUnitsBySlug($slugs: [String!]!) {
        rentalUnits(slugs: $slugs) {
            ...RentalUnitsBySlug
        }
    }
    ${RentalUnitsBySlugFragmentDoc}
`;

/**
 * __useRentalUnitsBySlugQuery__
 *
 * To run a query within a React component, call `useRentalUnitsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalUnitsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalUnitsBySlugQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useRentalUnitsBySlugQuery(
    baseOptions: Apollo.QueryHookOptions<RentalUnitsBySlugQuery, RentalUnitsBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<RentalUnitsBySlugQuery, RentalUnitsBySlugQueryVariables>(RentalUnitsBySlugDocument, options);
}
export function useRentalUnitsBySlugLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<RentalUnitsBySlugQuery, RentalUnitsBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<RentalUnitsBySlugQuery, RentalUnitsBySlugQueryVariables>(
        RentalUnitsBySlugDocument,
        options
    );
}
export type RentalUnitsBySlugQueryHookResult = ReturnType<typeof useRentalUnitsBySlugQuery>;
export type RentalUnitsBySlugLazyQueryHookResult = ReturnType<typeof useRentalUnitsBySlugLazyQuery>;
export type RentalUnitsBySlugQueryResult = Apollo.QueryResult<RentalUnitsBySlugQuery, RentalUnitsBySlugQueryVariables>;
export const CompaniesBySlugDocument = gql`
    query CompaniesBySlug($slugs: [String!]!) {
        companiesBySlug(slugs: $slugs) {
            id
            name
            slug
            description
            webpListImage: listImage {
                transform(config: TILE, format: WEBP) {
                    ...ListImage
                }
            }
            listImage {
                transform(config: TILE, format: JPEG) {
                    ...ListImage
                }
            }
        }
    }
    ${ListImageFragmentDoc}
`;

/**
 * __useCompaniesBySlugQuery__
 *
 * To run a query within a React component, call `useCompaniesBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesBySlugQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useCompaniesBySlugQuery(
    baseOptions: Apollo.QueryHookOptions<CompaniesBySlugQuery, CompaniesBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<CompaniesBySlugQuery, CompaniesBySlugQueryVariables>(CompaniesBySlugDocument, options);
}
export function useCompaniesBySlugLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CompaniesBySlugQuery, CompaniesBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<CompaniesBySlugQuery, CompaniesBySlugQueryVariables>(CompaniesBySlugDocument, options);
}
export type CompaniesBySlugQueryHookResult = ReturnType<typeof useCompaniesBySlugQuery>;
export type CompaniesBySlugLazyQueryHookResult = ReturnType<typeof useCompaniesBySlugLazyQuery>;
export type CompaniesBySlugQueryResult = Apollo.QueryResult<CompaniesBySlugQuery, CompaniesBySlugQueryVariables>;
export const ActivitiesBySlugDocument = gql`
    query ActivitiesBySlug($slugs: [String!]!) {
        activitiesBySlug(slugs: $slugs) {
            id
            name
            slug
            description
            webpListImage: listImage {
                transform(config: TILE, format: WEBP) {
                    ...ListImage
                }
            }
            listImage {
                transform(config: TILE, format: JPEG) {
                    ...ListImage
                }
            }
        }
    }
    ${ListImageFragmentDoc}
`;

/**
 * __useActivitiesBySlugQuery__
 *
 * To run a query within a React component, call `useActivitiesBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesBySlugQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useActivitiesBySlugQuery(
    baseOptions: Apollo.QueryHookOptions<ActivitiesBySlugQuery, ActivitiesBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ActivitiesBySlugQuery, ActivitiesBySlugQueryVariables>(ActivitiesBySlugDocument, options);
}
export function useActivitiesBySlugLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesBySlugQuery, ActivitiesBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ActivitiesBySlugQuery, ActivitiesBySlugQueryVariables>(
        ActivitiesBySlugDocument,
        options
    );
}
export type ActivitiesBySlugQueryHookResult = ReturnType<typeof useActivitiesBySlugQuery>;
export type ActivitiesBySlugLazyQueryHookResult = ReturnType<typeof useActivitiesBySlugLazyQuery>;
export type ActivitiesBySlugQueryResult = Apollo.QueryResult<ActivitiesBySlugQuery, ActivitiesBySlugQueryVariables>;
export const AccommodationsBySlugDocument = gql`
    query AccommodationsBySlug($slugs: [String!]!) {
        accommodationsBySlug(slugs: $slugs) {
            ...AccommodationsBySlug
        }
    }
    ${AccommodationsBySlugFragmentDoc}
`;

/**
 * __useAccommodationsBySlugQuery__
 *
 * To run a query within a React component, call `useAccommodationsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsBySlugQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useAccommodationsBySlugQuery(
    baseOptions: Apollo.QueryHookOptions<AccommodationsBySlugQuery, AccommodationsBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<AccommodationsBySlugQuery, AccommodationsBySlugQueryVariables>(
        AccommodationsBySlugDocument,
        options
    );
}
export function useAccommodationsBySlugLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AccommodationsBySlugQuery, AccommodationsBySlugQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<AccommodationsBySlugQuery, AccommodationsBySlugQueryVariables>(
        AccommodationsBySlugDocument,
        options
    );
}
export type AccommodationsBySlugQueryHookResult = ReturnType<typeof useAccommodationsBySlugQuery>;
export type AccommodationsBySlugLazyQueryHookResult = ReturnType<typeof useAccommodationsBySlugLazyQuery>;
export type AccommodationsBySlugQueryResult = Apollo.QueryResult<
    AccommodationsBySlugQuery,
    AccommodationsBySlugQueryVariables
>;
export const ActivitySearchDocument = gql`
    query ActivitySearch(
        $params: ActivitySearchParamsInput!
        $limit: Int
        $offset: Int
        $startDate: String!
        $endDate: String!
        $order: ActivitySearchOrderEnum!
    ) {
        activities(params: $params, limit: $limit, offset: $offset, order: $order) {
            ... on ActivitySearchResult {
                totalHits
                hits {
                    ...ActivityHit
                }
                placeCounts {
                    value
                    hits
                }
                themeCounts {
                    value
                    hits
                }
                targetAudienceCount {
                    value
                    hits
                }
            }
        }
    }
    ${ActivityHitFragmentDoc}
`;

/**
 * __useActivitySearchQuery__
 *
 * To run a query within a React component, call `useActivitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySearchQuery({
 *   variables: {
 *      params: // value for 'params'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useActivitySearchQuery(
    baseOptions: Apollo.QueryHookOptions<ActivitySearchQuery, ActivitySearchQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ActivitySearchQuery, ActivitySearchQueryVariables>(ActivitySearchDocument, options);
}
export function useActivitySearchLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ActivitySearchQuery, ActivitySearchQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ActivitySearchQuery, ActivitySearchQueryVariables>(ActivitySearchDocument, options);
}
export type ActivitySearchQueryHookResult = ReturnType<typeof useActivitySearchQuery>;
export type ActivitySearchLazyQueryHookResult = ReturnType<typeof useActivitySearchLazyQuery>;
export type ActivitySearchQueryResult = Apollo.QueryResult<ActivitySearchQuery, ActivitySearchQueryVariables>;
export const ArticleDocument = gql`
    query Article($slug: String, $lang: String, $notSlug: String) {
        entry(section: ["articles"], slug: [$slug]) {
            ...Article
        }
        related: entries(slug: [$notSlug], section: ["articles"], limit: 3, orderBy: "postDate DESC", site: [$lang]) {
            ...Card
        }
    }
    ${ArticleFragmentDoc}
    ${CardFragmentDoc}
`;

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      lang: // value for 'lang'
 *      notSlug: // value for 'notSlug'
 *   },
 * });
 */
export function useArticleQuery(baseOptions?: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
}
export function useArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
}
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = Apollo.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const ArticlePathsDocument = gql`
    query ArticlePaths {
        entries(site: ["*"], section: ["articles"]) {
            __typename
            slug
            language
        }
    }
`;

/**
 * __useArticlePathsQuery__
 *
 * To run a query within a React component, call `useArticlePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlePathsQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticlePathsQuery(
    baseOptions?: Apollo.QueryHookOptions<ArticlePathsQuery, ArticlePathsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ArticlePathsQuery, ArticlePathsQueryVariables>(ArticlePathsDocument, options);
}
export function useArticlePathsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ArticlePathsQuery, ArticlePathsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ArticlePathsQuery, ArticlePathsQueryVariables>(ArticlePathsDocument, options);
}
export type ArticlePathsQueryHookResult = ReturnType<typeof useArticlePathsQuery>;
export type ArticlePathsLazyQueryHookResult = ReturnType<typeof useArticlePathsLazyQuery>;
export type ArticlePathsQueryResult = Apollo.QueryResult<ArticlePathsQuery, ArticlePathsQueryVariables>;
export const HomeDocument = gql`
    query Home($lang: String) {
        entry(uri: ["__home__"], site: [$lang]) {
            ...Home
        }
    }
    ${HomeFragmentDoc}
`;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useHomeQuery(baseOptions?: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
}
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
}
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
export const NewsDocument = gql`
    query News($lang: String, $offset: Int, $limit: Int) {
        articleCount: entryCount(site: [$lang], section: "articles")
        articles: entries(site: [$lang], section: "articles", offset: $offset, limit: $limit) {
            ...Card
        }
        entry(section: ["news"], site: [$lang]) {
            ...News
        }
    }
    ${CardFragmentDoc}
    ${NewsFragmentDoc}
`;

/**
 * __useNewsQuery__
 *
 * To run a query within a React component, call `useNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNewsQuery(baseOptions?: Apollo.QueryHookOptions<NewsQuery, NewsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
}
export function useNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsQuery, NewsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
}
export type NewsQueryHookResult = ReturnType<typeof useNewsQuery>;
export type NewsLazyQueryHookResult = ReturnType<typeof useNewsLazyQuery>;
export type NewsQueryResult = Apollo.QueryResult<NewsQuery, NewsQueryVariables>;
export const PageDocument = gql`
    query Page($uri: String, $lang: String) {
        entry(uri: [$uri], site: [$lang]) {
            ...Page
        }
    }
    ${PageFragmentDoc}
`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      uri: // value for 'uri'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function usePageQuery(baseOptions?: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
}
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
}
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const PagePathsDocument = gql`
    query PagePaths {
        entries(site: ["*"], type: ["page"]) {
            __typename
            uri
            slug
            language
        }
    }
`;

/**
 * __usePagePathsQuery__
 *
 * To run a query within a React component, call `usePagePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagePathsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagePathsQuery(baseOptions?: Apollo.QueryHookOptions<PagePathsQuery, PagePathsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<PagePathsQuery, PagePathsQueryVariables>(PagePathsDocument, options);
}
export function usePagePathsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PagePathsQuery, PagePathsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<PagePathsQuery, PagePathsQueryVariables>(PagePathsDocument, options);
}
export type PagePathsQueryHookResult = ReturnType<typeof usePagePathsQuery>;
export type PagePathsLazyQueryHookResult = ReturnType<typeof usePagePathsLazyQuery>;
export type PagePathsQueryResult = Apollo.QueryResult<PagePathsQuery, PagePathsQueryVariables>;
export const SearchPageDocument = gql`
    query SearchPage($lang: String!, $q: String!, $types: [String!]) {
        globalSearch(language: $lang, query: $q, limit: 50, type: $types) {
            totalHits
            typeCounts {
                count
                label
            }
            hits {
                ...SearchHit
            }
        }
    }
    ${SearchHitFragmentDoc}
`;

/**
 * __useSearchPageQuery__
 *
 * To run a query within a React component, call `useSearchPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *      q: // value for 'q'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useSearchPageQuery(baseOptions: Apollo.QueryHookOptions<SearchPageQuery, SearchPageQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SearchPageQuery, SearchPageQueryVariables>(SearchPageDocument, options);
}
export function useSearchPageLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SearchPageQuery, SearchPageQueryVariables>(SearchPageDocument, options);
}
export type SearchPageQueryHookResult = ReturnType<typeof useSearchPageQuery>;
export type SearchPageLazyQueryHookResult = ReturnType<typeof useSearchPageLazyQuery>;
export type SearchPageQueryResult = Apollo.QueryResult<SearchPageQuery, SearchPageQueryVariables>;
export const SearchPageAllAvailableFiltersDocument = gql`
    query SearchPageAllAvailableFilters($lang: String!, $q: String!) {
        globalSearch(language: $lang, query: $q, limit: 50) {
            totalHits
            typeCounts {
                count
                label
            }
        }
    }
`;

/**
 * __useSearchPageAllAvailableFiltersQuery__
 *
 * To run a query within a React component, call `useSearchPageAllAvailableFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageAllAvailableFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageAllAvailableFiltersQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSearchPageAllAvailableFiltersQuery(
    baseOptions: Apollo.QueryHookOptions<
        SearchPageAllAvailableFiltersQuery,
        SearchPageAllAvailableFiltersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SearchPageAllAvailableFiltersQuery, SearchPageAllAvailableFiltersQueryVariables>(
        SearchPageAllAvailableFiltersDocument,
        options
    );
}
export function useSearchPageAllAvailableFiltersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        SearchPageAllAvailableFiltersQuery,
        SearchPageAllAvailableFiltersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SearchPageAllAvailableFiltersQuery, SearchPageAllAvailableFiltersQueryVariables>(
        SearchPageAllAvailableFiltersDocument,
        options
    );
}
export type SearchPageAllAvailableFiltersQueryHookResult = ReturnType<typeof useSearchPageAllAvailableFiltersQuery>;
export type SearchPageAllAvailableFiltersLazyQueryHookResult = ReturnType<
    typeof useSearchPageAllAvailableFiltersLazyQuery
>;
export type SearchPageAllAvailableFiltersQueryResult = Apollo.QueryResult<
    SearchPageAllAvailableFiltersQuery,
    SearchPageAllAvailableFiltersQueryVariables
>;
export const SearchDocument = gql`
    query Search($lang: String) {
        entry(section: ["search"], site: [$lang]) {
            ...Search
        }
    }
    ${SearchFragmentDoc}
`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useSearchQuery(baseOptions?: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const AccoFeedDocument = gql`
    query AccoFeed($amount: Int, $offset: Int) {
        unitSearch(params: {}, limit: $amount, offset: $offset) {
            hits {
                rentalUnit {
                    id
                    name
                    slug
                    images {
                        transform(config: TILE, format: JPEG) {
                            src
                        }
                    }
                    tagline
                    descriptionLayout
                    type
                    accommodation {
                        place
                    }
                    maxOccupancy
                    livingArea
                    outdoorArea
                }
                trips {
                    price
                }
            }
            totalHits
        }
    }
`;

/**
 * __useAccoFeedQuery__
 *
 * To run a query within a React component, call `useAccoFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccoFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccoFeedQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAccoFeedQuery(baseOptions?: Apollo.QueryHookOptions<AccoFeedQuery, AccoFeedQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<AccoFeedQuery, AccoFeedQueryVariables>(AccoFeedDocument, options);
}
export function useAccoFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccoFeedQuery, AccoFeedQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<AccoFeedQuery, AccoFeedQueryVariables>(AccoFeedDocument, options);
}
export type AccoFeedQueryHookResult = ReturnType<typeof useAccoFeedQuery>;
export type AccoFeedLazyQueryHookResult = ReturnType<typeof useAccoFeedLazyQuery>;
export type AccoFeedQueryResult = Apollo.QueryResult<AccoFeedQuery, AccoFeedQueryVariables>;
export const SitemapDocument = gql`
    query Sitemap($locale: String, $size: Int) {
        entries(site: [$locale], uri: "!= ''", settingsNoIndex: false) {
            url
            dateUpdated
            ... on page_Entry {
                heroImage {
                    url
                    title
                }
            }
            ... on news_Entry {
                heroImage {
                    url
                    title
                }
            }
        }
        travelbaseObjectsSitemap(language: $locale, size: $size) {
            url
            image {
                url
                title
            }
        }
    }
`;

/**
 * __useSitemapQuery__
 *
 * To run a query within a React component, call `useSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSitemapQuery(baseOptions?: Apollo.QueryHookOptions<SitemapQuery, SitemapQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SitemapQuery, SitemapQueryVariables>(SitemapDocument, options);
}
export function useSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapQuery, SitemapQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SitemapQuery, SitemapQueryVariables>(SitemapDocument, options);
}
export type SitemapQueryHookResult = ReturnType<typeof useSitemapQuery>;
export type SitemapLazyQueryHookResult = ReturnType<typeof useSitemapLazyQuery>;
export type SitemapQueryResult = Apollo.QueryResult<SitemapQuery, SitemapQueryVariables>;
export const SqzlyFeedDocument = gql`
    query SqzlyFeed($amount: Int, $offset: Int) {
        unitSearch(params: {}, limit: $amount, offset: $offset) {
            hits {
                rentalUnit {
                    code
                    name
                    listImage {
                        transform(format: JPEG, config: TILE) {
                            src
                        }
                    }
                    slug
                    code
                    accommodation {
                        name
                        id
                    }
                    type
                }
                trips {
                    price
                }
            }
            totalHits
        }
    }
`;

/**
 * __useSqzlyFeedQuery__
 *
 * To run a query within a React component, call `useSqzlyFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSqzlyFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSqzlyFeedQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSqzlyFeedQuery(baseOptions?: Apollo.QueryHookOptions<SqzlyFeedQuery, SqzlyFeedQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SqzlyFeedQuery, SqzlyFeedQueryVariables>(SqzlyFeedDocument, options);
}
export function useSqzlyFeedLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SqzlyFeedQuery, SqzlyFeedQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SqzlyFeedQuery, SqzlyFeedQueryVariables>(SqzlyFeedDocument, options);
}
export type SqzlyFeedQueryHookResult = ReturnType<typeof useSqzlyFeedQuery>;
export type SqzlyFeedLazyQueryHookResult = ReturnType<typeof useSqzlyFeedLazyQuery>;
export type SqzlyFeedQueryResult = Apollo.QueryResult<SqzlyFeedQuery, SqzlyFeedQueryVariables>;
export const AgendaDocument = gql`
    query Agenda($lang: String) {
        entry(section: ["excursions"], site: [$lang]) {
            ...Agenda
        }
    }
    ${AgendaFragmentDoc}
`;

/**
 * __useAgendaQuery__
 *
 * To run a query within a React component, call `useAgendaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useAgendaQuery(baseOptions?: Apollo.QueryHookOptions<AgendaQuery, AgendaQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<AgendaQuery, AgendaQueryVariables>(AgendaDocument, options);
}
export function useAgendaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgendaQuery, AgendaQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<AgendaQuery, AgendaQueryVariables>(AgendaDocument, options);
}
export type AgendaQueryHookResult = ReturnType<typeof useAgendaQuery>;
export type AgendaLazyQueryHookResult = ReturnType<typeof useAgendaLazyQuery>;
export type AgendaQueryResult = Apollo.QueryResult<AgendaQuery, AgendaQueryVariables>;
export const CompanyDocument = gql`
    query Company($lang: String) {
        entry(section: ["companies"], site: [$lang]) {
            ...Companies
        }
    }
    ${CompaniesFragmentDoc}
`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions?: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
}
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
}
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const SightsDocument = gql`
    query Sights($lang: String) {
        entry(section: ["sights"], site: [$lang]) {
            ...Sights
        }
    }
    ${SightsFragmentDoc}
`;

/**
 * __useSightsQuery__
 *
 * To run a query within a React component, call `useSightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSightsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useSightsQuery(baseOptions?: Apollo.QueryHookOptions<SightsQuery, SightsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SightsQuery, SightsQueryVariables>(SightsDocument, options);
}
export function useSightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SightsQuery, SightsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SightsQuery, SightsQueryVariables>(SightsDocument, options);
}
export type SightsQueryHookResult = ReturnType<typeof useSightsQuery>;
export type SightsLazyQueryHookResult = ReturnType<typeof useSightsLazyQuery>;
export type SightsQueryResult = Apollo.QueryResult<SightsQuery, SightsQueryVariables>;
export const EventsDocument = gql`
    query Events($lang: String) {
        entry(section: ["events"], site: [$lang]) {
            ...Events
        }
    }
    ${EventsFragmentDoc}
`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useEventsQuery(baseOptions?: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
}
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
}
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export const GlobalDocument = gql`
    query Global($lang: String) {
        ...GlobalQuery
    }
    ${GlobalQueryFragmentDoc}
`;

/**
 * __useGlobalQuery__
 *
 * To run a query within a React component, call `useGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGlobalQuery(baseOptions?: Apollo.QueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
}
export function useGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
}
export type GlobalQueryHookResult = ReturnType<typeof useGlobalQuery>;
export type GlobalLazyQueryHookResult = ReturnType<typeof useGlobalLazyQuery>;
export type GlobalQueryResult = Apollo.QueryResult<GlobalQuery, GlobalQueryVariables>;
